export default {
    websiteTitle: "充电运营服务平台",
    operatorId: "运营商代码",
    oprName: "运营商名称",
    tips: "提示",
    isUpdate: "确定要更新吗",
    isDelete: "是否确认删除",
    isOffline: "确定要强制下线吗",
    deleteSuccess: "删除成功",
    updateSuccess: "修改成功",
    addSuccess: "新增成功",
    all: "全部",
    operation: "操作",
    dl: "电量",
    eleFee: "电费",
    serverFee: "服务费",
    delayFee: "占桩费",
    totalAmount: "总金额",
    yuan: "元",
    kWh: "度",
    unitOrder: "单",
    ac: "交流",
    dc: "直流",
    confirm: "确认",
    noData: "暂无数据",
    allCity: "全部城市",
    chargingStation: "充电站",
    merchant: "商户",
    operator: "运营商",
    chargingPile: "充电桩",
    year: "年",
    month: "月",
    day: "日",
    yesterday: "昨日",
    today: "今日",
    thisMonth: "本月",
    thisYear: "本年",
    allday: "累计",
    timeType: "类型",
    regularText: "正常",
    irregular: "异常",
    agree: "同意",
    refuse: "拒绝",
    operationSucess: "操作成功",
    saveSucess: "保存成功",
    exportSuccess: "导入成功",
    isNullTime: "时间不可以为空",
    isStartAndEnd: "开始时间不能超过结束时间",
    allSelect: "全选",
    FormValidationError: "表单验证错误",
    multipleChoice: "表头设置",
    exportEdit: "导出编辑",
    edit: "编辑",
    loading: "加载中...",
    browse: "浏览",
    //单位
    unitText: {
        pen: "笔",
        yuan: "元",
        hours: "时",
        people: "人",
        seat: "座",
        wan: "万",
        Wyuan: "万元",
        WkWh: "万kWh",
        WkW: "万kW",
        year: "年",
        month: "月",
        day: "日",
        ton: "吨",
        second: "次",
        full: "满",
        reduce: "减",
        give: "送",
        zhang: "张",
        individual: "个",
        xHours: "小时",
        minute: "分钟",
        seconds: "秒",
        noDiscount: "无折扣",
        hold: "把",
        set: "台",
        total: "总",
        days: "天",
    },
    // form 里公用组件或者公用文字的
    formText: {
        startTime: "开始时间",
        endTime: "结束时间",
        startEndTime: "起止时间",
        export: "导出",
        exportLoading: "导出中...",
        exportNumber: "导出条数",
        exportPl: "导出条数不能少于等于0",
        exportError: "导出出错或者超时",
        allCity: "全部城市",
        selectGun: "充电枪",
        selectMch: "商户",
        selectSite: "充电站",
        selectPile: "充电桩",
        selectTime: "选择时间",
        selectTimePl: "请选择时间",
        selectOper: "运营商",
        downloadForm: "下载表格",
        intTips: "数值",
        beginTimeTips: "请选择开始时间",
        endTimeTips: "请选择结束时间",
        import: "导入",
        selectProvince: "请选择省",
        selectCity: "请选择市",
        selectArea: "请选择区",
        subSuccess: "操作成功",
        goBack: "返回",
        fileError: "请上传以下文件格式：",
        tipsMaxTime: "开始时间不能大于结束时间，请重新选择",
        fileSizeMax: "文件大小不能大于",
        imgUpload: "图片上传",
        numberError: "请输入正确的数量",
        exportOrderErrorMax: "请选择一年时间的跨度导出订单",
        select: "选择",
        upload: "上传文件",
        showAll: "显示全部",
        showSelect: "显示已选",
    },
    directCurrent: "直流",
    alternatingCurrent: "交流",
    gunStatus: "枪口状态",
    onLine: "在线",
    offLine: "离线",
    free: "空闲",
    connected: "插枪",
    charging: "充电",
    full: "充满",
    trouble: "故障",
    disabled: "禁用",
    booked: "预约",
    //===========================按钮===========================
    query: "查看",
    search: "查询",
    update: "修改",
    add: "新增",
    delete: "删除",
    balanceReminder: "余额提醒",
    siteOpen: "站点开放管理",
    details: "详情",
    recharge: "充值",
    refund: "退款",
    rapitalRecords: "资金记录",
    accountStatement: "对账单",
    pullSite: "拉取站点",
    apply: "申请",
    cancellation: "注销",
    supplement: "立即补推",
    batchDelete: "批量删除",
    cancel: "取消",
    toExamine: "审核",
    preservation: "保存",
    submit: "提交",
    adopt: "通过",
    determine: "确定",
    noAdopt: "不通过",
    enable: "启用",
    stop: "停用",
    grant: "发放",
    supplementOrder: "补单",
    // confirm: "确认",
    invalid: "作废",
    withdrawalOfReview: "撤回审核",
    regenerate: "重新生成",
    // cancel: "取消",
    preview: "预览",
    readyToPay: "准备付款",
    reject: "打回",
    paymentCompleted: "完成付款",
    annex: "附件",
    check: "审核",
    uploadCertificate: "上传凭证",
    close: "关闭",
    save: "保存",
    invoicing: "开票",
    forcedOffline: "强制下线",
    resetPassword: "重置密码",
    refresh: "刷新",
    jurisdiction: "权限分配",
    back: "返回",
    export: "导出",
    import: "导入",
    relevance: "关联",
    cancelRelevance: "取消关联",
    adjustIntegral: "积分调整",
    levelIntegral: "等级调整",
    member: "成员",
    userGroup: "用户组",
    operatingRecord: "操作记录",
    activate: "激活",
    pass: "通过",
    notPass: "不通过",
    outText: "登录过期，请重新登录",
    //===========================云产品===========================
    //短信服务
    msgServer: {
        startTime: "开始时间",
        endTime: "结束时间",
        phone: "手机号",
        search: "查询",
        msgRecharge: "短信条数充值",
        msgBuy: "短信购买",
        send: "已发送条数",
        msgSurplus: "短信剩余条数",
        msgStatus: "状态",
        msgSendTime: "发送时间",
        msgMsgType: "短信类型",
        msgSendContent: "发送内容",
        recharge: "短信充值",
    },
    //短信购买记录
    msgBuyRecord: {
        orderNumber: "订单号",
        auditStatus: "审核状态",
        startTime: "开始时间",
        endTime: "结束时间",
        purchaseQuantity: "购买数量(条)",
        paymentAmount: "付款金额(元)",
        orderStatus: "订单状态",
        payTime: "购买时间",
        operation: "操作",
        enclosure: "附件",
        totalNum: "累计购买条数",
        remainNum: "剩余条数",
        invoiceStatus: "开票状态",
        btnUploadContract: "上传合同",
        btnPay: "去支付",
        btnApplyInvoice: "申请发票",
        smsRechargeTitle: "短信充值",
        smsRechargeBtnUpload: "下载合同模板",
        smsRechargeBtnYes: "我已有合同",
        smsRechargeTips: "短信充值需要上传购买合同，请先下载合同模板，完善合同信息后，再进行短信充值操作；如已完善购买合同，请点击“我已有合同”继续购买。",
        paymentWay: "支付方式",
        paymentWay2: "微信支付",
        paymentWay3: "对公转账",
        paymentWayTips: "注意: 选择微信支付提交,支付订单生成后不可更改!",
        payWx: "使用微信扫码支付",
        payWxTips: "支付后，请自行关闭，如果短信未到账，",
        payWxTips2: "请联系管理员",
        payWxMoney: "支付金额：",
        payWxOrder: "已生成订单",
        orderNo: "订单号",
        payWxCopy: "复制",
        payWxMoneyInfo: "线下汇款信息",
        payMoney: "金额",
        bankAccountName: "开户名",
        bankDeposit: "开户行",
        bankAccountNo: "账号",
        remark: "备注",
        payWxOrderTips: "此项必填，订单号点击上方复制",
        success: "等待处理，完成订单",
        successTips: "汇款后，请及时上传转账凭证，我们将及时为您处理，如有任何疑问，请联系管理员",
        paymentNetFileUrl: "支付凭证",
        paymentNetFileUrlPl: "请上传支付凭证",
        paymentWayPl: "请选择支付方式",
        upload: "上传",
        auditNo: "审核不通过，原因：",
        uploadSuccess: "上传成功",
        uploadContract: "上传合同",
        contractNetFileUrl: "购买合同",
        contractNetFileUrlPl: "请上传购买合同",
        comboPkId: "购买条数",
        residue: "剩余条数",
        packageAmount: "套餐金额",
        totalPay: "总计应付",
        submitOrder: "提交订单",
        unit: "条",
        purchasedWay: "购买方式",
        contractStatus: "合同状态",
        paymentStatus: "支付状态",
        paymentVoucherStatus: "支付审核状态",
    },
    // 短信发票
    msgApplyInvoice: {
        hasDefault: "默认",
        setHasDefault: "设为默认",
        ent: "企业单位",
        entNo: "个人/非企业",
        info: "接收信息",
        sendEmail: "电子邮件",
        phoneNo: "手机号",
        addressee: "收件人",
        mailingAddress: "收件地址",
        sublimt: "提交申请",
        addresseePl: "请输入收件人",
        mailingAddressPl: "请输入收件地址",
        invoiceTitleInfo: "抬头信息",
        invoiceTitleType: "发票类型",
        invoiceTitle: "抬头名称",
        taxId: "税号",
        registerTelephone: "注册电话",
        registerAddress: "注册地址",
        hasDefaultSelect: "是否默认",
        invoiceAccount: "开票金额",
        applyStatus: "开票状态",
    },
    //短信购买记录详情
    msgBuyRecordDetails: {
        pkid: "订单单号",
        purchasedCount: "购买条数",
        paymentAmount: "支付金额",
        createTime: "购买时间",
        payTime: "支付时间",
        orderStatus: "订单状态",
        needContract: "是否需要合同",
        contractNetFileUrl: "购买合同",
        paymentNetFileUrl: "支付凭证",
        rechargeTime: "充值时间",
        beforeSmsCount: "充值前短信条数",
        afterSmsCount: "充值后短信条数",
        yes: "需要",
        no: "不需要",
        cardRder: "订单信息",
        cardInvoice: "发票信息",
        cardAudit: "审核记录",
    },
    //互联互通
    interflowList: {
        systemnName: "系统名称",
        internetDirection: "互通方向",
        internetStatus: "互通状态",
        internetStartTime: "互通开始时间",
        internetEndTime: "互通结束时间",
        internetType: "互通类型",
        accountBalance: "账户余额",
        status: "状态",
        operation: "操作",
        open: "已启用",
        close: "已禁用",
        pullSuccess: "拉取成功",
        netPublic: "互联互通公开类型",
        hasOpen: "开启状态",
        oprSum: "已开通互联互通运营商数",
        netSystemSum: "互联互通数",
        netSystemSum2: "互通方向数",
        netSystemSum3: "互联互通公开类型",
        netSystemSum4: "开启状态",
        netForwardSum: "正向",
        netReverseSum: "反向",
        netBidirectionalSum: "双向",
        netInsideSum: "内部",
        netExternalSum: "外部",
        netNoSum: "开启",
        netOffSum: "关闭",
        netEndSum: "即将结束",
    },
    //接口用户
    interfaceMember: {
        totalinterfaceMember: "接口会员总数(个)",
        totalsiteOpen: "站点开放总数(个)",
        totalRechargeAmount: "充值总金额(元)",
        totalChargeAmount: "充电总金额(元)",
        contacts: "联系人",
        contactNumber: "联系电话",
        interfaceName: "接口用户名称",
        siteNumber: "站点数量",
        accountNumber: "账户号",
        accountType: "用户类型",
        status: "状态",
        accountBalance: "账户余额(元)",
        unBind: "请先解绑站点",
        delConfirm: "是否确认注销",
        delSuccess: "注销成功",
        globalSearch: "联系人/联系方式",
        netStatus3: "已注销",
        netStatus2: "正常",
    },
    //结算订单补推
    orderSupplement: {
        government: "政府",
        personal: "个人",
        externalOrderNumber: "外部订单号",
        internetOperators: "互联运营商",
        chargingStation: "充电站",
        supplementaryResults: "补推结果",
        supplementaryTimePeriod: "最新补推时间段",
        internalOrderNumber: "内部订单号",
        chargingStationName: "充电站名称",
        startTime: "开始时间",
        endTime: "结束时间",
        chargingTime: "充电时长(分钟)",
        chargeAmount: "充电费用(元)",
        supplementaryTime: "最新补推时间",
        updateTime: "更新时间",
        startSupplementaryResults: "开始补推结果",
        endSupplementaryResults: "结束补推结果",
        settlementSupplementaryResults: "结算补推结果",
        chargeTime: "请选择充电时间",
        noOper: "暂无互联运营商",
        timeMaxError: "时间选择不能超过三个月，请重新选择",
        noTableSelect: "请选择要补推的数据",
        TableNoTypeSelect: "请选择同一个运营商的数据补推",
        pullSuccess: "推送成功的订单",
        pullFail: "推送失败的订单",
        pullNo: "未推送的订单",
        pleasePull: "请勾选补推的类型",
    },
    //第三方服务
    thirdPartyServices: {
        nameOfThirdPartyService: "第三方服务商名称",
        nameOfServiceProvider: "服务商名称",
        serviceProviderContent: "服务商内容",
        contacts: "联系人",
        contactNumber: "联系电话",
        startTime: "开始时间",
        endTime: "结束时间",
        globalSearch: "第三方服务名称/服务商名称",
    },
    //第三方服务订单
    thirdPlatformPushOrder: {
        orderNumber: "订单号",
        nameOfThirdPartyService: "第三方服务商名称",
        chargingStation: "充电站",
        pushResults: "推送结果",
        supplementaryTimePeriod: "最新补推时间段",
        chargingStationName: "充电站名称",
        pushResultsDes: "推送结果描述",
        pushTime: "推送时间",
        selectData: "请选择要补推的数据",
        loading: "请等待...",
        success: "提交成功，等待系统推送",
        results: "补推结果",
        failReason: "失败原因",
    },
    //===========================运营商===========================
    //运营商
    operInfo: {
        operatorInformation: "运营商信息",
        basicInformation: "基本信息",
        operator: "运营商",
        operatorAbbreviation: "运营商简称",
        address: "地址",
        companyDescription: "公司描述",
        contact: "联系人",
        mobile: "联系电话",
        email: "电子邮箱",
        registrationDate: "注册时间",
        expirationDate: "到期时间",
        mobileCustomization: "移动端定制",
        mobileCustomizationInfo: "设置移动端定制消息",
        systemMessage: "系统信息",
        systemMessageInfo: "用于云平台的logo、平台名称、网页备案显示等信息的配置",
        settlementConfiguration: "发票设置",
        settlementConfigurationInfo: "用于运营商与商户结算时的运营商信息管理，如付款公司、结算发票结算说明等",
        lastUpdateDate: "最后一次更新时间",
        passwordSetup: "操作密码",
        passwordSetupInfo: "用于系统关键性信息操作权限密码，入站点上线、下线、费率变更等，默认为绑定手机后6位",
        chargingServiceconFiguration: "充电服务配置",
        chargeServiceInfo: "用于配置用户充电服务的选项，如APP的开启和配置等",
        chargingServiceconFigurationInfo: "用于配置用户充电服务的选项，如微信公众号、小程序的开启和配置，支付宝小程序的开启和配置等",
        balanceReminder: "余额提醒",
        balanceReminderInfo: "用于配置个人会员账户的余额提醒功能",
        city: "请选择城市",
        serviceTel: "客服电话",
        verificationCode: "验证码",
        updateMobileSoc: "修改移动端定制",
        socStop: "SOC定停充电",
        socRadio: "SOC定停功能开关，若设置关闭，移动端隐藏SOC设置功能，开启后恢复SOC功能。",
        socDefault: "SOC默认值",
        socMinValue: "SOC下限值:",
        socDefaultInfo: "配置移动端SOC的默认设定值，用户在未设定SOC值情况下使用此设定值充电，默认设定值98%。为防止意外过充谨慎设置默认值。",
        scoTop: "默认值已达到100%，实际充电超过98%后只允许充电5分钟，请谨慎设置",
        socFooler: "用于配置移动端SOC设定的下限值，介于10%-80%之间，默认下限值80%",
        exceptionType: "异常处理类型",
        exceptionPile: "桩报告",
        exceptionPlatForm: "平台报告",
        delayRadio: "占桩费",
        socTopDefalut: "请输入默认值",
        socMax: "默认值不能多于100",
        socIsnull: "默认值必须是大于0的整数",
        socMin: "请输入下限值",
        socIsMax: "下限值不能多于100",
        socIsNumber: "下限值必须是大于0的整数",
        limitStartAmount: "账户最低启动金额",
        frozenStartAmount: "启动充电最高冻结金额",
        isRefund: "开启退款",
        isRefundPl: "请选择是否开启退款",
        prechargeRetired: "即充即退",
        isPrechargeRetired: "请选择是否即充即退",
        prechargeRetiredTips: "使用充值的金额进行充电，结束充电后扣除充电费用，剩余金额将原路返回至客户微信/支付宝或银行卡。",
        refundText: "退款说明",
        refundTextPl: "请输入退款说明退款说明",
        chargingMethod: "充电方式",
        chargingMethodPl: "请选择充电方式",
        hasOpenBalanceConsumption: "余额充电",
        hasOpenBalanceConsumptionTips: "使用客户充电账户余额进行充电，结束充电后扣除充电费用，剩余金额将返回到客户充电账户余额。",
        hasOpenCredit: "先充后付",
        hasOpenCreditTips: "开启先充后付需要对微信公众号和微信小程序的支付分分别进行配置，配置完成后先充后付才会生效，否则用户将无法在对应平台使用该功能。",
        hasOpenCreditGo: "去配置",
        openText: "开启",
        //系统设置
        weChatLogo: "微信公众号logo",
        weChatMiniLogo: "微信小程序logo",
        platFormLogo: "平台logo",
        platFormName: "平台名称",
        logoPropaganda: "登录页宣传语",
        webFilingInfo: "网页备案信息",
        //结算配置信息
        invoiceInfo: "开票信息",
        invoiceType: "发票类型",
        electronicInvoice: "电子发票",
        paperInvoice: "纸质发票",
        enterpriseName: "公司名称",
        dutyParagraph: "税号",
        tariffRate: "电费税率",
        serviceRate: "服务费税率",
        bankOfDeposit: "开户银行",
        accountNumber: "账号",
        invoiceUnit: "发票单位",
        contacts: "联系人",
        contactNumber: "联系电话",
        payee: "收款人",
        drawer: "开票人",
        reviewer: "复核人",
        receivingAddress: "收件地址",
        otherInfo: "其他信息",
        remark: "备注",
        withdrawalInstructions: "提现说明",
        mattersNeedingAttention: "注意事项",
        explainOne: "1、不同的发票类型将影响对方开票的税率，因此发票类型谨慎选择。",
        explainTwo: "2、公司名称会影响提现单的付款方和发票的公司表头，请谨慎修改。",
        explainThree: "3、其他如税号、开户银行、帐号等信息为开票必填项。",
        explainForm: "4、联系人、联系电话、收件地址可不填，默认运营商创建时的联系信息",
        explainFive: "5、可根据实际请款填写备注信息和提现说明，修改后将更新提现单处对应的信息",
        invoiceStatus: "发票启用状态",
        invoiceAudit: "手动审核状态",
        invoiceTypeName1: "电子发票",
        invoiceTypeName2: "纸质发票",
        openInvoiceYes: "已启用",
        openInvoiceNo: "未启用",
        set: "设置",
        //密码修改
        newpassword: "新密码",
        repeatpassword: "重复新密码",
        //充电服务配置
        //微信公众号
        basicConfiguration: "基本配置",
        serviceEnable: "服务启用",
        wechatQrcode: "公众号二维码",
        wechatName: "公众号名称",
        originalId: "原始ID",
        appId: "appId",
        secret: "secret",
        weChatTemplate: "通知模版",
        chargingStartNotification: "充电开始通知",
        chargingEndNotification: "充电结束通知",
        chargingSettlementNotification: "充电结算通知",
        chargingFaultNotification: "故障通知",
        amountNotification: "余额不足提醒",
        wechatPayInfo: "微信支付信息",
        merchantName: "商户名称",
        merchantId: "商户ID",
        merchantKey: "商户密钥",
        merchantCert: "申请退款证书",
        //支付宝小程序
        miniProgramLogo: "小程序logo",
        miniProgramQrcode: "小程序二维码",
        miniProgramName: "小程序名称",
        privateKey: "应用私钥",
        publicKey: "支付宝公钥",
        //余额提醒
        individualMember: "个人会员",
        electricCard: "非实名电卡会员",
        notes: "注：开启此功能后，会员启动充电后余额低于指定金额时将发送短信或公众号通知对方，为防止频繁通知影响用户，建议提醒金额谨慎设置。",
        openFunction: "功能开放",
        open: "开启",
        close: "关闭",
        amountMin: "用户充电中，余额低于",
        amountInfo: "元后，发送通知。",
        notificationMethod: "通知方式",
        weChatNotification: "公众号通知",
        smsNotification: "短信通知",
        weChatTemplateDetection: "公众号模板检测",
        isTemplate: "已配置",
        notTemplate: "未配置",
        smstemplateDetecion: "短信模板检测",
        maxRiskAmountPerOrder: "最大风险金",
        maxRiskAmountPerOrderTips: "提示：风险金为单个用户/单日/单笔订单最大支付限额。推荐设置金额200元，若站点有大型服务车辆充电，建议将金额调整至300-500元。",
        blacklistUserTelphone: "黑名单联系电话",
        blacklistUserNotifyText: "黑名单提醒文本",
        blacklistUserNotifyTextPl: "请输入黑名单提醒文本",
        oprSystemName: "运营商系统名称",
        oprSystemLogoFilePath: "系统LOGO",
        addressPl: "请输入地址",
        addressPlCity: "请选择城市",
        rolePkIdPl: "请选择角色",
        oprSystemLogoFilePathPl: "请上传运营商系统LOGO",
        hasOpenAutoRefund: "退款自动审核",
        hasOpenAutoRefundPl: "请选择是否退款自动审核",
        contactServiceProvider: "联系服务商",
        contactServiceProviderPl: "用于查看服务商联系方式或向服务商进行问题反馈",
        problemFeedback: "问题反馈",
        problemType: "问题类型",
        operHasRead: "服务商是否已读",
        operHasReply: "服务商是否回复",
        addFeedback: "新增反馈",
        feedbackTime: "反馈时间",
        feedbackPerson: "反馈人",
        problemContent: "问题内容",
        replyTime: "回复时间",
        addProblem: "新增问题",
        checkReply: "查看回复",
        operReply: "服务商回复",
        replyContent: "回复内容",
        deleteFeedback: "是否删除该反馈问题？",
        configInfo: "配置信息",
        chargingErrorRemind: "充电异常提醒",
        chargingErrorRemindPl: "单笔订单长时间充电量为0kWh时，短信提醒",
        singleOrderChargeTime: "单笔订单连续充电时长",
        singleOrderChargeTimePl: "请输入单笔订单连续充电时长",
        changeProblem: "修改问题",
        chooseProblemTypePl: "请选择问题类型",
        problemContentPl: "请输入问题内容",
        addFeedbackSuccess: "新增反馈成功",
        inputEnterTip: "所设置充电时长需为整数",
        inputEnterTip2: "所设置充电时长需为正数",
        inputEnterTip3: "所设置充电时长最大为三位数",
    },
    //商户管理
    merchantManagement: {
        merchantId: "商户编号",
        merchantName: "商户名称",
        merchantIdOrName: "商户编号/名称",
        merchantAbbreviation: "商户简称",
        chargingStationNum: "充电站数",
        contacts: "联系人",
        email: "邮箱",
        contactNumber: "联系电话",
        creationTime: "创建时间",
        mchStatus: "商户状态",
        cooperationTime: "合作截止日期",
        closeMerchant: "关闭商户",
        totalQuantity: "商户总数",
        enableQuantity: "已启用商户",
        disableQuantity: "已关闭商户",
        days30Left: "30天到期",
        days60Left: "60天到期",
        days90Left: "90天到期",
        closeError: "请将所属充电站关闭下线",
        invoiceStaCount: "开票站点数",
        log: "操作日志",
    },
    // 商户日志
    mchLog: {
        globalSearch: "关键字",
        sharingRules: "分成规则",
        withdrawalRules: "提现规则",
        objectType: "操作对象",
        operationContent: "操作内容",
        operationType: "操作类型",
        operationUserName: "操作人",
        operationIp: "操作人IP",
    },
    //设备厂商信息
    producer: {
        manufacturerName: "厂商名称",
        BusinessLicenseNo: "营业执照编号",
        brandName: "品牌名称",
        equipmentManufacturer: "设备生厂商",
        equipmentManufacturerType: "设备厂商类型",
        equipmentManufacturerLicenseNo: "设备生厂商组织机构代码",
        contacts: "联系人",
        contactNumber: "联系方式",
        corporationLegalPerson: "公司法人",
        corporateIdentityCard: "法人身份证",
        equipmentForm: "系统",
        equipmentForm2: "本运营商",
    },
    //设备型号
    equipmentModel: {
        equipmentType: "设备类型",
        equipmentmodelManufacturerName: "设备型号/生厂商",
        equipmentModel: "设备型号",
        standardInformation: "标配信息",
        matchingInformation: "选配信息",
        manufacturer: "生厂商",
        updateTime: "更新时间",
        system: "系统",
    },
    //===========================系统管理===========================
    //权限配置
    accessConfiguration: {
        roleName: "角色名称",
        remark: "备注",
        createUserId: "创建人",
        createTime: "创建时间",
        updateTime: "更新时间",
        menuModule: "菜单模块",
        menuGlance: "菜单一览",
        roleType: "角色类型",
        roleNameMsg: "请输入角色名称",
        roleNameErrorMsg: "角色名称不能多于20个字符",
        roleTypeMsg: "请选择角色类型",
        operate: "操作日志",
        operationUserName: "最后一次操作人",
        operationTime: "最后一次操作时间",
        operationIp: "最后一次操作IP",
    },
    //用户管理
    userManage: {
        userName: "用户名",
        role: "所属角色",
        effectiveTime: "有效时间",
        status: "状态",
        password: "密码",
        confirmPassword: "确认密码",
        name: "姓名",
        addUser: "新增用户",
        updateUser: "修改用户",
        detailsUser: "用户详情",
        userNameMsg: "登录账号不能为空",
        roleMsg: "所属角色不能为空",
        passwordMsg: "密码不能为空",
        passwordLenMsg: "长度6~18",
        passwordValMsg: "密码不能包含空格、制表符、换行符",
        confirmPasswordMsg: "确认密码不能为空",
        confirmPasswordOldMsg: "确认密码与密码不一致",
        effectiveTimeStartMsg: "有效时间的开始时间必须填写",
        effectiveTimeStartValMsg: "开始时间不能大于结束时间",
        effectiveTimeEndMsg: "有效时间的结束时间必须填写",
        effectiveTimeEndValMsg: "结束时间不能小于开始时间",
        assignedSite: "已分配站点",
        unassignedSite: "未分配站点",
        moveLeft: "左移",
        moveRight: "右移",
        chargeStationName: "站点名称",
        createUserName: "创建人",
        operationUserName: "操作人",
        operationTime: "操作时间",
        operationIp: "操作IP",
        operationTypeName: "操作类型",
        content: "操作内容",
    },
    //系统日志
    logManage: {
        operationLog: "用户操作日志",
        logIn: "登录日志",
        platformOperation: "平台操作日志",
        queryInfo: "用户名/IP",
        userName: "用户名",
        customerIp: "客户IP",
        moduleName: "模块名称",
        operationMethod: "操作方法",
        operationTime: "操作时间",
        operationDetails: "操作详情",
        logInTime: "登录时间",
        version: "版本",
        operationModule: "操作模块",
        platformUserName: "用户名",
        platformCustomerIp: "客户IP",
        platformModuleName: "模块名称",
    },
    //更新日志
    renewLog: {},
    //在线用户
    onlineUser: {
        query: "请输入关键字(用户名/登录名/IP地址)",
        roleName: "角色名称",
        userName: "用户名",
        IP: "IP地址",
        logInTime: "登录时间",
        token: "Token",
    },
    //===========================会员管理===========================
    //===========================主页===========================
    home: {
        assetTitle: "资产信息",
        staCount: "站点总数",
        pileCount: "充电桩总数",
        gunCount: "充电枪总数",
        mapStaStutas: "充电站状态",
        mapAc: "交流桩",
        mapDc: "直流桩",
        map: "地图",
        mapQuery: "查看",
        mapStaTel: "站点电话",
        gunStatus: "充电枪状态",
        assets: "资产",
        mchStatistics: "商户总数",
        staStatistics: "站点总数",
        pileStatistics: "电桩统计",
        gunStatistics: "电枪统计",
        powerStatistics: "总功率统计",
        rankingTitle: "站点",
        rankingTitle2: "排名",
        rankingTitleDl: "充电量",
        rankingTitleMoney: "金额",
        cardTitleMoney: "站点金额排名",
        cardTitleDl: "站点充电量排名",
        rankingNo: "暂无排行",
        total: "总数",
        totalPower: "总功率",
        dl: "充电量(度)",
        trans: "实收(元)",
        charge: "充电次数(次)",
        useRate: "使用率(％)",
        totalUser: "累计用户数(个)",
        avgChargeTimes: "平均充电次数",
        monthAvgUseRate: "本月站点使用率",
        totalRegister: "新增注册",
        totalCancellation: "注销",
        all: "累计",
        today: "今日",
        yesterday: "昨日",
        chargeEcharTitle: "充电及收入",
        chargeEcharTypeDay: "(近30天，不含今天)",
        chargeEcharTypeMonth: "(近12月)",
        chargeEcharTypeYear: "(近10年)",
        gunTotal: "枪总数",
        dataStatistics: "充电数据统计",
        dcPile: "直流充电桩",
        dcSplit: "分体式直流",
        acPile: "交流充电桩",
        totalTitle: "总览",
        detailsTitle: "详情",
    },
    // 主页地图
    homeMap: {
        search: "搜索",
        reset: "重置",
        area: "区域",
        power: "功率",
        quantity: "数量",
        tower: "台",
        merchant: "商户",
        deviceType: "设备类型",
        staSize: "充电站规模",
        netDirection: "互联互通",
        staStatus: "充电站运营状态",
        staActivity: "站点活动",
        normalSearch: "普通搜索",
        advancedSearch: "高级搜索",
        ac: "交流桩",
        dc: "直流桩",
        smallSize: "小规模",
        mediumSize: "中规模",
        largeSize: "大规模",
        yes: "是",
        no: "否",
        site: "站",
        pile: "桩",
        screenPl: "请输入充电站、运营商名称",
        screenResult: "为您找到相关结果约",
        moreSelect: "多选",
        more: "更多",
    },
    //===========================主页 - 站下桩列表 ===========================
    homePile: {
        pileNumber: "桩编号",
        pileName: "桩名称",
        power: "功率(kW)",
        loading: "加载中...",
        pileNo: "暂无电桩",
    },
    //===========================主页 - 站下桩列表 - 详情 ===========================
    homePileDetails: {
        number: "号",
        gun: "枪",
        totalDl: "累计充电量(kWh)",
        totalCharge: "累计充电次数(次)",
        totalChargeTime: "累计充电时长约",
        startTime: "开始时间",
        entTime: "结束时间",
        details: "详情",
        endOrder: "结束订单",
        tableFullName: "会员名",
        tablePhoneNo: "手机号",
        tableOrderStatusDesc: "订单状态",
        tableChargeBeginTime: "开始充电时间",
        tableChargeEndTime: "结束充电时间",
        tableChargeElect: "电量",
        tableChargeMinutes: "充电时长",
        tableTotalAmount: "总费用",
        timeMaxMin: "开始时间不能超过结束时间",
        timeNull: "更新时间不能为空 !",
        endOrderConfirm: "确定要结束订单吗？",
        endOrderSuccess: "结束订单成功",
    },
    //===========================主页 - 大屏 ===========================
    homeData: {
        goSys: "进入系统",
        operData: "充电运营维护平台",
        pageTitle: "运营数据",
        mapTypeSite: "站点地图",
        mapTypeHeat: "热力地图",
        mapTypeDl: "电量热力地图",
        mapTypeMoney: "营收热力地图",
        mapEnergy: "能源核算",
        coal: "煤炭",
        oil: "石油",
        co2: "二氧化碳",
        so2: "二氧化硫",
        no2: "氮氧化物",
        revenueRanking: "充电营收排行",
        orderRanking: "充电订单排行",
        dlRanking: "充电电量排行",
        timeRanking: "充电使用率排行",
        effectiveTimeRanking: "充电利用率排行",
        userRanking: "充电用户数量排行",
        dataRanking: "站点排行",
        totalOrder: "充电订单",
        totalMoney: "充电营收",
        totalDlMoney: "电费营收",
        totalServerMoney: "服务费营收",
        totalChargingTime: "充电使用时长",
        totalDl: "充电电量",
        totalPower: "总额定功率",
        totalUser: "充电用户数量",
        selectAll: "累计",
        selectToday: "今日",
        yesterday: "昨日",
        selectMonth: "今月",
        revenueLineTitle: "充电营收趋势图",
        revenuePieTitle: "充电营收占比图",
        revenueTotalTitle: "费用总数",
        revenueUnit: "元",
        dlLineTitle: "充电电量趋势图",
        dlPieTitle: "充电电量占比图",
        dlTotalTitle: "电量总数",
        dlUnit: "kWh",
        orderLineTitle: "充电订单趋势图",
        orderPieTitle: "充电订单占比图",
        orderTotalTitle: "订单总数",
        orderUnit: "单",
        gunStatusTitle: "充电枪实时状态",
        userLineTitle: "充电用户数量趋势图",
        useLineTitle: "使用率与利用率趋势图",
        siteRanking: "建设信息",
        totalSiteNum: "已建设充电站数量",
        totalGunNum: "已建设充电枪数量",
        totalPowerNum: "已建设充电桩总额定功率",
        pileCount: "充电桩数量",
        dcNum: "直流桩数量",
        dcGunNum: "直流枪数量",
        dcPower: "直流总额定功率",
        acNum: "交流桩数量",
        acGunNum: "交流枪数量",
        acPower: "交流总额定功率",
        bottomSite: "充电站数量",
        bottomGun: "充电枪数量",
        bottomTotalPower: "充电桩总额定功率",
        bottomDcPile: "直流桩数量",
        bottomDcGun: "直流枪数量",
        bottomDcPower: "直流总额定功率",
        bottomAcPile: "交流桩数量",
        bottomAcGun: "交流枪数量",
        bottomAcPower: "交流总额定功率",
        mapSelectText2: "充电时长",
        mapSelectText3: "充电用户数量",
        mapSelectText4: "充电电量",
        mapSelectText5: "充电订单",
        mapSelectText6: "充电营收",
        mapSelectText7: "充电使用率",
        mapSelectText8: "充电利用率",
        echartRevenueDf: "电费收入(元)",
        echartRevenueServer: "服务费收入(元)",
        echartRevenueDelayAmount: "占桩费收入(元)",
        echartDlSharp: "尖段电量(kWh)",
        echartDlPeak: "峰段电量(kWh)",
        echartDlFlat: "平段电量(kWh)",
        echartDlValley: "谷段电量(kWh)",
        echartUserOrder: "普通用户(单)",
        echartUserOrderEnt: "企业用户(单)",
        echartUserOrderNet: "渠道用户(单)",
        echartUseRatio: "使用率(%)",
        echartUsageRate: "利用率(%)",
        chargeUser: "充电用户人数(人)",
        activeUserNum: "活跃次数(人)",
        dcPlotGun: "分体式直流枪数量",
        dcPlotPower: "分体式直流总功率",
        bottomPower: "建设总功率",
    },
    // 资金数据
    fullData: {
        allYear: "全部年份",
        yearTips: "*清除年份条件，可汇总全部年份数据",
        month: "按月",
        day: "按日",
        statDate: "统计日期",
        oprName: "运营商名称",
        slefOrderCount: "充电订单数量",
        slefChargeElect: "充电电量(kW)",
        slefChargeAmount: "应收电费(元)",
        slefServiceAmount: "应收服务费(元)",
        slefDelayAmount: "应收占桩费(元)",
        slefTotalAmount: "应收总金额(元)",
        slefDiscountAmount: "优惠金额(元)",
        slefTransactionAmount: "实收总金额(元)",
        agentAmount: "分成收入金额(元)",
        totalAmount: "合计收入(元)",
        totalMoney: "合计收入",
        moneyUnit: "收入(元)",
    },
    //运营数据
    operationData: {
        receivableAmount: "应收金额(元)",
        discountAmount: "优惠金额(元)",
        totalMoney: "实收金额(元)",
        serverFee: "服务费(元)",
        charge: "充电次数(次)",
        people: "活跃人数(人)",
        chargeTime: "充电时长",
        chargeDl: "充电电量(kWh)",
        data: "数据统计",
        dlRanking: "电量排名",
        noRanking: "暂无排行",
        moneyRanking: "金额排名",
        tipsSite: "请选择充电站",
        tipsTime: "请选择时间",
        tipsMaxTime: "开始时间不能大于结束时间，请重新选择",
        echart: "图表",
        table: "表格",
        chargeTimes: "充电次数",
        balanceAmount: "账户余额",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        insideOrderNo: "内部订单号",
        externalOrderNo: "外部订单号",
        orderStatus: "订单状态",
        orderType: "订单类型",
        no: "否",
        yes: "是",
        details: "详情",
        endOrder: "结束订单",
        error: "异常处理",
        orderNo: "订单号",
        merchantName: "商户名称",
        netSystemName: "互联运营商",
        orderStatusDesc: "订单状态",
        staName: "站点名称",
        pileName: "桩名称",
        gunName: "枪名称",
        serialNumber: "桩编号",
        memberName: "会员名",
        phoneNo: "手机号",
        carNo: "车牌号",
        chargeBeginTime: "开始充电时间",
        chargeEndTime: "结束充电时间",
        payTime: "支付时间",
        chargeDuration: "充电时长",
        delayDuration: "占桩时长",
        chargeElect: "电量(kWh)",
        chargeAmount: "电费(元)",
        serviceAmount: "服务费(元)",
        time: "时间段",
        delayAmount: "占桩费(元)",
        totalAmount: "消费总金额(元)",
        discountAmount: "优惠总金额",
        transactionAmount: "实付金额（元）",
        startSoc: "开始soc",
        endSoc: "结束soc",
        stopReason: "停止原因",
        orderSource: "订单来源",
        abnormalType: "是否异常",
        elecPrice: "电费费率(元/kWh)",
        servicePrice: "服务费率(元/kWh)",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元)",
        delayMins: "时长(分钟)",
        delayFreeMins: "免费时长(分钟)",
        delayFree: "免费时长",
        sex: "性别",
        vipType: "会员类型",
        vipLevel: "会员等级",
        vin: "VIN码",
        cardType: "车型",
        staType: "站点类型",
        staStatus: "站点状态",
        staAddr: "充电站地址",
        gunPkId: "枪编号",
        manufacturer: "归属厂商",
        deviceType: "电桩类型",
        devicemodel: "设备型号",
        ratedPower: "额定功率",
        ratedCurrent: "额定电流",
        ratedVoltage: "额定电压",
        timeInterval: "时段",
        chargeDiscount: "电费优惠",
        serviceDiscount: "服务费优惠",
        delayDiscount: "占桩费优惠",
        totalDiscount: "优惠总金额",
        chargeTransAmount: "实付电费（元）",
        serviceTransAmount: "实付服务费（元）",
        jian: "尖",
        feng: "峰",
        ping: "平",
        gu: "谷",
        beforeBalance: "消费前金额(元)",
        afterBalance: "消费后金额(元)",
        reteInfo: "电桩费率信息",
        charge: "充电次数(次)",
        startTime: "开始时间",
        endTime: "结束时间",
        modifyTime: "更新时间",
        staPkId: "站点编号",
        entUserName: "企业会员",
        chargingCard: "用户卡号",
        consumptionPattern: "充电模式",
        chargingMode: "充电方式",
        userType: "用户类型",
        startMode: "启动方式",
        manufactureDate: "生产日期",
    },
    commonDetails: {
        delayMins: "时长",
        delayFreeMins: "免费时长",
        delayAmount: "占桩费",
        lastBillingNode: "最后计费节点",
        charge: "电量(kW·h)",
        serviceFee: "服务费(元)",
        totalAmount: "消费总金额(元)",
    },
    // 订单列表页面
    orderList: {
        end: "已结束充电",
        endConfirm: "确定要结束该订单吗?",
        endLoadingTips: "下发停止充电命令",
        endLoadingTips2: "系统将给充电桩下达停止充电命令，若15s内订单状态无法变更为“充电完成”，将继续进行第2步操作",
        endLoadingTips3: "生成平台充电报告",
        endLoadingTips4: "系统将给充电桩推送平台充电报告，若15s内订单状态无法变更为“充电完成”，将继续进行第3步操作",
        endLoadingTips5: "修改订单状态为异常单",
        endLoadingTips6: "系统将修改此订单为异常单，用户可正常进行下一次的充电操作",
        endLoading: "处理中..",
        endCharge: "结束充电",
        loadingSuccess: "下发停止命令成功",
        success: "生成平台报告成功",
        orderError: "订单状态已变更为异常",
        endSuccess: "结束成功",
        pageTitle: "充电订单",
        exportType: "默认",
        exportType2: "详情",
        totalChargeElect: "总充电量(kWh)",
        totalTransactionAmount: "实际总收入(元)",
        totalServiceAmount: "服务费(元)",
        totalChargeAmount: "电费(元)",
        totalDelayAmount: "占桩费(元)",
        totalDiscount: "优惠总金额(元)",
        totalServiceDiscount: "服务费优惠(元)",
        totalChargeDiscount: "电费优惠(元)",
        formType1: "常规搜索",
        formType2: "精准搜索",
        balanceRecharge: "余额充电",
        prechargeRetired: "即充即退",
        postPaidcharge: "先充后付",
    },
    // 订单异常结算页面
    abnormalOrder: {
        pileCharging: "桩计费总额",
        chargeTime: "充电时段",
        stopReason: "停止原因",
        pileChargeAmount: "桩充电费总额（元）",
        sysCharging: "平台计费总额",
        sysChargeAmount: "平台充电费总额（元）",
        pileErrorValue: "与桩误差值",
        normalErrorValue: "正常误差值：差值小于0.5元或差值比例小于20%",
        usePileCharging: "使用桩计费",
        useSysCharging: "使用平台计费",
        countType: "计算公式：桩充电费总额/平台充电费总额+占桩费总额",
        payAmount: "支付总额",
    },
    //订单详情
    orderDetails: {
        aorderDetailsTitle: "充电订单详情",
        userSiteTabTitle: "用户及站点信息",
        chargeType: "充电类型",
        chargeStatus: "充电状态",
        chargingModel: "充电策略",
        chargeElect: "充电电量",
        chargeDuration: "充电时长",
        orderCheckDetails: "订单校验详情",
        chargeDataEchart: "充电数据",
        chargeMoneyEchart: "充电计费数据曲线",
        batteryEchart: "电池信息曲线",
        pileSignal: "桩信号强度",
        faultCode: "异常编码",
        faultName: "异常名称",
        faultDesc: "异常描述",
        userInfo: "用户信息",
        siteInfo: "站点信息",
        siteId: "站点ID",
        pileInfo: "桩信息",
        rateInfo: "费用信息",
        errorHandle: "异常处理",
        billingMethod: "计费方式",
        operationTime: "操作时间",
        operationoOject: "操作对象",
        pileCreationTime: "桩投运时间",
        chargeFeeYLeftName: "费用(元)",
        chargeFeeYRightName: "电量(kW/h)",
        chargeYLeftName: "电压(V)/电流(A)/功率(kW)",
        chargeTemperatureYLeftName: "温度",
        chargeTemperatureYRightName: "电压",
        // 详情几个图表
        insertGun: "插枪",
        startCharging: "启动充电",
        endCharging: "结束充电",
        draw: "拔枪",
        outputVoltage: "输出电压",
        chargingPower: "充电功率",
        outputCurrent: "输出电流",
        demandVoltage: "需求电压",
        demandCurrent: "需求电流",
        cpVoltage: "CP电压",
        chargerTemperature: "充电机温度",
        gunTemperature: "枪口温度",
        brmProtocol: "brm协议版本",
        brmBatteryType: "brm电池类型",
        brmBatteryCapacity: "brm电池额定容量",
        brmRatedVoltage: "brm额定总电压",
        BCPMaxVoltage: "BCP单体最高电压",
        BCPMaxCurrent: "BCP最高电流",
        BCPBatteryEnergy: "BCP电池总能量",
        BCPMacVoltage: "BCP最高充电电压",
        BCPMaxTemperature: "BCP最高温度",
        BCPStartSOC: "BCP开始SOC",
        BSMMaxTemperature: "BSM最高动力电池温度",
        BCSMaxBatteryVoltage: "BCS最高单体电池电压",
        // 结算信息
        settlementTableName: "项目",
        settlementTablePayableAmount: "应付(元)",
        settlementTableDiscountAmount: "优惠(元)",
        settlementTabletransAmount: "实付(元)",
        settlementTabletransDl: "电费",
        settlementTabletransServer: "服务费",
        settlementTabletransDelay: "占桩费",
        retaInfoTab1: "结算信息",
        retaInfoTab2: "充电费用信息",
        retaInfoTab3: "占桩费用信息",
        retaInfoTab4: "VIP会员/优惠券优惠信息",
        total: "合计",
        vipDiscount: "VIP会员优惠",
        couponDiscount: "优惠券优惠",
        serviceAmount: "应付服务费（元）",
        serviceDiscount: "优惠服务费（元）",
        vipDiscountAmount: "VIP优惠",
        couponDiscountAmount: "优惠券",
        serviceTransAmount: "实付服务费（元）",
        chargeAmount: "应付电费（元）",
        chargeDiscount: "优惠电费（元）",
        chargeTransAmount: "实付电费（元）",
        delayAmount: "应付占桩费（元）",
        delayDiscount: "优惠占桩费（元）",
        delayTransAmount: "实付占桩费（元）",
        totalAmount: "应付合计（元）",
        totalDiscount: "总金额优惠（元）",
        transactionAmount: "实付合计（元）",
        discountTotal: "优惠合计（元）",
        discountName1: "活动",
        discountName2: "企业",
        discountName3: "接口用户",
        discountName4: "互联互通",
        discountName5: "非实名卡",
        typeName1: "活动",
        typeName2: "企业",
        typeName3: "接口用户",
        typeName4: "互联互通",
        typeName5: "非实名卡",
        //费率表格
        dlInfo: "用电信息",
        slotFlagDesc: "用电类型",
        time: "用电时段",
        electricity: "电量（kWh）",
        standardExpenses: "标准费用",
        slotServicePrice: "服务费率(元/kWh)",
        slotElecPrice: "电费费率(元/kWh)",
        discountServiceAmount: "服务费优惠(元)",
        discountElectAmount: "电费优惠(元)",
        cost: "活动/企业/互联互通/接口用户费用",
        delayCost: "企业/互联互通/接口用户费用",
        delayInfo: "占桩信息",
        minutesOhter: "占桩时长（分钟）",
        slotDelayPrice: "费率(元/分钟)",
        delayFee: "应付占桩费(元/分钟)",
        discountAmountOhter: "占桩费优惠（元）",
        discountType: "优惠类型",
        vipTotalDiscount: "合计优惠",
        discount: "优惠",
    },
    errorOrder: {
        abnormal: "异常名称",
        faultDesc: "异常描述",
        stopReason: "停止原因",
        totalAbnormalChargeOrder: "异常订单数",
        processedQuantity: "已处理数",
        unProcessedQuantity: "未处理数",
        orderType: "异常订单类型",
        handleFlag: "计费方式",
        pileBilling: "桩计费",
        platformFlag: "平台计费",
        errorDetails: "异常详情",
    },
    // 离线卡订单
    offCardOrder: {
        cardPhysicalSn: "流水号",
        cardSn: "物理卡号",
        chargeMode: "充电方式",
        dealType: "订单状态",
        exportName: "离线卡订单",
        dl: "充电电量",
        amount: "收入金额(元)",
        service: "服务费(元)",
        chargingTime: "充电时长",
        orderNumber: "订单数量(笔)",
        offCardNum: "离线卡数量(个)",
        chargingType: "充电方式",
        chargingEndTime: "充电结束时间",
    },
    // 离线卡详情
    offCardOrderDetails: {
        pageTitle: "充电订单详情",
    },
    //用户分析
    userAnalysis: {
        tab1: "用户增长",
        tab2: "用户属性",
        tab3: "用户排行",
        tab4: "用户行为",
        userStatus: "用户状态",
        targetDate: "目标日期",
        comparisonDate: "对比日期",
        addUser: "新增用户",
        activeUser: "活跃用户",
        cumulativeUser: "累计用户",
        selectTimeTips: "时间跨度不能超过两个月",
        target: "目标",
        comparison: "对比",
        analyzeTrends: "分析趋势",
        timeComparison: "时间对比",
        time: "时间",
        addUserRetention: "新增用户留存率",
        activeUserRetention: "活跃用户留存率",
        cumulativeUserRetention: "累计用户环比",
        analysisIndex: "分析指标",
        dataTime: "数据时间",
        firstOrderRate: "首单率",
        addProportion: "增长环比",
        cumulative: "累计",
        firstUserRatio: "首单用户比",
        ratioOfRetainedUsers: "留存用户比",
        yesterday: "昨日",
        lastDays7: "近7天",
        lastDays15: "近15天",
        lastDays30: "近30天",
        provinceAscription: "省级归属",
        loading: "加载中",
        province: "所属省份",
        people: "人数",
        proportion: "占比",
        strategyAnalysis: "充电策略分析",
        startAnalysis: "启动方式分析",
        timeAnalysis: "单次充电时长分布",
        firstOrderUser: "首单用户",
        top100: "前100",
        top200: "前200",
        custom: "自定义",
        accountType: "账户类型",
        userRanking: "用户排行",
        ranking: "排行",
        avgTransactionAmount: "订单平均金额(元)",
        cycleActivityRate: "周期活跃率",
        inputTips: "请输入正确的数值",
        mapNoData: "暂无此地区地图信息",
    },
    // 优惠券
    coupon: {
        addCoupon: "新增优惠券",
        couponNamePl: "优惠券名称",
        discountType: "优惠类型",
        couponType: "优惠券类型",
        couponTitle: "优惠券名称",
        relevancingAmount: "正在关联活动",
        usingCouponAmount: "已生成数量",
        sendCouponAmount: "已发放数量",
        createUserName: "创建人",
        createTime: "创建时间",
        applyStatus: "审核状态",
        grant: "发放",
        pushConfiguration: "推送配置",
        pushStatus: "推送状态",
        updateSuccess: "更新成功",
        tamplateDetection: "模板检测",
        hasAllocation: "已配置",
        notAllocation: "未配置",
        pushConfigTip: "未配置模板无法开启优惠券推送功能",
    },
    // 新增优惠券
    addCoupn: {
        couponCategory1: "活动优惠券",
        couponCategory2: "赠送优惠券",
        couponTypeTips: "备注：活动优惠券需要关联优惠活动使用，赠送优惠券则不需要关联优惠活动，创建完成后直接发放至指定用户账户中。",
        costType: "适用收费项",
        useCondition: "使用条件",
        orderUse: "单笔订单可用 1 张",
        addRow: "添加一行",
        termOfValidity: "有效期",
        fixedTime: "固定时间",
        afterCollection: "领取后",
        dayEffective: "天内有效",
        thirdServices: "关联第三方服务",
        issuedQuantity: "发放数量",
        instructionsTitle: "使用说明",
        instructionsTips: "使用说明将展示在优惠券上，请注意用词规范",
        applyStatus: "审核状态",
        auditorName: "审核人",
        auditTime: "审核时间",
        reasons: "备注",
        inputDayTips: "请输入天数",
        inputDayMax: "数量不得大于1000，请重新输入",
        inputDayError: "请输入正确的天数，不能有小数",
        inputTimeNo: "请选择固定时间",
        inputTimeNo2: "开始时间不能和结束时间相同",
        inputReasons: "请输入不通过原因",
        selectCoupn: "请选择优惠券类型",
        dayNumber: "天数",
        number: "数量",
        selectCostTypeTips: "请选择适用收费项",
        inputInstructionsNoTips: "请输入使用说明",
        selectTermOfValidity: "请选择有效期",
        selectThirdServices: "请选择关联第三方服务",
        subSuccess: "操作成功",
        auditSuccess: "审核成功",
        addCoupn: "新增优惠券",
        updataCoupn: "修改优惠券",
        detailsCoupn: "优惠券详情",
        auditCoupn: "优惠券审核",
        discount: "折扣比例",
        remarks: "备注",
        couponInfo: "优惠券信息",
        discountName: "优惠",
        auditTitle: "审核意见",
        remarksTips: "原因说明，通过为非必填",
        grantTitle: "发放设置",
        auditInfoTitle: "审核信息",
    },
    // 优惠活动
    memberCoupon: {
        addActivity: "新增活动",
        namePl: "活动名称模糊检索",
        status: "活动状态",
        campaignType: "活动类型",
        applyStatus: "审核状态",
        usageStatus: "使用状态",
        waitAudit: "待审核",
        passed: "已通过",
        rejected: "已驳回",
        title: "活动标题",
        userCouponAmount: "使用数量",
        sendCouponAmount: "已发放数量",
        marginAmount: "余量/总数量",
        createUserName: "创建人",
        createTime: "创建时间",
        confrimStart: "确定要启用吗",
        confrimStop: "确定要停用吗",
        startSuccess: "启用成功",
        stopSuccess: "停用成功",
        auditUserName: "审核人",
        titleActivity: "活动信息",
        titleAudit: "审核信息",
    },
    // 新增优惠活动
    addMemberCoupon: {
        couponAmounts: "优惠券模板",
        chargeMoney: "单笔充值金额需≥",
        charge: "单笔充电度数需≥",
        selectTmp: "选择模板",
        noCoupon: "暂无可选优惠券",
        sending: "发送",
        addCondition: "添加条件",
        noGrantMore: "不叠加发放",
        noGrantMoreTips: "不叠加发放：系统仅发放最符合条件的一个优惠券模板",
        crantMore: "叠加发放",
        crantMoreTips: "叠加发放：系统会将符合条件的所有优惠券模板叠加起来，全部发放。",
        userMaxSecond: "单个用户领取次数",
        infinite: "无限次",
        limited: "有限次",
        thirdCouponAmounts: "第三方优惠券模板",
        addTmp: "选择模板",
        elePriceMethod: "电价优惠方式",
        dcElePrice: "直流桩电价",
        acElePrice: "交流桩电价",
        serverPriceMethod: "服务费优惠方式",
        dcServerFee: "直流桩服务费",
        acServerFee: "交流桩服务费",
        ruleSet: "规则设置",
        EveryInvitation: "邀请人数",
        everyInvitation: "每次邀请",
        cumulativeInvitation: "累计邀请",
        addInviteesCondition: "添加邀请人数条件",
        giftOptions: "赠送选择",
        addUserRegister: "新用户注册成功",
        addUserRegisterTips: "新用户注册后x天内充电达x度",
        givePeople: "赠送邀请人",
        newUserAfter: "新用户注册后",
        dayCharge: "天内充电达",
        channel: "适用渠道",
        partakeSite: "参与调价站点",
        couponRange: "优惠券使用范围",
        unlimited: "无限制",
        designatedCity: "指定城市",
        designatedSite: "指定站点",
        autarky: "自营",
        noAutarky: "非自营",
        totalCoupons: "优惠券总数",
        useCollectTimesStatusTips: "请选择单个用户领取次数",
        useCollectTimesStatusTips2: "请输入次数",
        useCollectTimesStatusTips3: "次数不能大于1000",
        useCollectTimesStatusTips4: "请输入正确的次数",
        scopeTypeTips: "请选择优惠券使用范围",
        scopeTypeTips2: "请选择城市",
        scopeTypeTips3: "请选择站点",
        totalNumberTips: "发送次数",
        moneyTips: "数值",
        campaignTypeTips: "请选择活动类型",
        campaignClientTips: "请选择适用渠道",
        elecFeeTypeTips: "请选择电费优惠方式",
        serviceFeeTypeTips: "请选择服务费优惠方式",
        couponAmountsTips: "请选择优惠券模板",
        beginTimeTips: "请选择开始时间",
        endTimeTips: "请选择结束时间",
        remarkTips: "请输入使用说明",
        tipsMaxTime: "开始时间不能大于结束时间，请重新选择",
        subSuccess: "操作成功",
        auditSuccess: "审核成功",
        titleAdd: "新增营销活动",
        titleUpdata: "修改营销活动",
        titleDetails: "营销活动详情",
        titleAudit: "营销活动审核",
        overlayDiscount: "叠加优惠",
        overlayDiscountTips: "叠加优惠是指多种优惠可叠加计算。",
        overlayDiscountTips2: "活动调价优惠，可与VIP会员优惠、优惠券优惠其中之一或两者一起叠加使用，若不选择，则该优惠活动只执行活动调价，不叠加优惠。",
        registrationTips: "赠送次数表示该模板总共赠送的总数，例如输入10，则表示前10位新注册用户将获得该优惠券，之后注册的将不在发放。",
    },
    // 发放优惠券
    memberCouponGrant: {
        couponEnd: "张用完",
        allowance: "余量",
        surplus: "剩余发送次数",
        surplusTips: "每指定一个用户记为一次发放次数",
        targetUsers: "接收目标用户",
        targetUsersTips1: "手动输入用户手机号",
        targetUsersTips2: "批量导入用户手机号",
        targetUsersTips3: "无",
        targetUsersTips4: "多个输入需要用英文“ , ”隔开，手动输入最多支持1000个号码，大批量号码建议通过文件导入形式提交",
        uploadFile: "选择文件",
        uploadFileType: "请上传xls、xlsx格式，号码文件",
        uploadFileExamples: "范例查看",
        uploadFileTips: "Excel的单元格格式请务必使用“常规”格式文件大小不可超过3M，建议单次导入",
        targetUsersNull: "请选择接收目标用户",
        phoneNull: "请输入用户手机号",
        exportPhoneNull: "请导入用户手机号",
        No: "第",
        NoTips: "个优惠券模板指定用户数已超出剩余发放次数，请删减指定用户",
        minTmpTips: "请至少发放一种优惠券模板",
        grantTitle: "优惠券发放",
        grant: "发放",
        perPerson: "人，每人",
        total: "张，共",
        totalGrant: "总计发放优惠券",
        grantSuccess: "发放成功",
        issuingType: "发放时间",
        targetUsers1: "所有用户",
        targetUsers2: "指定用户",
        issuingType1: "立即发放",
        issuingType2: "指定时间发放",
    },
    // 用户优惠券
    userCoupon: {
        hasUsed: "优惠券使用状态",
        notUsed: "未使用",
        used: "已使用",
        campaignTitle: "活动名称",
        staName: "使用充电站",
        pileName: "使用充电桩",
        orderNo: "使用订单",
        releaseTime: "领取时间",
        endTime: "过期时间",
        useTime: "使用时间",
        state: "状态",
        platformId: "平台ID",
        platformName: "平台名称",
        couponPkId: "优惠券编号",
        userName: "用户昵称",
        couponType: "优惠券类型",
        couponTitle: "优惠券标题",
        tab1: "用户优惠券",
        tab2: "第三方优惠券",
    },
    //系统公告
    systemNotice: {
        addNotice: "新增公告",
        noticeState: "公告状态",
        noticeType: "消息类型",
        title: "标题",
        content: "内容",
        picturesParam: "图片",
        validTime: "生效时间",
    },
    //新增系统公告
    addSystemNotice: {
        pageTitle: "新增系统公告",
        expireTime: "失效时间",
        noticeType1: "选用系统样式",
        noticeType2: "自定义图片",
        staPkId: "发送站点",
        viewShow: "样式预览",
        upload: "上传图片",
        activity: "关联活动",
        contentTips: "请输入内容",
        validTimeTips: "请选择生效时间",
        expireTimeTips: "请选择失效时间",
        noticeTypeTips: "请选择消息类型",
        staPkIdTips: "请选择发送站点",
        picturesParamTips: "请上传图片",
        maxTime: "失效时间不能大于生效时间",
        subSuccess: "提交成功",
        imgTips: "图片尺寸为：750*150",
    },
    // 会员消息
    customerService: {
        key: "会员昵称、手机号",
        createUserName: "会员昵称",
        processed: "已回复",
        unprocessed: "未回复",
        reply: "回复",
        sources: "消息来源",
        weChat: "公众号",
        applets: "小程序",
        contactPhone: "手机号",
        sourceType: "消息类型",
        content: "消息内容",
        picturesParam: "图片",
        createTime: "发出时间",
        processingStatus: "处理状态",
        processingResult: "处理内容",
        modifyTime: "处理时间",
        replyMsg: "回复消息",
        contentPl: "请输入回复内容",
        feedBackType: "反馈类型",
        user: "用户",
        system: "平台",
        time: "时间",
        account: "操作帐号",
        role: "角色",
    },
    // 用户指南
    userGuide: {
        addArticle: "新增文章",
        catalogue: "目录管理",
        addCatalogue: "新增目录",
        menuTitle: "目录",
        title: "标题",
        requestUrl: "链接地址",
        confirmDel: "确定要删除吗",
        delSuccess: "删除成功",
    },
    // 新增文章
    addArticle: {
        titleTips: "请输入标题",
        requestUrlTips: "请输入链接地址",
        subSuccess: "操作成功",
    },
    // 会员等级管理
    memberGrade: {
        switch: "当前启用状态",
        tab1: "等级管理",
        tab2: "等级购买记录",
        discountType: "折扣类型",
        discountRatio: "折扣比例",
        saleStatus: "售卖状态",
        endPurchase: "终止购买",
        allowPurchase: "允许购买",
        enablea: "启用",
        disable: "禁用",
        confirmEnablea: "确定要启用吗",
        confirmDisable: "确定要禁用吗",
        confirmDel: "确定要删除吗？",
        delSuccess: "删除成功",
        successTips: "更改成功",
        salesRevenue: "售卖会员收入(元)",
        purchaseRatio: "等级购买比例",
        purchaseTimeRatio: "购买时长比例",
        purchaseMethod: "购买方式",
        gradeType: "等级类型",
        vipDaysDesc: "购买时长",
        purchaseType: "购买类型",
        purchaseTime: "购买时间",
        gradePurchaseRecord: "等级购买记录",
        transactionPoints: "支付积分",
        transactionTime: "消费积分",
        vipEndTime: "到期时间",
        transactionAmount: "支付金额(元)",
    },
    // 会员等级管理添加
    addMemberGrade: {
        vipLevel: "等级名称",
        vipLevelPl: "请选择等级",
        vipLevelRule: "请选择会员等级",
        priceTitle: "会员价格",
        pricePl: "数字1-10",
        points: "积分",
        discountAmountTypeRule: "请选择折扣类型",
        maxNumber: "会员人数",
        statusRule: "请选择售卖状态",
        daysDesc: "购买天数",
        price: "价格（元）",
        firstDiscountRatio: "首次购买折扣",
        pointsPrice: "积分兑换价格",
        dayPrice: "天价格",
        dayPointsPrice: "天积分兑换价格",
        firstDiscountRatioTips: "天首次购买折扣要在1-10之间",
        please: "请输入",
        maxNum: "不能超过99999",
        subSuccess: "提交成功",
        noLimit: "无上限",
        discount: "折",
        customDays: "自定义",
    },
    // 积分活动
    integralActivity: {
        tabTitle1: "充电积分活动",
        tabTitle2: "积分签到活动",
        tabTitle3: "积分兑换记录",
        tabTitle4: "积分增长记录",
        activityName: "活动名称",
        allType: "全部方式",
        payTime: "支付时间",
        integralActivity: "积分活动",
        integralSet: "积分设置",
        mei: "每",
        consume: "每消耗",
        kwhExchange: "度电，兑换",
        points: "积分",
        pay: "每支付 ",
        yuanExchange: "元，兑换",
        cmpnName: "积分活动名称",
        chargePointWayDesc: "获取方式",
        chargePointRuleDesc: "获取方式内容",
        campaignState: "活动状态",
        searchPl: "订单号/会员名称/手机号/积分活动",
        integralAddRecord: "积分增长记录",
        transactionPoints: "积分值",
        totalPoints: "已产生积分汇总",
        pointsTop5: "积分活动TOP5",
        userPointAlarmDays: "积分有效期",
        updataTime: "积分更新时间",
        updataTimeTips: "积分有效期提醒",
        countDown: "倒计时",
        updataTimePl: "请选择积分更新时间",
        userPointAlarmDaysPl: "请选择积分有效期",
        subSuccess: "操作成功",
        totalPointsRedeemed: "已兑换总积分",
        residualTotalIntegral: "剩余总积分",
        exchangeTop5: "兑换量TOP5",
        orderNo: "兑换订单号",
        vipName: "兑换物品",
        exchangePoints: "兑换积分",
        afterPoints: "剩余积分",
        transactionMethodDesc: "变动方式",
        createTime: "兑换时间",
        integralSwitch: "积分功能开关",
        campaignTotalPoints: "产生积分",
        integralActivityInfo: "积分活动信息",
        configInfo: "配置信息",
    },
    // 新增积分活动
    addIntegralActivity: {
        // checkInPlan: "签到方案",
        // firstCheck: "首次签到规则",
        // firstCheckGet: "首次签到获取",
        // noIntegral: "无积分",
        // continuityCheckRule: "连续签到规则",
        // continuityCheckRuleTips:
        //   "用户获得连续签到奖励后，连续签到天数会重新计算，并在下一次满足连续签到天数时再次获得连签奖励",
        // continuityCheckFul: "连续签到满",
        // continuityCheckFul2: "天，获取",
        // continuityCheckRuleTips2:
        //   "连续签到天数获取到的积分值呈阶梯形，用户获取第一阶层奖励后，签到天数将计入第二阶层，直至满足下一阶层连续签到天数时再次获取连签奖励",
        // add: "添加阶梯",
        checkRule: "签到规则",
        activityRules: "活动规则",
        activityRulesPl: "请描述本次积分活动规则",
        chargePointWayRule: "请选择积分方式",
        payTimeRule: "请选择支付方式",
        firstCheckIntegral: "首次签到赠送积分",
        checkRulePl: "请选择签到规则",
        continuityCheckDay: "连续签到天数",
        remarksRule: "请输入活动说明",
        integralRule: "积分签到规则",
        integralRule1: "1、连续签到 第一天得1分，第二天得2分，依次类推，第七天得7分。",
        integralRule2: "2、连续签到大于7天，得分与第七天一致",
        integralRule3: "3、中途若签到中断 ，则从第一天重新开始计算。",
        add: "新增签到活动",
        updata: "修改签到活动",
    },
    // 积分增长记录详情
    integralAddRecordDetails: {
        type: "类型",
        time: "时间",
        createTime: "签到时间",
    },
    //站点信息
    pileInfo: {
        addSite: "增加站点",
        operationType: "营业类型",
        staStatus: "运营状态",
        applyStatus: "审核状态",
        merchantName: "商户名称",
        updataSite: "编辑站点",
        subAudit: "提交审批",
        eleList: "电价列表",
        pileList: "桩列表",
        closeSite: "关闭站点",
        audit: "审批",
        chargeStrategy: "充电策略",
        siteDebug: "现场调试",
        underRepair: "维修中",
        normalUse: "正常使用",
        outSite: "迁出充电站",
        exportTips: "导出条数不能少于等于0",
        closeSiteSuccess: "关闭站点成功!",
        closeSiteConfirm: "确定关闭下线站点吗?",
        siteExportTmp: "充电站导入模板",
        subAuditConfirm: "确定要提交审核吗?",
        subSuccess: "提交成功",
        staPkId: "站点编号",
        staAddress: "地址详情",
        movingMch: "迁入的商户",
        movingMchPl: "请选择商户",
        operSet: "运营设置",
        phoneShow: "增值服务",
        show: "显示",
        hide: "关闭",
        electricFeeTplName: "充电费率",
        appointFeeTplName: "待生效费率",
        feeEffectiveTime: "待生效费率生效时间",
        delayFeeTplName: "占桩费率",
        chargingStrategy: "有序充电",
        operationMode: "营业方式",
        invoicingParty: "开票方",
        invoicingPartyPl: "请选择开票方",
        province: "省",
        city: "市",
        district: "区",
        unbindTip: "请稍后再试",
    },
    // 站点电价列表
    pileInfoEle: {
        rate: "充电费率",
        appointmentRate: "待生效费率",
        feeName: "模板名称",
        ac: "交流桩",
        dc: "直流桩",
        executeTime: "生效时间",
        chargeRateName: "电费/服务费率(元/kWh)",
        delayFreeMinutes: "免费时长",
        delayFreeMinutesMax: "占桩费上限",
        delayRateName: "占桩费(元/分钟)",
        reservationRateName: "预约占位费(元/分钟)",
        reservationRateMax: "预约占位费上限",
        minute: "分钟",
        rateChangeBnt: "费率更换明细",
        delayRate: "占桩费率",
    },
    // 费率应用明细
    feeDetails: {
        feeName: "充电费率",
        replaceFeeName: "待生效费率",
        executeTime: "预约生效时间",
        delayFeeTplName: "占桩费率",
        tab1: "充电费率",
        tab2: "占桩费率",
        tab3: "预约占位费率",
        rateDetails: "费率详情",
        open: "展开",
        close: "收起",
        noSta: "暂无充电站使用",
        replaceFee: "预约占位费率",
        acReplaceFee: "交流桩费率",
        dcReplaceFee: "直流桩费率",
    },
    // 站点详情
    pileInfoDetail: {
        city: "城市",
        staAddress: "地址",
        position: "建设场所",
        staLat: "经纬度",
        staTypeName: "站点类型",
        fullName: "关联商户",
        tagInfoVos: "站点标签",
        commissioningDate: "投运时间",
        businessBeginHours: "开放时间",
        parkNum: "车位数量",
        serviceTel: "服务电话",
        phoneNo: "站点电话",
        hasFreePark: "是否免费停车",
        yes: "是",
        no: "否",
        remarks: "温馨提示",
        feeName: "站点费率",
        DC: "直流桩",
        AC: "交流桩",
        oprDelayFeeInfos: "占桩费",
        delayFreeMinutes: "免费时长",
        staPics: "站点图片",
        staInfo: "充电桩信息",
        totalDev: "总设备",
        dcGunCount: "直流枪口",
        acGunCount: "交流枪口",
        tab1: "站点详情",
        tab2: "维护记录",
        tab3: "费率变更记录",
        price: "总价(元/kWh)",
        manufacturerName: "设备商",
        ratedPower: "额定功率(kW)",
        delayUnit: "元/分",
        reason: "原因",
        debuggingPeople: "调试人员",
        debuggingContent: "调试内容",
        oldFeeName: "旧费率",
        newFeeName: "新费率模版",
        replaceTime: "更换日期",
        feeType: "费率类型",
    },
    // 充电桩信息
    pileList: {
        allUpdata: "批量编辑",
        batchStaBtn: "批量关联/解绑",
        batchLineBtn: "批量上线/下线",
        batchSendBtn: "批量下发二维码",
        addBtn: "增加桩信息",
        deviceStatus: "充电桩状态",
        showQcode: "二维码",
        editGun: "编辑枪",
        showUnlock: "解锁",
        offLine: "离线",
        showFee: "下发电价",
        outPile: "迁出充电桩",
        unbind: "解绑",
        downQCode: "下发",
        staName: "所属站点",
        internalNumber: "站内编号",
        chargeGunInfoVoList: "电枪型号",
        parkNo: "车位号",
        gunStatus: "电枪状态",
        editPile: "编辑桩",
        issueConfirm: "确定要下发二维码吗？",
        issueSuccess: "下发二维码成功",
        showFeeConfirm: "确定下发电价吗?",
        showFeeSuccess: "下发电价成功",
        showUnlockConfirm: "确定解锁吗?",
        showUnlockSuccess: "解锁成功",
        unbindSuccess: "解绑站点成功!",
        moveInSta: "迁入的充电站",
        moveInStaPl: "请选择充电站",
        remarks: "备注",
        checkReminder: "校验提醒",
        checkReminderTips: "该二维码平台和充电枪不一致，请到二维码明细页校验后查看，若不一致需要重新下发二维码",
        checkReminderTips2: "该二维码未较验，请到二维码明细页校验后查看",
        gun: "枪",
        offTips: "充电桩所属站点配置了有序充电分组策略，上下线操作后需要重新配置分组",
        unbindTips: "充电桩所属站点配置了有序充电分组策略，解绑操作后需要重新配置分组",
        groupName: "有序充电分组",
        confirmOff: "确定要操作设备 - ",
        saveQrcode: "保存二维码",
        saveQrcodeImg: "保存图片",
        exportQrcode: "导出二维码",
        gunOperation: "枪操作",
    },
    // 批量修改桩
    pileAllUpdata: {
        dwonloadBtn: "下载设备表",
        importBtn: "导入文件",
        remove: "移除",
        confirmSave: "确认保存",
        step1: "第一步",
        stepText1: "筛选条件，选择指定充电站",
        step2: "第二步",
        stepText2: "下载设备表，如已提前下载请忽略此步",
        step3: "第三步",
        stepText3: "根据表格内设备编号填写对应信息",
        step4: "第四步",
        stepText4: "点击：导入文件",
        step5: "第五步",
        stepText5: "核对导入数据，确认无误点击保存",
    },
    modalShowMap: {
        showMap: "开启地图",
        addrPl: "请输入地址",
        noData: "暂无数据",
    },
    // 修改充电站
    pileInfoEdit: {
        site: "充电站",
        regionId: "省-市-区",
        businessBeginHours: "开始营业时间",
        businessEndHours: "结束营业时间",
        allDay: "全天",
        position: "站点位置",
        map: "地图",
        showMap: "开启地图",
        staLng: "经度",
        staLat: "纬度",
        largeParkNum: "大巴车位数",
        consNo: "报装户号",
        hasSupportReseration: "是否支持预约",
        parkingFee: "停车备注",
        picturesParamList: "图片",
        picturesParamQuery: "查看图片",
        imgSize: "图片尺寸建议为：",
        addrPl: "请输入地址",
        selectTag: "选择标签",
        addTag: "添加标签",
        tagName: "标签名称",
        required: "必填项",
        nameMax: "站点名称长度不能超过50",
        regionIdPl: "省-市-区都必填",
        merchantPkIdPl: "请选择关联商户",
        constructionPl: "请选择建设场所",
        positionPl: "请选择站点位置",
        commissioningDatePl: "请选择投运时间",
        hasWeChat: "微信公众号显示",
        hasWeMini: "微信小程序显示",
        hasZfbLife: "支付宝生活号显示",
        hasZfbMini: "支付宝小程序显示",
        hasApp: "app显示",
    },
    // 批量更换费率
    allUpdataRate: {
        allUpdataRateBtn: "批量更换费率",
        allUpdataRateDelayBtn: "批量更换占桩费率",
        allUpdataRateReservationBtn: "批量更换预约占桩费率",
        allUpdataChargingStrategy: "批量修改有序充电策略",
        addUpdataRateBtn: "新增更换费率",
        changeRateBtn: "立即更换",
        feeName: "新费率模版",
        executeTime: "更换日期",
        executeStatus: "更换状态",
        operatorName: "操作帐号",
        targetSta: "站点",
        executeMode: "更换类型",
        feeNamePl: "请选择费率",
        executeTimePl: "请选择时间",
        executeModePl: "请选择更换类型",
        targetStaPl: "请选择站点",
        executeMode1: "立即生效",
        executeMode2: "预约生效",
        tips: "提醒：立即生效不影响已经有预约生效的费率，预约生效将更新当前已经预约生效的充电费率，不影响当前正在使用的费率。 生效时间为设置日期当天的00:00:00",
        subTips: "提醒：立即生效不影响已经有预约生效的费率，预约生效将更新当前已经预约生效的充电费率，不影响当前正在使用的费率。",
        aduitNow: "立即下发",
        aduitThen: "预约下发",
    },
    // 批量关联站点
    allBindPile: {
        sta: "将设备关联到",
        staPl: "请选择所属站点",
        subBtn: "立即关联",
        subUnBtn: "立即解绑",
        unFormSta: "站点筛选",
        tab1: "关联",
        tab2: "解绑",
    },
    // 批量上线/下线
    allLineOffPile: {
        lineOffBtn: "立即下线",
        lineBtn: "立即上线",
    },
    //  编辑枪
    editGun: {
        manufacturerName: "设备生产商",
        gunName: "枪口名称",
        gunNamePl: "请输入枪口名称",
        parkNo: "车位号",
        description: "枪口描述",
        descriptionPl: "请输入枪口描述",
    },
    // 新增桩
    addPile: {
        deviceType: "设备类型",
        deviceModelPkId: "设备型号",
        protocolPkId: "协议",
        remark: "备注",
        gunInfo: "枪口信息",
        info: "信息",
        addName: "新增充电桩",
        staNamePl: "所属站点必须选择",
        deviceTypePl: "设备类型必须选择",
        deviceModelPkIdPl: "设备型号必须选择",
        sn: "桩编号",
        snPl: "桩编号不能为空",
        snPl2: "桩编号必须为数字",
        snPl3: "桩编号必须为数字或者字母",
        pileNamePl: "桩名称不能为空",
        deviceStatusPl: "运营状态不能为空",
        protocolPkIdPl: "请选择协议主键",
        qrcode: "二维码",
        detailsName: "充电桩详情",
        updataName: "修改充电桩",
        charging: "充电中",
        inserted: "已插枪",
        fault: "故障",
        disable: "禁用",
        offLine: "离线",
        free: "空闲",
        full: "已充满",
        subscribe: "预约",
        offline: "下线",
        online: "上线",
        importTpl: "模板下载",
        tab1: "新增桩",
        tab2: "批量导入桩",
        total: "本次共计",
        dev: "台设备",
        dc: "直流桩",
        ac: "交流桩",
        power: "功率",
        pileCommissioningDate: "投运时间",
        pileCommissioningDatePl: "请选择投运时间",
        pileProductionDate: "请选择生产日期",
        splitPile: {
            deviceModelPkId: "主机型号",
            sn: "主机编号",
            pileName: "主机名称",
            title: "添加终端",
            addRow: "新增终端",
            addRowPl: "请新增终端",
            deviceModel: "终端型号",
            deviceModelName: "终端名称",
            deviceModelSn: "终端编号",
            ratedPower: "额定功率",
            deviceModelPl: "请选择终端型号",
            deviceModelNamePl: "请输入终端名称",
            numberPl: "请输入数字编号",
            remove: "移除",
            internalNumber: "站内编号",
            pileProductionDate: "生产日期",
        },
    },
    // 费率管理
    feeManage: {
        tabStaRate: "站点费率",
        tabEntRate: "企业费率",
        tabInterflowRate: "互联互通费率",
        useRate: "生效中费率",
        notUseRate: "待生效费率",
        rateDetails: "费率详情",
        bindSite: "关联站点",
        waitTakeEffect: "待生效",
        takeEffect: "已生效",
        effectiveStatus: "生效状态",
        effectiveTime: "关联时间",
        addTpl: "新增费率",
        allChangeRate: "批量更换费率",
        key: "费率名称",
        sys: "系统",
        feeName: "模板名称",
        feeNamePl: "请输入模板名称",
        acRate: "交流桩充电费率(电费/服务费)",
        dcRate: "直流桩充电费率(电费/服务费)",
        delayRate: "占桩费率",
        bindStaNum: "使用数量",
        applyStatus: "审核状态",
        timePl: "更新时间不能为空",
        upPl: "费率使用中，请勿删除或修改 !",
        delConfirm: "确定删除当前费率吗",
        rateAudit: "费率审核",
        adopt: "审批通过",
        refuse: "审批拒绝",
        reason: "原因说明",
        rateAuditPl: "请选择审批状态",
        reasonPl: "请输入原因说明",
        replaceTime: "生效时间",
        requestTime: "操作时间",
        operatorName: "操作人",
        recordChargeRate: "充电费率",
        recordDealyRate: "占桩费率",
        acAppointment: "交流桩预约占位费率",
        acRateTimingType: "交流桩收费类型",
        dcAppointment: "直流桩预约占位费率",
        dcRateTimingType: "直流桩收费类型",
        appointmentRate: "预约占位费率",
        hasReplaceFee: "是否有待生效费率",
        createUserName: "修改人",
        createTime: "修改时间",
        feeRecord: "费率记录",
        feeStatus: "当前状态",
        clearConfirm: "确定要取消费率更换吗？",
        issue: "下发",
        toBeIssued: "待下发数量",
        updateTip: "当前费率有待下发站点，若需要修改费率请先取消下发",
        aduitTip: "当前费率有待生效费率，若需要下发请先取消待生效费率",
        aduitCancleTip: "确定取消下发吗?",
        cancleSuccess: "取消成功",
        sureCancleTip: "确定取消预约吗?",
    },
    //新增、修改费率
    addFeeManage: {
        copyRate: "复制费率",
        copyTips: "提示：可快速复制费率及时段",
        copyPl: "请选择要复制的费率",
        subAudit: "提交审核",
        addRate: "新增费率",
        delayFreeMinutes: "免费时长",
        copy: "复制",
        rate: "费率",
        acRate: "交流桩费率",
        dcRate: "直流桩费率",
        delayRate: "占桩费费率",
        priceMax: "当前价格超过",
        priceNumber: "价格请输入数字",
        timePl: "请选择时间再添加",
        time24All: "24小时已全部选择，不能再添加",
        timeOverlap: "时间段重叠，请检查",
        time24AllNo: "请选择完整的24小时",
        please: "请输入",
        serviceRate: "的服务费率",
        slotElec: "电价",
        slotDelayPrice: "费率（元/分钟）",
        rateDetails: "费率详情",
        acRateDetails: "交流桩充电费率详情",
        dcRateDetails: "直流桩充电费率详情",
        replaceMethod: "生效配置",
        replaceTime: "生效时间",
        replaceMethodPl: "请选择生效配置",
        replaceTimePl: "请选择生效时间",
        retaOld: "原费率",
        retaNew: "新费率",
        copyDc: "与直流费率一致",
        copyAc: "与交流费率一致",
        reteSet: "费率设置",
        freePeriod1: "免费时段一",
        freePeriod2: "免费时段二",
        freePeriod3: "免费时段三",
        selectTimeTip: "请选择时段",
        freeTips: "在以上时段内，占桩免占桩费",
        selectTimeRepeatTip: "免费时段不能重复",
        chargeFee: "交流充电费率",
        delayFee: "直流占桩费率",
        delayFeeDetail: "占桩费(元/分钟)",
        freePeriod: "免费时长(分钟)",
        delayFeeMax: "占桩费上限(元)",
    },
    //费率管理--企业
    entFeeManage: {
        boundStaCount: "关联站点数",
        electricStrategy: "电费策略",
        serviceStrategy: "服务费策略",
        delayStrategy: "占桩费策略",
        original: "是否原价",
        priceUpdata: "电价修改",
        bindSta: "关联站点",
        entName: "企业名称",
        systemName: "系统名称",
    },
    delayFeeManage: {
        acRate: "交流桩占桩费率",
        dcRate: "直流桩占桩费率",
        acRateDetails: "交流占桩费详情",
        dcRateDetails: "直流占桩费详情",
        dcDelayFeeUpperLimit: "直流占桩费上限",
        acDelayFeeUpperLimit: "交流占桩费上限",
        delayFeeUpperLimit: "占桩费上限",
        freePeriod: "免费时段",
    },
    // SIM卡管理
    simManage: {
        status: "SIM卡状态",
        successDev: "成功匹配设备",
        flow: "SIM卡流量套餐",
        globalSearch: "ICCID",
        matchingStatus: "匹配状态",
        statusYes: "已匹配",
        statusNo: "未匹配",
        activeDate: "激活日期",
        endDate: "截止日期",
        simOperator: "供应商",
        totalFlow: "流量套餐",
        usedFlow: "当月使用流量",
        restFlow: "当月剩余流量",
        deviceModelName: "设备型号",
        deviceType: "设备类型",
        staName: "站点名称",
        dcDev: "直流设备",
        acDev: "交流设备",
        totalNum: "SIM卡总数",
        toBeActivatedNum: "待激活数",
        activatedNum: "已激活数",
        closedNum: "停机数",
        testableNum: "可测试数",
        inventoryNum: "库存数",
        preCloseNum: "预销户数",
    },
    // 新增SIM卡
    addSim: {
        fileText: "SIM卡导入模板",
        downloadTemplate: "下载模板",
        importTemplate: "导入模板",
        selectFile: "选择文件",
        timeError: "日期错误提示",
        No: "第",
        timeMax: "行激活日期不能超过截止日期",
        close: "关闭",
        please: "请选择",
        iccidPl: "请输入ICCID",
        iccidLen: "ICCID长度必须是20位",
        iccidError: "只能由字母或数字组成",
        iccid4Number: "后4位必需是数字",
        activeDatePl: "请选择激活日期",
        endDatePl: "请选择截止时间",
        simOperatorPl: "请选择供应商",
        statusPl: "请选择卡状态",
        staPkIdPl: "请选择充电站",
        totalFlowPl: "请选择流量套餐",
        exportSuccess: "导入成功",
        exportPl: "请导入文件",
        statusError: "卡状态不是沉默期的时间不可以为空",
        addSuccess: "新增成功",
        timeNull: "时间不可以为空",
        upSim: "修改SIM卡",
        detailsSim: "SIM卡详情",
    },
    // 头部
    header: {
        strip: "条",
        jump: "点击跳转",
        accInfo: "帐号信息",
        upPas: "修改密码",
        out: "退出登录",
        resetPas: "重置密码",
        abnormalOrder: "待处理异常订单",
        campaignAmount: "待审核优惠活动",
        couponTemplateAmount: "待审核优惠卷模板信息",
        feeAmount: "待审核费率模板信息",
        invoiceAmount: "待审核发票记录",
        mchDrawcashOrder: "待审核商户提现单",
        mchSettlementOrder: "待审核商户日结单",
        memberMsgAmount: "待处理会员消息",
        rechargeApplyAmount: "待审核充值申请",
        refundOrder: "待审核退款订单",
        staAmount: "待审核充电站",
        unusedEquipmentAmount: "待关联站点设备",
        outConfirm: "确定要退出登录吗？",
        upSuccess: "修改成功，请重新登录",
    },
    // 查看账号信息组件
    queryAccount: {
        loginUrl: "登录信息",
        userName: "登录账号",
        passwordShow: "登录密码",
        infoPl: "注：请保存好登录信息，若遗忘密码请点击重置；",
        copy: "快速复制",
        close: "关闭",
    },
    // 操作密码
    safePassword: {
        title: "请输入操作密码确认此项操作",
        password: "密码",
        noPassword: "忘记密码？",
        passwordPl: "请输入密码",
    },
    // 验证
    regular: {
        name: "名称",
        please: "请输入",
        pleaseSelect: "请选择",
        max: "不能超过",
        maxText: "个字符",
        min: "不能少于",
        numberABC: "只能由数字或者字母组成",
        number_ABC: "只能由数字+字母+下划线组成",
        tel: "请输入手机号码或者座机号码，7-15位",
        phone: "请输入电话",
        phonePl: "请输入手机号码",
        phonePl11: "请输入11位数字的手机号码",
        phoneError: "请输入正确格式的手机号码",
        int: "只能是整数数字",
        maxInput: "最多输入",
        minInput: "最少输入",
        unit: "位",
        maxNum: "不能大于",
        minNum: "不能小于",
        money: "金额",
        towDecimal: "最多保留两位小数",
        email: "请输入邮箱",
        emailPl: "邮箱不能超过",
        emailError: "请填写正确的邮箱",
        passwordPl: "请输入密码",
        passwordError: "密码必须包含字母和数字且长度在8-16之间，请重新输入",
    },
    //个人会员
    memberList: {
        cardStatus: "充电卡状态",
        userNameAndPhone: "用户名称/手机",
        carNoAndvin: "车牌号/VIN码(精确查询)",
        userLevel: "用户等级",
        userName: "用户名称",
        account: "账户号",
        phone: "手机号",
        carNo: "车牌号",
        vin: "VIN码",
        accountBalance: "账户余额(元)",
        accountFrozen: "冻结金额(元)",
        residueIntegral: "剩余积分",
        registrationDate: "注册时间",
        userAmount: "个人用户总数（个）",
        relevanceCard: "关联电卡用户（个）",
        relevance: "已关联",
        notRelevanceCard: "未关联",
        memberExport: "用户导入",
        memberExportTpl: "用户导入模板",
        startGet: "读卡",
        closeGet: "取消读卡",
        cardNumber: "卡号",
        serialNumber: "流水号",
        relation: "关联",
        reset: "重置",
        getLoading: "读取中······",
        cardNumberPl: "请输入卡号",
        getError: "读卡失败，请检查读卡器连接或更换卡片重新关联",
        rechargeAmount: "充值金额(元)",
        rechargeSuccess: "充值完成",
        rechargeSuccessTips: "请等待审核，充值金额审核通过后即刻到账",
        refundAmount: "退款金额",
        refund: "退款",
        maxMoney: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        vipLevel: "等级调整",
        vipDays: "等级时长",
        vipLevelPl: "请选择等级",
        vipDaysPl: "请选择等级时长",
        allOpen: "批量开启一号多充",
        allClose: "批量关闭一号多充",
        multiCharge: "一号多充状态",
        availableAmount: "可用余额(元)",
        isEnt: "是否为企业会员",
        totalBalance: "当前用户账户余额（元）",
        totalFrozenAmount: "账户冻结金额（元）",
        vipEndTime: "到期时间",
        add: "等级调整",
        expired: "已失效",
        tab1: "当前等级",
        tab2: "已失效等级",
        purchaseWay: "获取方式",
        effectStatus: "当前状态",
        vipBeginTime: "生效时间",
        remainDays: "剩余天数",
        transactionTime: "操作时间",
        operatorName: "操作人",
        expCauseName: "失效原因",
        expireTime: "失效时间",
        auditMoney: "审核中充值金额(元)",
        refundableAmount: "可退金额(元)",
        blacklistBtn: "移入黑名单",
        isBlackUser: "黑名单状态",
        moveBlackListTime: "移入时间",
        moveBlackListTimeEnd: "移入到期时间",
        moveOut: "移出",
        moveOutUser: "用户名：",
        moveOutConfirm: "确定要将该用户移出黑名单吗？",
        BlacklistedUsers: "黑名单用户",
        blackListEndTime: "到期时间",
        cycleBtn: "会员周期",
        reason: "加入黑名单原因",
        enterReason: "请输入加入黑名单原因",
        isLoginAllowed: "是否允许登录",
        chooseNoTip: "选择否，则被移入黑名单的用户无法进行登录。",
        restrictSites: "限制站点",
        restrictSitesTip: "用户将无法在所选站点进行充电",
        enterUserName: "请输入用户名",
        enterPhoneNo: "请输入手机号",
        confirmChangeCommonVip: "确认调整为普通会员",
        confirmChangeCommonVipTip: "若该用户存在多个待生效会员，调整为普通会员后将一并失效",
        refundTip: "注：平台退款只清除用户账户余额，无法原路退回，实际金额请线下（转账、现金等）方式退回给用户。",
        freezeType: "冻结类型",
        importResult: "校验结果",
        importTotal: "校验总数：",
        successTotal: "校验成功：",
        failTotal: "校验失败：",
        wechatUnionID: "微信unionID",
        wechatAvatarUrl: "用户头像地址",
        failReason: "错误原因",
        importTip: "一次性最多可导入500条数据，超过将无法导入",
        success: "成功",
        fail: "失败",
        importFailTip: "一次导入数据超过500条，无法导入",
        importSuccessTip: "导入用户成功",
    },
    // 会员列表--详情
    memberDetails: {
        memberInfo: "用户信息",
        male: "男",
        female: "女",
        mergerName: "地区",
        createTime: "注册时间",
        accInfo: "账户信息",
        cardVin: "车牌号与VIN",
        cardStatus: "电卡状态",
        otherInfo: "其他信息",
        vipEndTime: "用户到期时间",
        points: "用户当前积分",
        memberCoupon: "用户优惠券",
        cardPkId: "卡号",
        cardSerialNumber: "电卡流水号",
        cardPhysicalNumber: "电卡序号",
        silkScreenNumber: "丝印编号",
        operationTime: "操作时间",
        createUserName: "创建人名称",
        operateType: "操作类型描述",
        releaseTime: "领取日期",
        endTime: "过期日期",
        hasUsed: "当前状态",
        entTitle: "用户企业信息",
        entName: "所属企业",
        hasUseEntAccountDesc: "支付方式",
        hasAdminDesc: "是否是管理员",
        elecFeeType: "企业电费",
        dcElecFee: "直流桩电费",
        acElecFee: "交流桩电费",
        serviceFeeType: "企业服务费",
        dcServiceFee: "直流桩服务费",
        acServiceFee: "交流桩服务费",
        entBeginTime: "开始时间",
        entEndTime: "结束时间",
    },
    // 会员列表--资金记录
    memberMoneyRecord: {
        tab1: "充电",
        tab2: "充值",
        tab3: "退款",
        tab4: "资金操作日志",
        rechargeAmount: "充值总金额（元）",
        refundAmount: "退款总金额（元）",
        chargeAmount: "充电总金额（元）",
        shoppingAmount: "购买会员（元）",
        balanceAmount: "当前总余额（元）",
        transactionTime: "操作时间",
        flowType: "操作类型",
        transactionChannel: "操作渠道",
        beforeBalance: "操作前余额（元）",
        transactionAmount: "操作金额（元）",
        afterBalance: "操作后余额（元）",
        orderNo: "相关订单号",
    },
    // 会员列表 - 风险金列表
    memberListMoneyRiskFund: {
        flowType: "流水类型",
        transactionTime: "交易时间",
        transactionAmount: "交易金额",
        beforeBalance: "交易前金额",
        afterBalance: "交易后金额",
        orderType: "订单类型",
        remark: "备注",
        riskAmount: "当前风险金额(元)",
    },
    // 会员列表 - 会员周期
    membershipCycle: {
        days: "会员天数",
        effectiveStatus: "会员状态",
        beginTime: "开始时间",
        endTime: "失效时间",
        expCause: "失效原因",
    },
    //企业会员
    corporateMemberList: {
        enterpriseName: "企业名称",
        enterpriseAmount: "企业会员总数(个)",
        enterpriseUserAmount: "现有成员数(人)",
        enterprisePayUser: "企业支付成员数(人)",
        rechargeTotalMoney: "充值总金额(元)",
        chargeTotalMoney: "充电总金额(元)",
        station: "站点(个)",
        userUpperLimit: "成员上限",
        account: "账户号",
        accountBalance: "账户余额(元)",
        accountFrozen: "冻结金额(元)",
        chargeTotalMoneyTips: "企业支付总金额",
        unifiedDivision: "统付组分成状态",
        unifiedOrder: "统付订单",
    },
    //非实名在线卡
    nonRealNameCardManagement: {
        cardPkId: "卡号",
        cardMember: "电卡会员(人)",
        cardStatus: "电卡状态",
        inUse: "使用中",
        cancelled: "已注销",
        operationStatistics: "归属统计",
        selfSupport: "运营商自营",
        generationCamp: "代营商户",
        fuzzySearch: "流水号/电卡序号/联系人/联系电话",
        cardAffiliation: "卡片归属",
        commercialTenant: "商户",
        cardNumber: "电卡会员号",
        cardPhysicalNumber: "电卡序号",
        cardSerialNumber: "流水号",
        contacts: "联系人",
        phone: "联系电话",
        cardBalance: "卡内余额(元)",
        frozenAmount: "冻结金额(元)",
        openTime: "开卡时间",
        remark: "备注",
        money: "开卡金额",
        openCardTips: "请保持发卡器与电脑正常连接，并将卡片放置于发卡器上",
        openCardError: "该充电卡已被使用！请更换卡片",
        cardPhysicalNumberPl: "请输入电卡序号",
        cardSerialNumberPl: "请输入流水号",
        moneyPl: "请输入充值金额",
        moneyMax: "一次性充值金额不能多于5000",
        moneyMin: "一次性充值金额不能少于0",
        moneyError: "开卡金额必须数字且小数位不超过两位",
        openCardSuccess: "开卡成功",
        balance: "余额",
        amount: "金额",
        cancellation: "注销",
        cancellationTips: "注销后卡内金额将自动全额退款，充电卡将无法使用",
        cancellationSuccess: "注销成功",
        accountBalance: "账户余额(元)",
        createUserName: "开卡人",
        createTime: "开卡时间",
        status: "电卡状态",
        operationInfo: "操作信息",
        cardInfo: "电卡信息",
        cardDetails: "非实名卡详情",
        remarkPl: "请输入备注",
        createName: "操作人",
        operateTime: "操作时间",
        operateType: "操作",
        rechargeAmount: "充值金额(元)：",
        allMoneyMax: "在线卡最大金额不能超过9999元",
        accountPkId: "会员卡号",
        refundAmount: "退款金额(元)",
        refundBtn: "退款",
        refundError: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        silkScreenNumber: "丝印编号",
        getCard: "读卡",
        input: "直接录入",
        reset: "重置",
        cardExist: "卡已存在，请先注销或者换一张卡再执行开卡操作",
        openCard: "开卡",
        silkScreenNumberPl: "请输入丝印编号",
        contactsPl: "请输入联系人",
        cardYes: "此卡可以操作",
        logout: "销卡",
        viewNo: "您的浏览器不支持发卡系统",
        connectError: "发卡器连接失败",
        logoutSuccess: "销卡成功",
        cardChange: "卡片已更换，请重新读卡",
        cardWhite: "此卡是空白卡",
        statusError1: "请先读卡再操作",
        statusError2: "未检测到充电卡,请重新操作",
        statusError3: "客户编码不能为空",
        statusError4: "卡类型不能为空",
        statusError5: "ID不能为空",
        statusError6: "卡Id只能是16位数字",
        statusError7: "非本系统卡，无法操作！",
        logoutTitle: "此操作销毁此卡的所有信息,请谨慎操作",
        connectBtn: "连接发卡器",
        connectBtnLoading: "正在连接发卡器……",
        cardBind: "此卡已使用，请换一张未使用过的卡片,流水号: ",
        relation: "关联",
        userName: "会员名称",
        cardNumberPl: "请输入卡号",
        relationSuccess: "关联成功",
        hasSms: "是否发送短信",
        hasSmsPl: "请选择是否发送短信",
        word: "温馨提示：操作使用说明文档",
        wordDownload: "点击此处下载",
        confirmStop: "确定要停用吗?",
        confirmStart: "确定要启用吗?",
        readCardTips: "请先读取可使用的充电卡",
        connect: "发卡器已连接",
    },
    // 发卡下载提示
    cardTips: {
        t1: "1.下载并安装发卡器驱动",
        download: "点击此处下载",
        t1_1: "XP系统请",
        t2: "2.将读卡器通过USB线连接计算机，正常上电后读卡器会'哔'一声并保持读卡器内部LED灯闪。",
        t3: "3.下载并运行发卡器插件(",
        t3_1: ")，连接读卡器之后点击'开启服务'即可。",
        t4: "4.打开浏览器的发卡管理进行相关操作。",
        tips: "注意事项：",
        tips1: "1.目前支持Windows操作系统，Windows 7/10各系列版本。",
        tips1_1: "如要在Windows XP下使用需要安装.net3.5框架",
        tips2: "2.运行过程中必须确保发卡器插件持续开启服务状态。",
        tips3: " 3.提示“检查是否插入读卡器或是否安装串口驱动”时，一般是没有插上读卡器或者串口驱动未安装的问题，右键“我的电脑” 选择 “管理” ，再弹出的 “计算机管理” 窗口中，点击左边菜单的“设备管理器” 后，查看 “其它设备” 下是否存在 “USB Serial Port” 或 “FT232RUSR UART”。如果没有，说明读卡器没插上，换个USB口试一试；",
    },
    //一号多充
    oneToMoreAudit: {
        phone: "手机号码",
        nickName: "昵称",
        applyTime: "申请时间",
        applyCause: "申请原因",
        auditTime: "审核时间",
        status: "状态",
        auditUserName: "审核人",
        total: "总申请量",
        totalPending: "待审核量",
        totalAudit: "审核不通过量",
        totalExamination: "审核通过量",
    },
    //站点监控
    siteMonitor: {
        province: "省",
        city: "市",
        type: "类型",
        power: "功率",
        equipmentAmount: "设备数量(个)",
        gun: "枪",
        number: "编号",
        voltage: "电压",
        current: "电流",
        outPower: "输出功率",
        chargeElect: "充电电量",
        totalPower: "累计充电量",
        thisPower: "当前输出功率",
        setPower: "设置输出功率",
        totalTimes: "累计充电次数(次)",
        totalHours: "累计充电时长",
        accountPkId: "充电账号",
        accountType: "账户类型",
        carVin: "车辆VIN码",
        chargedMinutes: "充电时长",
        chargingPower: "充电电量",
        predictAmount: "充电金额",
        faultInfo: "故障信息",
        totalOprMch: "运营商/站点数量(个)",
        totalMchSta: "商户/站点数量(个)",
        totalMch: "商户",
        totalSite: "站点",
        totalGun: "充电枪",
        totalGunStatus: "充电桩状态",
        queryAll: "查看全部",
        mchAmount: "商户数",
        staAmount: "充电站数",
        devNum: "设备数量",
        dcPileAmount: "直流桩数",
        acPileAmount: "交流桩数",
        gunAmount: "充电枪数",
        devStatus: "设备状态",
        onlinePileAmount: "上线桩数",
        offlinePileAmount: "下线桩数",
        gunStatus: "枪状态",
        freeGunAmount: "空闲枪数",
        chargedGunAmount: "插枪数",
        chargeGunAmount: "正在充电数",
        completedGunAmount: "完成数",
        offlineGunAmount: "离线枪数",
        faultGunAmount: "故障枪数",
        stopGunAmount: "禁用枪数",
        reservedGunAmount: "预约枪数",
        staName: "站点名称",
        pileStatus: "桩状态",
        qrderlyCharging: "有序充电策略",
        strategyName: "充电策略",
        strategyStatus: "策略状态",
        strategyType: "策略类型",
        groupMaxOutputPower: "组内最大允许输出功率",
        groupPileNum: "组内桩数",
        open: "展开",
        close: "收起",
        pileType: "充电桩类型",
        orderDetails: "订单详情",
        allStatus: "全部状态",
        gunChange: "点击切换",
        totalElec: "累计充电量(kWh)",
        electricity: "当前电流(A)",
        thisChargingPower: "当前充电电量(kWh)",
        online: "上线",
        offline: "下线",
        gunTotal: "枪总数(支)",
        soc: "当前soc",
        thisVoltage: "当前电压",
        gunAllData: "枪累计",
        gunThisData: "枪当前",
        parkNo: "车位号",
        multipleDCPileAmount: "分体直流",
    },
    //告警通知
    alertNotification: {
        strategyName: "策略名称",
        sendWay: "通知方式",
        alarmCount: "事件内容数",
        staCount: "充电站数",
        modifyTime: "更新时间",
        status: "当前状态",
        faultCodes: "事件内容",
        generalLevel: "一般等级",
        noSelect: "未选择",
        emergencyLevel: "紧急等级",
        severityLevel: "严重等级",
        staPkId: "指定站点",
        checkSite: "勾选站点",
        wx: "公众号",
        msg: "短信",
        wxPeople: "公众号通知人员",
        phonePl: "输入手机号多个号码用,号隔开",
        msgPeople: "短信通知人员",
        staPkIdsPl: "请选择指定站点",
        sendWaysPl: "请选择通知方式",
        faultCodesPl: "请输入至少选择一个事件内容",
        msgPeoplePl: "请输入通知人员手机号码",
        phoneError: "号码格式错误，号码之间用 ',' 号隔开",
        phoneMax: "号码不能超过5组",
        strategyTotal: "策略总数",
        faultTotal: "事件内容总数",
        normalTotal: "一般等级告警",
        urgentTotal: "紧急等级告警",
        seriousTotal: "严重等级告警",
        smsTotal: "短信通知",
        weChatTotal: "公众号通知",
    },
    //事件告警
    alarmEvent: {
        alarmTime: "告警时间",
        eventAmount: "事件总数",
        todayEvent: "今日事件",
        alarmRatio: "告警比例",
        alarmLevel: "告警级别",
        alarmType: "告警类型",
        equipmentAlarmAmountTop5: "设备故障告警次数TOP5",
        stationAlarmAmountTop5: "站点告警次数TOP5",
        equipmentSn: "设备sn",
        stationName: "站点名称",
        quantity: "次数",
        faultDesc: "事件描述",
        recoverTime: "恢复时间",
        duration: "异常时间",
        alarmStatus: "当前状态",
        equipmentType: "设备类型",
    },
    //站点报表
    siteReport: {
        stationName: "站点名称",
        dcPileNumber: "直流桩数(个)",
        acPileNumber: "交流桩数(个)",
        sharpPower: "尖时电量(kWh)",
        peakPower: "峰时电量(kWh)",
        flatPower: "平时电量(kWh)",
        valleyPower: "谷时电量(kWh)",
        totalAmount: "累计总金额(元)",
        totalChargingMinutes: "累计充电时长(分钟)",
        totalChargingTimes: "累计充电次数(次)",
        totalElecAmount: "累计充电电费(元)",
        totalPower: "累计充电量(kWh)",
        totalSeviceAmount: "累计服务费(元)",
        billGenerationDate: "账单生成日期",
        billCreateDate: "报表创建日期",
    },
    //电桩报表
    pileReport: {
        pilePkId: "桩编号",
        pileName: "桩名称",
        stationName: "站点名称",
        totalGunNumber: "枪数",
        totalChargingTimes: "累计充电次数(次)",
        totalAmount: "累计总金额(元)",
        totalChargingMinutes: "累计充电时长(分钟)",
        totalElecAmount: "累计充电电费(元)",
        totalPower: "累计充电量(kWh)",
        totalSeviceAmount: "累计服务费(元)",
        billGenerationDate: "账单生成日期",
        billCreateDate: "报表创建日期",
        statisticalTime: "统计周期",
        details: "明细",
        totalDelayAmount: "累计占桩费(元)",
        tab1: "站桩报表",
        tab2: "站桩报表明细",
    },
    //渠道报表
    channelReport: {
        stationName: "站点名称",
        orderQuantity: "订单数量",
        totalAmount: "累计总金额(元)",
        totalChargingMinutes: "累计充电时长(分钟)",
        totalChargingTimes: "累计充电次数(次)",
        totalElecAmount: "累计充电电费(元)",
        totalPower: "累计充电量(kWh)",
        totalSeviceAmount: "累计服务费(元)",
        billGenerationDate: "账单生成日期",
        billCreateDate: "报表创建日期",
    },
    //企业报表
    kaReport: {
        enterpriseName: "企业名称",
        totalAmount: "累计总金额(元)",
        totalChargingMinutes: "累计充电时长(分钟)",
        totalChargingTimes: "累计充电次数(次)",
        totalElecAmount: "累计充电电费(元)",
        totalPower: "累计充电量(kWh)",
        totalSeviceAmount: "累计服务费(元)",
        billGenerationDate: "账单生成日期",
        billCreateDate: "报表创建日期",
        timeError: "结束时间不能超过昨天",
    },
    //站点核算
    siteAccounting: {
        accountingTimeRange: "核算时间范围",
        qualifyingDays: "合格",
        failedDays: "不合格",
        accountingDate: "核算日期",
        totalPowerConsumptionForTheCurrentPeriod: "本期总耗电量(kWh)",
        totalPowerAtTheBeginningOfThePeriod: "本期起始总电量(线上 + 线下)",
        totalElectricityConsumptionDuringSharpHours: "本期尖时段总耗电量(kWh)",
        totalElectricityConsumptionDuringPeakHours: "本期峰时段总耗电量(kWh)",
        totalElectricityConsumptionDuringShoulderHours: "本期平时段总耗电量(kWh)",
        totalElectricityConsumptionDuringOffPeakHours: "本期谷时段总耗电量(kWh)",
        accountingError: "核算误差",
        formula: "公式",
        absoluteError: "核算误差",
        accountingResults: "核算结果",
        pleaseSelectAChargingStationFirst: "请先选择充电站",
        electricityAccounting: "电量核算",
        amountAccounting: "金额核算",
        totalAmount: "本期总充电金额（元）",
        sharpAmount: "本期尖时段总充电金额（元）",
        peakAmount: "本期峰时段总充电金额（元）",
        flatAmount: "本期平时段总充电金额（元）",
        valleyAmount: "本期谷时段总充电金额（元）",
        toleranceScope: "误差范围",
        and: "并",
        electAmount: "充电费（元）",
        seviceAmount: "服务费（元）",
    },
    //运营核算
    operationalAccounting: {
        accountingTimeRange: "核算时间范围",
        totalAmountOfUserCharging: "本期余额充电总金额(元)",
        totalAmountOfUserRecharge: "本期用户充值总金额(元)",
        totalAmountOfUserRefunds: "本期用户退款总金额(元)",
        totalUserBalanceOfThePreviousPeriod: "上期用户总余额(元)",
        totalUserBalanceForTheCurrentPeriod: "本期用户总余额(元)",
        totalShoppingAmount: "本期用户消费总金额(元)",
        totalShoppingAmountTips: "消费包括购买会员、商品等除充电之外的其它消费",
        endAmount: "本期用户总金额(元)",
        accountingError: "核算误差(元)",
        accountingResults: "核算结果",
        qualified: "合格",
        unqualified: "不合格",
        formula: "核算公式",
        toleranceScope: "误差范围",
        rechargeAccounting: "充值核算",
        refundAccounting: "退款核算",
        orderTracking: "订单查询",
        theEndTimeCannotBeLessThanTheStartTime: "结束时间不能少于开始时间",
        startAndEndTimesCannotBeEmpty: "开始时间,结束时间都不能为空",
        chargeAmount: "充电金额",
        rechargeAmount: "充值金额",
        refundAmount: "退款金额",
        consumptionAmount: "消费金额",
        currencyUnit: "元",
        amount: "金额",
        totalReservationAmount: "本期用户预约充电总金额(元)",
        totalPostPaidAmount: "本期用户先充后付充电总金额(元)",
    },
    //用户核算
    userAccounting: {
        userType: "用户类型",
        selectUser: "用户选择",
        accountingTimeRange: "核算时间范围",
        currentUserBalance: "本期用户余额(元)",
        totalAmountOfUserRecharge: "本期用户充值总金额(元)",
        totalAmountOfUserRefunds: "本期用户退款总金额(元)",
        totalAmountOfUserCharging: "本期余额充电总金额(元)",
        totalUserBalanceOfThePreviousPeriod: "上期用户总余额(元)",
        totalUserBalanceForTheCurrentPeriod: "本期用户总余额(元)",
        accountingError: "核算误差(元)",
        accountingResults: "核算结果",
        qualified: "合格",
        unqualified: "不合格",
        formula: "公式",
        toleranceScope: "误差范围",
        normal: "正常",
        abnormal: "异常",
        userName: "用户名称",
        accountID: "账户ID",
        rechargeThisPeriod: "本期充值（元）",
        refundForThisPeriod: "本期退款（元）",
        currentChargeAmount: "本期充电（元） ",
        theBalanceOfThePreviousPeriod: "上期余额（元）",
        balanceForThePeriod: "本期余额（元）",
        accountingErrorPercentage: "核算误差(%)",
        beginTime: "核算时间",
        totalChargeAmount: "本期用户余额充电总金额(元)",
        totalReservationAmount: "本期用户预约充电总金额(元)",
        totalPostPaidAmount: "本期用户先充后付充电总金额(元)",
        totalShoppingAmount: "本期用户消费总金额(元)",
    },
    //充值核算
    rechargeAccounting: {
        rechargeChannels: "充值渠道",
        accountingResults: "核算结果",
        accountingTimeRange: "核算时间范围",
        fix: "修正",
        accountID: "账户ID",
        numberOfRechargeOrders: "本期充值总订单数(个)",
        totalRecharge: "本期充值总金额(元)",
        // numberOfAbnormalOrders: "异常订单数(个)",
        // abnormalTotalAmount: "异常总金额(元)",
        accountingTime: "核算时间",
        fullName: "会员名字",
        phoneNo: "会员手机号",
        createTime: "充值时间",
        orderNo: "商户订单号",
        outOrderAmount: "微信充值金额（元）",
        OrderNo: "平台订单号",
        orderAmount: "平台记账金额（元）",
        differentAmount: "差值金额（元）",
        fixType: "修正类型",
        recharge: "充值",
        deduction: "扣费 ",
        tel: "管理员手机",
        fixMoney: "修正金额",
        fixOrder: "修正订单号",
    },
    //退款核算
    refundAccounting: {
        refundChannel: "退款渠道",
        accountingResults: "核算结果",
        accountID: "账户ID",
        numberOfRefundOrders: "本期退款总订单数(个)",
        totalAmountOfRefund: "本期退款总金额(元)",
        numberOfAbnormalOrders: "异常订单数(个)",
        totalAbnormalAmount: "异常总金额(元)",
        accountingTime: "核算时间",
        operation: "操作",
        fix: "修正",
    },
    //财务统计
    statistics: {
        financeStatistics: "财务统计",
        stationName: "站点名称",
        selectionTime: "选择时间",
        bind: "绑定",
        edit: "编辑",
        logout: "注销",
        history: "历史",
        chargingStation: "充电站",
        chargingStationAddress: "充电站地址",
        chargingTime: "充电时长",
        chargeVolume: "充电量(度)",
        basicElectricityBill: "基本电费(元)",
        serviceCharge: "服务费(元)",
        delayFee: "占桩费(元)",
        discountAmount: "优惠金额(元)",
        actualAmount: "实收金额(元)",
        totalNumberOfOrders: "合计订单数",
        numberOfGuns: "枪数(支)",
        usageRate: "使用率",
        pleaseChooseATime: "请选择时间",
        pileNum: "桩数(个)",
        usageRate2: "利用率",
        proportion: "占比",
        transAmount: "总实收（元）",
        serviceAmount: "总服务费（元）",
        elecAmount: "总电费（元）",
        delayAmount: "总占桩费（元）",
        totalDiscount: "总优惠（元）",
        tab1: "财务总览",
        tab2: "电费贡献",
        tab3: "服务费贡献",
        tab4: "占桩费贡献",
        incomeElecAmount: "实收电费(元)",
        incomeServiceAmount: "实收服务费(元)",
        incomeDelayAmount: "实收占桩费(元)",
    },
    //分成结算
    splitSettlement: {
        settlementType: "分成规则类型",
        settlementType1: "线下",
        settlementType2: "线上",
        shareSettlement: "分成结算",
        orderBreakdown: "订单分成明细",
        merchantName: "商户名称",
        chargingOrderNumber: "充电订单号",
        selectionTime: "选择时间",
        chargingStation: "充电站",
        chargeVolume: "充电量",
        electricityBill: "电费",
        serviceCharge: "服务费",
        chargeableAmount: "应付充电金额",
        discountAmount: "优惠金额",
        totalAmountActuallyPaid: "实付总金额",
        partitionMethod: "分成方式",
        merchantIncome: "商户收入",
        operatorShare: "运营商分成",
        orderDate: "订单核算日期",
        orderTimeError: "订单时间不能为空，请选择",
        errorStartTimeEndTime: "开始时间不能大于结束时间",
        contentConfirm: "确认要同意选中的数据吗？？",
        successfulOperation: "操作成功",
        daySettlementOrderNumber: "日结订单号",
        dailyStatementStatus: "日结单状态",
        settlementDate: "结算日期",
        numberOfOrders: "订单笔数",
        actualChargeAmount: "实付充电金额",
        merchantIncomeAmount: "商户收入金额",
        operatorShareAmount: "运营商分成金额",
        createTime: "生成日期",
        pleaseSelectTheGenerationDate: "请选择生成日期",
        createTimeError: "生成日期开始时间不能大于结束时间",
        selectMonth: "请选择月结月份",
        confirmDate: "确认要确认选中的数据吗？",
        confirmGeneration: "确认重新核算吗？",
        confirmGenerationError: "日结单中包含多个商户，当前只支持同一商户批量重新生成日结单",
        withdrawnDate: "确认要撤回选中的数据吗？",
        selectDate: "确认要操作选中的数据吗？",
        selectDateToOperate: "请选择要操作的数据",
        deleteTitle: "作废原因",
        remarkPl: "请输入原因",
        supplement: "补单",
        orderNo: "选择日结订单号",
        orderNoPl: "请选择订单",
        staName: "充电站",
        settlementStatus: "核算状态",
        regenerate: "重新生成",
        regenerateConfirm: "重新生成",
        allSettlement: "批量核算",
        settlement: "核算",
        settlementNew: "重新核算",
        errorInfo: "异常信息",
        accountingRecords: "核算记录",
        accountingRecordsStatus: "核算状态",
        accountingRecordsRepairStatus: "修复状态",
        accountingRecordsTime: "结算日期",
        initialAccounting: "初次核算",
        newAccounting: "最新核算",
        ComparisonResults: "对比结果差额",
        settlementNewConfirm: "重新核算选择的数据吗？",
        settlementConfirm: "核算日结单",
        settlementConfirmError: "日结单中包含多个商户，当前只支持同一商户批量核算日结单",
        exceptionDifference: "异常差额",
        drawCashOrderStatus: "提现状态",
        drawCashOrderStatus1: "已提现",
        drawCashOrderStatus2: "未提现",
        exportMch: "导出(请选择商户)",
    },
    //商户提现
    withdrawal: {
        withdrawalOverview: "提现概览",
        withdrawOrder: "提现明细",
        addWithdrawal: "新增提现单",
        totalNumberOfMerchants: "总商户数（个）",
        totalChargeAmount: "充电金额总计（元）",
        amountOfCashWithdrawn: "已提现金额（元）",
        undrawnCash: "未提现金额（元）",
        merchantName: "商户名称",
        chargeAmount: "充电金额总计",
        cashWithdrawal: "已提现金额",
        undrawn: "未提现金额",
        pendingWithdrawalOrder: "待审核提现单",
        beSettledOrderCount: "待结算结算单",
        abnormalSettledOrderCount: "结算异常结算单",
        numberOfWithdrawals: "已提现次数",
        dateOfTheMostRecentWithdrawal: "最近提现日期",
        pendingPaymentWithdrawalOrder: "待付款提现订单（条）",
        paidWithdrawalOrder: "已付款提现单（条）",
        comprehensiveScreening: "综合筛选",
        withdrawOrderStatus: "提现单状态",
        createTime: "生成日期",
        reviewDate: "审核日期",
        withdrawOrderTemplate: "提现单模板",
        withdrawOrderNumber: "提现单编号",
        withdrawalAmount: "提现金额",
        transferFee: "转账手续费",
        actualWithdrawalAmount: "实际提现金额",
        paymentDate: "付款日期",
        readyToPay: "确定已经准备付款了吗？",
        successfulOperation: "操作成功",
        noAttachments: "暂无附件",
        reason: "中止",
        reasonTitle: "中止原因",
        abortedReasonPl: "请输入原因",
        withdrawOrderBtn: "提现单",
        payVoucher: "付款凭证",
        payVoucherPl: "请上传凭证",
    },
    //会员充值
    memberRecharge: {
        arrivalTime: "到账时间",
        numberOfTopUpUsers: "充值用户数（个）",
        rechargeAmount: "充值金额",
        rechargeTimes: "充值次数（次）",
        rechargeMethodAmountRatio: "充值方式金额比例",
        memberName: "会员名称",
        cellphoneNumber: "手机号码",
        orderNumber: "商户订单号或支付订单号",
        rechargeMethod: "充值方式",
        operatorCode: "运营商代码",
        operatorName: "运营商名称",
        memberNo: "会员号",
        memberPhoneNumber: "会员手机号",
        merchantOrderNumber: "商户订单号",
        paymentOrderNumber: "支付订单号",
        rechargeTime: "充值时间",
        orderStatus: "订单状态",
        accountingCorrection: "核算修正",
        wechatPay: "微信支付",
        cashRecharge: "现金充值",
        rechargeInformation: "充值信息",
        typeOfMembership: "会员类型",
        transferVoucher: "转账凭证",
        reviewInformation: "处理信息",
        // reviewer: "审核人",
        // reviewTime: "审核时间",
        // auditResults: "审核结果",
        remark: "备注",
        reasonForRejection: "驳回原因",
        reasonForRejectionPl: "请输入原因",
        auditConfirm: "确定要审核通过吗?",
        allAudit: "批量审核",
        allAuditStatus: "审核状态",
        allAuditStatusPl: "请选择审核状态",
        processingTime: "处理时间",
        processingAction: "处理动作",
        auditUserName: "处理人",
        refundStatus: "当前状态",
        auditPass: "审批通过",
        auditReject: "审批拒绝",
        alipayRecharge: "支付宝充值",
        xlRecharge: "信联充值",
        ccbRecharge: "建行充值",
    },
    //退款记录
    refundRecords: {
        pageTitle: "退款记录",
        refundApplicationTime: "退款申请时间",
        refundOrderQuantity: "退款订单数量（笔）",
        refundAmount: "退款金额（元）",
        orderStatus: "订单状态",
        globalSearch: "订单号/账户号/手机号",
        accountType: "账户类型",
        refundMethod: "退款方式",
        pendingReview: "待审核",
        rejected: "已拒绝",
        returned: "已退回",
        paymentFailed: "支付失败",
        nonPaymentNumber: "未支付",
        passed: "已通过",
        orderNumber: "订单号",
        accountNumber: "账户号",
        accountName: "账号名称",
        phoneNumber: "手机号",
        amountOfRefundRequested: "申请退款金额",
        successfulRefundAmount: "已支付退款金额",
        uploadCertificate: "上传凭证",
        transferVoucher: "转账凭证",
        pleaseUploadAPicture: "请上传图片",
        successfulOperation: "操作成功",
        refundReview: "退款审核",
        refundReviewPl: "请选择退款审核方式",
        refundNoteText: "退款说明文字",
        refundNoteTextPl: "请输入退款说明文字",
        autoText: "退款权限",
        autoTextPl: "请选择退款权限方式",
        refundRecordDetails: "退款记录详情",
        applicationInformation: "申请信息",
        processingInformation: "处理信息",
        reviewInformation: "审核信息",
        refundOrderStatus: "退款订单状态",
        remark: "备注",
        refundDetails: "退款明细信息",
        refundFailed: "退款失败",
        refundSuccessfully: "退款成功",
        agreeToARefund: "同意退款",
        refusalToRefund: "拒绝退款",
        enterReason: "请输入拒绝退款理由",
        processingTime: "处理时间",
        processingAction: "处理动作",
        processResult: "处理结果",
        detailedOrderNumber: "明细订单号",
        amount: "金额",
        refundTime: "退款支付时间",
        result: "结果",
        refundToUser: "退款至用户",
        refundErrResult: "原因",
        allAudit: "批量审核",
        allAuditType: "审核类型",
        rejectRemark: "拒绝理由",
        auditUserName: "处理人",
        refundStatus: "当前状态",
        refundType: "退款类型",
        refundStatusName: "退款状态",
        noHandleData: "暂无处理信息",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "申请时间",
        globalSearch: "订单号/手机号",
        invoiceType: "发票类型",
        invoicingStatus: "开票状态",
        auditSettings: "审核设置",
        invoiceOrderNumber: "发票订单号",
        invoiceHeaderType: "抬头类型",
        invoiceTitle: "发票抬头",
        taxNumber: "税号",
        invoiceAmount: "开票金额",
        phoneNumber: "手机号",
        invoicing: "开票",
        invoiceUserName: "开票用户",
        issuer: "开票人",
        processingMethod: "处理方式",
        courierCompany: "快递公司",
        shipmentNumber: "物流单号",
        remark: "备注",
        haveBeenMailed: "邮寄",
        noNeedToMail: "无需邮寄",
        enterIssuer: "请输入开票人",
        selectMethod: "请选择开票方式",
        validationError: "表单验证错误",
        selectAddress: "请输入邮寄地址",
        enterNumber: "请输入邮寄订单号",
        orderNumberLength: "邮寄订单号长度不得小于八位",
        invoiceSuccessful: "开票成功",
        numberOfInvoices: "已开票数量（张）",
        electronicInvoice: "电子发票",
        paperInvoice: "纸质发票",
        totalInvoicedAmount: "已开票总金额（元）",
        invoicedServiceFee: "已开票服务费（元）",
        invoicedElectricityBill: "已开票电费（元）",
        invoiceReviewProcess: "发票审核流程",
        on: "开启",
        close: "关闭",
        selectionProcess: "请选择发票审核流程",
        setSuccessfully: "设置成功",
        invoiceInformation: "发票信息",
        serviceCharge: "服务费(元)",
        electricityBill: "电费(元)",
        eMail: "电子邮箱",
        receivingInformation: "接收信息",
        invoicingInformation: "开票信息",
        processingTime: "处理时间",
        invoiceSerialNumber: "发票流水号",
        payee: "收款人",
        reviewer: "复核人",
        unit: "单位",
        invoicePicture: "发票图片",
        shippingAddress: "收件地址",
        denialReason: "请输入拒绝原因",
        orderNumber: "订单号",
        delayFee: "占桩费（元）",
        discountedPrice: "优惠金额（元）",
        amountActuallyPaid: "实付金额（元）",
        reviewCompleted: "审核完毕",
        invoiceOperator: "发票运营商",
        invoiceOrder: "发票订单",
        invoiceAuditRecord: "审核记录",
        operationTime: "操作时间",
        operationStatus: "处理动作",
        operation: "处理人",
        applyStatuse: "当前状态",
        confirmAudit: "确定要审核通过吗?",
        operationSys: "系统自动处理",
        registerAddress: "注册地址",
        registerTelephone: "注册电话",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账户",
    },
    //企业会员-- 资金记录
    memberListMoney: {
        transactionTime: "充值时间",
        rechargeAmount: "充值金额（元）",
        beforeBalance: "充值前余额（元）",
        afterBalance: "充值后余额（元）",
        rechargeMethod: "充值渠道",
        orderStatus: "订单状态",
        rechargeStatus: "充值状态",
        transactionAmount: "充值总金额（元）",
        wxTransAmount: "微信充值金额（元）",
        alipayTransAmount: "支付宝充值金额（元）",
        cashTransAmount: "现金充值金额（元）",
        accountBalance: "当前总余额（元）",
    },
    //企业会员-- 资金记录退款
    memberListRefundMoney: {
        transactionTime: "申请退款时间",
        refundAmount: "申请退款金额（元）",
        refundedAmount: "成功退款余额（元）",
        orderStatusDesc: "订单状态",
        transactionAmount: "退款总金额（元）",
        wxTransAmount: "微信退款金额（元）",
        alipayTransAmount: "支付宝退款金额（元）",
        cashTransAmount: "现金退款金额（元）",
        accountBalance: "当前总余额（元）",
        refundMethod: "退款渠道",
        exportName: "退款记录",
    },
    // 企业会员-- 会员积分调整
    memberListIntegral: {
        tab1: "积分调整",
        tab2: "调整记录",
        type: "操作类型",
        points: "操作积分",
        typePl: "请选择操作类型",
        pointsPl: "请输入积分",
        pointsMin: "操作积分必须大于0",
        pointsMax: "扣除积分大于当前积分，请重新输入",
        openId: "微信openId",
        unionId: "微信unionId",
        headImgUrl: "用户头像",
        sex: "性别",
        balanceAmount: "账户余额(元)",
    },
    // 企业会员详情
    corporateMemberDetail: {
        info: "基本信息",
        entName: "企业名称",
        contactName: "联系人",
        phoneNo: "联系电话",
        maxMemberNumber: "成员上限（人）",
        accountPkId: "账户号",
        minRechargeAmount: "最低充值金额（元）",
        minRecharge: "最低充值金额",
        accountBalance: "账户余额（元）",
        loginUrl: "登录地址",
        accInfo: "账号信息",
        userName: "用户名",
        detailsExpireTime: "账号有效期",
        rolePkId: "所属角色",
        password: "密码",
        password2: "确认密码",
        reset: "重置",
        effectiveTime: "账号有效期",
        expireTime: "账号过期时间",
        resetPassword: "重置密码",
        add: "新增",
        updata: "修改",
        effectiveTimePl: "请选择账号生效日期",
        expireTimePl: "请选择账号过期时间",
        rolePkIdPl: "请选择角色",
        passwordPl: "请输入密码",
        passwordError: "请输入6-10位字符的密码",
        passwordTowError: "两次密码输入不一致，请重新输入",
        resetSuccess: "重置成功",
        loginTitle: "大客户登录信息",
        timeError: "过期时间不能小于生效时间",
        unifiedDivisionDesc: "统付组分成状态",
        feeInfo: "费率信息",
        elecBillType: "电费类型",
        dcPileElecFee: "直流桩电费",
        acPileElecFee: "交流桩电费",
        openTime: "开始时间",
        serviceFeeType: "服务费类型",
        dcPileServiceFee: "直流桩服务费",
        acPileServiceFee: "交流桩服务费",
        endTime: "结束时间",
        occupationFeeType: "站桩费类型",
        dcOccupationFee: "直流桩占桩费",
        acOccupationFee: "交流桩占桩费",
        openStation: "开放站点",
        stationList: "站点名单",
        stationAddress: "站点地址",
        feeType1: "收费比例%",
        feeType2: "定价(元)",
        feeType3: "定额减免(元)",
    },
    //  企业会员充值
    corporateMemberRecharge: {
        accountBalance: "交易前余额(元)",
        minRechargeAmount: "最低充值(元)",
        rechargeAmount: "充值金额(元)",
        cardMaxMoney: "在线卡最大金额不能超过9999元",
        cardMinMoney: "充值金额不能少于",
        rechargeSuccess: "充值成功",
        balance: "余额：",
    },
    //  企业会员退款
    corporateMemberRefund: {
        refundAmount: "退款金额(元)：",
        refundBtn: "退款",
        maxAmount: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        amountBalance: "账户余额",
    },
    //企业会员-- 绑定站点
    bindSites: {
        rateSet: "电价修改",
        dcElecFee: "直流桩电价",
        acElecFee: "交流桩电价",
        dcServiceFee: "直流桩服务费",
        acServiceFee: "交流桩服务费",
        hasOriginalFee: "原价",
        yes: "是",
        beginTime: "开始时间",
        endTime: "结束时间",
        bindSite: "关联站点",
        self: "自营",
        unself: "非自营",
        amount: "金额",
        please: "请输入",
        pleaseCorrect: "请输入正确的",
        towNumber: "，最多保留两位小数",
        max: "不能大于",
        delayFeeTypePl: "请选择占桩费优惠方式",
        serviceFeeTypePl: "请选择服务费优惠方式",
        elecFeeTypePl: "请选择电费优惠方式",
        selectSta: "选择站点",
        dealyADc: "交直流占桩费",
    },
    // 企业成员
    corporateMembers: {
        hasUseEntAccount: "支付方式",
        entUserGroupPkId: "所属用户组",
        hasAdmin: "是否管理员",
        globalSearch: "姓名/手机号",
        historyRecords: "历史记录",
        members: "企业成员",
        admin: "管理员",
        unallocated: "未分配",
        queryCarNo: "车牌",
        relevanceCard: "关联电卡",
        queryBindCard: "电卡信息",
        setMain: "设置为管理员",
        cancelMain: "取消管理员",
        handleDel: "移除",
        fullName: "姓名",
        carList: "车牌号",
        vinList: "Vin码",
        quotaType: "额度分配（元）",
    },
    // 新增成员
    corporateMembersAdd: {
        add: "可添加",
        templateDownload: "模板下载",
        upCard: "修改车辆",
        addCard: "添加车辆",
        addRow: "添加一列",
        addMember: "新增成员",
        fullNamePl: "请输入姓名",
        phoneError: "该手机号码成员已存在，请重新输入",
        phoneRepeat: "该手机号码已重复",
        cardMax: "车牌号不能大于10个字符",
        cardRepeat: "该车牌号已重复",
        exists: "已存在",
        vinMax: "vin码不能大于17个字符",
        vinError: "vin码只能由数字和字母组成",
        vinRepeat: "该vin码已重复",
        vinCardError: "组车牌号和Vin码必须同时输入或者同时不输入",
        No: "第",
        addMemberTpl: "新增成员模板",
        updataMember: "修改成员",
        entUserGroupPkIdPl: "请选择所属用户组",
        updataTitle: "修改员工信息",
        entUserGroupPkIdTips: "说明：修改后额度分配于下个周期生效",
        adds: "继续添加",
        carNoPl: "请输入车牌号",
        carNoMax: "车牌号不能大于10个字符",
        hasAdmin: "是(管理员)",
        del: "移除",
        confirmDel: "确定要删除吗？",
    },
    // 成员绑卡
    corporateMembersBind: {
        cancelSuccess: "取消成功",
        cancelRelation: "取消关联",
    },
    // 成员-历史记录
    membersHistory: {
        globalSearch: "姓名/手机号/车牌号",
        createTime: "移除时间",
        userName: "操作人",
        operateType: "操作类型",
    },
    // 企业会员--用户组
    membersUserGroup: {
        groupName: "用户组名称",
        entUserSum: "成员数量（个）",
        staSum: "可用站点（个）",
        quotaAmount: "员工额度分配",
        associateMembers: "关联成员",
        availableSites: "可用站点",
        hasUseEntAccountPl: "请选择支付方式",
        moveLeft: "左移",
        moveRight: "右移",
        total: "共",
    },
    // 企业会员-- 资金记录
    corporateMemberRecord: {
        tab1: "充电",
        tab2: "充值",
        tab3: "退款",
        payStatus: "支付状态",
        chargeGlobalSearch: "姓名",
        chargeRecord: "充电记录",
        rechargeType: "充值方式",
        rechargeStatus: "充值状态",
        rechargeRecord: "充值记录",
        rechargeTime: "充值时间",
        rechargeMoney: "充值金额（元）",
        beforeBalance: "充值前余额（元）",
        afterBalance: "充值后余额(元)",
        recordRecord: "退款记录",
        recordTime: "申请退款时间",
        refundAmount: "申请退款金额（元）",
        refundedAmount: "成功退款余额（元）",
        orderStatus: "退款状态",
    },
    // 非实名卡-- 资金记录
    nonFundHistory: {
        tab1: "充电",
        tab2: "充值",
        tab3: "退款",
        transactionTime: "充值时间",
        rechargeAmount: "充值金额(元)",
        createName: "操作人",
        refundTime: "退款时间",
        refundAmount: "退款金额（元）",
        amountBeforeRefund: "退款前金额（元）",
        amountAfterRefund: "退款后金额（元）",
        transactionAmount: "充值总金额（元）",
        refundTransactionAmount: "退款总金额（元）",
        accountBalance: "卡内总余额（元）",
        beforeBalance: "充值前金额（元）",
        afterBalance: "充值后金额（元）",
    },
    // 运营商信息余额提醒
    upBalanceConfig: {
        tipsText: "注：开启此功能后，会员启动充电后余额低于指定金额时将发送短信或公众号通知对方，为防止频繁通知影响用户，建议提醒金额谨慎设置。",
        status: "功能开放",
        open: "开启",
        close: "关闭",
        triggerValue: "余额提醒",
        triggerValueTips: "用户充电中，余额低于",
        triggerValueTips2: "元后，发送通知。",
        sendWays: "通知方式",
        wx: "公众号通知",
        msg: "短信通知",
        wxTpl: "公众号模板检测",
        msgTpl: "短信模板检测",
        configured: "已配置",
        noConfigured: "未配置",
        noTmpTips: "未检测到短信模板，请联系平台服务商配置",
        balance: "余额",
        sendWaysPl: "请选择通知方式",
        statusPl: "请选择功能是否开放",
        tab1: "个人会员",
        tab2: "非实名电卡会员",
    },
    // 修改系统信息
    upSysInfo: {
        wxLogo: "微信公众号logo",
        imgSize: "图片尺寸建议为：",
        wxMiniLogo: "微信小程序logo",
        logo: "平台logo",
        logoPl: "请上传平台logo",
        oprSystemName: "平台名称",
        loginPageSlogan: "登录页宣传语",
        websiteRecordInfo: "网页备案信息",
        sysName: "系统名称",
        websiteRecordInfoPl: "请输入网页备案信息",
        wxLogoPl: "请上传公众号logo",
        wxMiniLogoPl: "请上传小程序logo",
        upSuccess: "修改成功",
        description: "运营商描述",
        descriptionPl: "请输入运营商描述",
    },
    //  充电服务配置
    upChargeConfig: {
        tab1: "微信公众号",
        tab2: "微信小程序",
        tab3: "支付宝小程序",
        infoConfig: "基本配置",
        hasWeChat: "服务启用",
        open: "开启",
        close: "关闭",
        qrCodeFilePath: "二维码",
        upload: "上传",
        weChatName: "名称",
        please: "请输入",
        primevalId: "原始ID",
        noticeTpl: "通知模版",
        wxPayInfo: "微信支付信息",
        mchName: "商户名称",
        mchId: "商户ID",
        mchKey: "商户密钥",
        mchCertFilePath: "申请退款证书",
        download: "下载证书",
        mchCertFilePathPl: "请上传申请退款证书",
        qrCodeFilePathPl: "请上传二维码",
        weChatLogoPl: "请上传logo",
        Applets: "小程序",
        wxNumber: "公众号",
        "201": "充电开始通知",
        "203": "充电结算通知",
        "202": "充电结束通知",
        "301": "故障通知",
        "204": "余额不足提醒",
        "205": "发送优惠券模板",
        "101": "登录短信模版",
        "104": "身份验证模版",
        "102": "修改密码模版",
        "103": "信息变更模版",
        zfbLogo: "小程序logo",
        qrCodePath: "小程序二维码",
        zfbName: "支付宝应用名称",
        zfbAppId: "小程序ID",
        zfbAppSecret: "小程序secret",
        privateKey: "应用私钥",
        alipayPublicKey: "支付宝公钥",
        zfbLogoPl: "请上传logo",
        qrCodePathPl: "请上传二维码",
        mchCertName: "信联支付证书名称",
        mchCert: "信联支付证书存放路径",
        mchCertPwd: "商户证书密码",
        mchPosid: "商户柜台代码",
        mchBranchid: "分行代码",
        mchTxCode: "交易码",
        mchUserId: "操作员号",
        mchPassword: "操作员密码",
        ipAddr: "外联平台ip",
        port: "外联端口",
        wxPayPointsTitle: "微信支付分",
        mchCertSerialNo: "微信商户证书序列号",
        mchCertPrivateKey: "微信商户证书私钥",
        serviceIntroduction: "微信支付分服务信息",
        mchV3Key: "微信商户V3密钥",
        serviceId: "微信支付分service id",
        required: "必填项",
        sm2Pass: "sm2 签名私钥",
        merSm2KeyText: "商户签名",
        merSm2PubKeyText: "商户签名公钥",
        merSm2DecKeyFile: "商户解密私钥",
        merSm2DecPubKeyFile: "商户解密公钥",
        payCenterPublicKey: "支付平台加密公钥",
        refundNotifyUrl: "退款异步通知接口",
        version: "版本",
        xlType: "支付版本",
        mchType: "商户类型",
        mchTypePl: "请选择商户类型",
        AppID: "App ID",
        mchPrivatePassword: "商户私钥密码",
        mchPrivateKey: "商户私钥",
        mchPrivateKeyPl: "请上传账户私钥",
        entPublicKey: "企业网关公钥",
        entPublicKeyPl: "请上传企业网关公钥",
        isSupportLedgerSplit: "是否支持分账",
        isSupportLedgerSplitPl: "请选择是否支持分账",
        zfbInfo: "支付宝支付信息",
        mchNo: "商户号",
    },
    // 修改操作密码
    upSafePassword: {
        userPwd: "新密码",
        confirmPassword: "重复新密码",
        verCode: "手机验证码",
        verCodePl: "验证码不能为空",
        userPwdPl: "密码不能为空",
        userPwdLen: "密码长度6~18",
        userPwdError: "密码不能包含空格、制表符、换行符",
        confirmPasswordPl: "确认密码不能为空",
        confirmPasswordError: "请确认新旧密码是否一致",
        upError: "修改失败",
    },
    // 结算配置
    upSettlementConfig: {
        info: "开票信息",
        invoiceOperator: "发票运营商",
        invoiceOperatorPl: "请选择发票运营商",
        invoiceType: "发票类型",
        companyName: "公司名称",
        taxId: "税号",
        chargeRate: "电费税率",
        serviceRate: "服务费税率",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账户",
        unit: "发票单位",
        contacts: "联系人",
        telephone: "联系电话",
        payee: "收款人",
        drawer: "开票人",
        reviewer: "复核人",
        registerAddress: "收件地址",
        modifyTime: "上一次更新时间",
        otherInfo: "其他信息",
        drawRemark: "备注",
        drawDesc: "提现说明",
        tips: "注意事项",
        tips1: "1、不同的发票类型将影响对方开票的税率，因此发票类型谨慎选择。",
        tips2: "2、公司名称会影响提现单的付款方和发票的公司表头，请谨慎修改。",
        tips3: "3、其他如税号、开户银行、帐号等信息为开票必填项。",
        tips4: "4、联系人、联系电话、收件地址可不填，默认运营商创建时的联系信息",
        tips5: "5、可根据实际请款填写备注信息和提现说明，修改后将更新提现单处对应的信息",
        unitPl: "请选择发票单位",
        isOpen: "是否开启电子发票",
        isOpenPaper: "是否开启纸质发票",
        openTipsTitle: "开通提示",
        openTips: "开通此功能需要与第三方开票平台进行对接，并会产生相应的开票费用，此费用需要运营商自行承担。如果需要请联系平台管理员开通。",
        companyCode: "百旺-公司代码",
        drawerCode: "百旺-开票人代码",
        terminalCode: "百旺-开票终端代码",
        paperInvoiceType: "开票类型",
        paperInvoiceTypePl: "请选择开票类型",
    },
    // 新增商户
    addMerchant: {
        info: "基本信息",
        fullName: "商户名称",
        shortName: "商户简称",
        contacts: "联系人",
        contactsMail: "联系邮箱",
        telephone: "联系电话",
        address: "联系地址",
        operatorShare: "运营商分成",
        shareType: "分成类型",
        isMoneyRules: "固定金额",
        isMoneyRulesShareMaxError: "固定金额分成不能大于总金额，请检查",
        orderTotalMoney: "单笔订单总金额",
        orderTotalMoneyMax: "元以上",
        orderShare: "每笔订单分成",
        isMoneyRulesTips: "根据分成类型显示对应分成金额配置，多选。注：选择固定金额后，百分比类型每笔订单不能再次选择总金额",
        isPercentageRules: "百分比",
        order: "每笔订单",
        cashConfig: "提现配置",
        cashMin: "最低提现金额",
        condition: "条件",
        fromValueTips: "结算金额满",
        feeTips: "扣除转账手续费",
        feeTipsPl: "扣除转账手续费百分比",
        loginUrl: "登录地址",
        addTitle: "新增账号",
        resetPassword: "重置密码",
        mchCollectionInfo: "商户收款信息",
        bankAccountName: "银行账户名称",
        bankDeposit: "收款账户开户银行",
        bankAccountNo: "收款银行账户",
        addMch: "新增商户",
        loginTitle: "新增登录账号",
        updataTitle: "修改登录账号",
        required: "必填项",
        textLenMax: "长度不能超过",
        divisionPercentPl: "请选择分成方式",
        divisionPercentMax: "值区间：0.00~100",
        divisionPercentError: "请输入有效数字",
        base2: "百分比",
        minWithdrawAmount: "最低提现金额",
        bankDepositPl: "请输入收款账户开户银行",
        bankAccountNamePl: "请输入收款账户名称",
        userName: "登录用户名",
        effectiveTime: "生效时间",
        expireTime: "过期时间",
        accountName: "账户名称",
        bankInstitutionDesc: "银行机构",
        remarks: "备注",
        delConfig: "确定要删除当前账号吗",
        userParamsNull: "登录用户账户不能为空",
        isPercentageRulesPl: "请选择百分比分成的类型",
        isPercentageRulesError: "百分比分成的类型不能重复",
        addSuccess: "新增成功",
        mchLoginInfo: "商户登录信息",
        userParamsMax: "只能存在一个登录用户，请删除多余的",
        mchDetails: "商户详情",
        upDetails: "修改商户",
        add: "添加",
        rolePkIdPl: "请选择角色",
        expireTimePl: "请先选择生效日期",
        expireTimeError: "不能低于生效日期",
        userNameError: "用户名重复",
        issueCardCode: "客户编码",
        fixedShare: "固定分成",
        fixedShareText: "每度电分成",
        accountPl: "请填写账号信息",
        invoiceType: "发票类型",
        hasOpenAudit: "是否开启发票审核",
        open: "开启",
        close: "关闭",
        invoiceSet: "发票设置信息",
        invoiceTypePl: "请选择发票类型",
        hasOpenAuditPl: "请选择是否开启",
        settlementType: "分成规则类型",
        wxMerchantName: "微信收账商户名称",
        wxMerchantAccount: "微信收账商户账号",
        wxMerchantNamePl: "请输入微信收账商户名称",
        wxMerchantAccountPl: "请输入微信收账商户账号",
        password: "密码",
    },
    // 新增设备生产商信息
    addProducer: {
        busLicenseNumberPl: "请输入营业执照编号",
        busLicenseNumberError: "营业执照编号长度是18位",
        brandNamePl: "请输入品牌名称",
        manufacturerNamePl: "请输入设备生产商",
        manufacturerIdPl: "请输入设备厂商组织机构代码",
        manufacturerIdError: "营业执照编号长度是九位",
        legalPersonPl: "请输入公司法人",
        legalIdCardPl: "请输入法人身份证",
        legalIdCardError: "法人身份证长度是十八位",
        contactNamePl: "请输入联系人",
        contactName: "联系人",
    },
    // 新增设备型号
    addEquipmentModel: {
        typeInfo: "型号信息",
        deviceType: "设备类型",
        deviceModelName: "设备型号",
        name1: "标配",
        name2: "选配",
        manufacturerInfo: "厂商信息",
        optionalAdd: "选配新增项",
        manufacturerPkId: "生产商名称",
        optionName: "选项名称",
        remark: "选项说明",
        addDevType: "添加设备型号",
        deviceModelNamePl: "请输入设备型号",
        manufacturerPkIdPl: "请选择生产商名称",
        optionNamePl: "请输入选项名称",
        isChecked: "是否标配",
        optionValue: "固定值",
        valueNull: "值不能为空",
        valueError: "值只能是正的数值",
        detailsTitle: "设备型号详情",
        upTitle: "修改设备型号",
        addTitle: "新增设备型号",
        addSplitPile: "添加分体设备型号",
        delDevType: "删除设备型号",
        outPutRange: "输出范围",
    },
    // 短信购买
    msgBuy: {
        step: "步骤解析",
        step1: "第一步",
        step1Text: "选择购买条数",
        step2: "第二步",
        step2Text: "添加充值联系人微信并备注信息",
        step3: "第三步",
        step3Text: "提交购买",
        step4: "第四步",
        step4Text: "付款，完成购买",
        note: "注：",
        note1: "短信购买完成后不支持退货；",
        note2: "短信无过期限制；",
        note3: "当前不支持对接其他短信供应商；",
        note4: "短信70个字数含以内，按1条短信计费；",
        note5: "成功发送计费一条，发送失败不计算在内。",
        remainder: "当前条数(条)",
        comboPkId: "购买条数(条)",
        paymentAmount: "支付金额(元)",
        purchasedWay: "支付方式",
        remark: "备注",
        tips: "填写完成信息后，拨打下方充值联系人手机号或添加微信联系后台充值，暂时不支持线上购买。",
        rechargeContact: "充值联系人",
        contactPhone: "联系人手机号",
        qrCodeFileUrl: "联系人微信",
        contactTips: "添加微信请备注好运营商名称，以便后台人员快速查找到充值订单。支持线上购买。",
        purchasedWayPl: "请选择支付方式",
        purchasedCountPl: "请选择购买条数",
    },
    // 余额提醒
    balanceReminderPage: {
        triggerValue: "余额提醒",
        triggerValueTips: "账户余额低于",
        triggerValueTips2: "元后，发送通知。",
        sendWays: "通知方式",
        sendWaysTips: "公众号通知",
        triggerVTips2: "短信通知",
        wxTpl: "公众号模板检测",
        msgTpl: "短信模板检测",
        configured: "已配置",
        noConfigured: "未配置",
        noTips: "未检测到短信模板，请联系平台服务商配置",
        wxMessage: "公众号通知人员",
        msgMessage: "短信通知人员",
        phoneTips: "输入手机号多个号码用，号隔开",
        sendWaysPl: "请选择通知方式",
        phonePl: "请输入号码",
        phoneError: "号码格式错误，号码之间用 ',' 号隔开",
        phoneMax: "号码不能超过5组",
        addTime: "添加时间",
        openFunctionality: "功能开放",
        open: "开启",
        close: "关闭",
        time: "提醒时间",
        timePl: "请选择时间",
        timeError: "时间重复，请重新选择",
    },
    // 互联互通
    interflowListSend: {
        operatorId: "组织结构代码",
        projectName: "项目名称",
        systemName: "系统名称",
        protocolPkId: "协议主键",
        phoneNo: "联系方式",
        contactName: "联系人",
        netDriection: "互通方向",
        netType: "互通类型",
        beginTime: "互联开始日期",
        endTime: "互联结束日期",
        netFileUrl: "附件",
        upload: "上传文件",
        reason: "申请理由",
        tab1: "基本信息",
        tab2: "平台密钥",
        tab3: "运营商密钥",
        addInterflow: "新增互联互通",
        reasonPl: "请输入申请理由",
        netDriectionPl: "请选择互通方向",
        netTypePl: "请选择互通类型",
        beginTimePl: "请选择开始时间",
        endTimePl: "请选择结束时间",
        netFileUrlPl: "请上传附件",
        protocolPkIdPl: "请输入协议主键",
        upInterflow: "修改互联互通",
        detailsInterflow: "互联互通详情",
        aesDataSecret: "数据加密密钥",
        aesDataSecretIV: "初始化向量",
        operatorSecret: "运营商密钥",
        sigSecret: "签名密钥",
        requestUrl: "请求平台地址",
        rechargeAmount: "充值金额(元)",
        rechargeSuccess: "充值成功",
        refundAmount: "退款金额(元)",
        refundBtn: "退款",
        refundError: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        refundOrderNo: "订单号",
        balance: "账户余额",
        governmentPush: "推送充电数据",
        governmentPushPl: "请选择推送充电数据",
    },
    // 互联互通-- 资金记录
    interflowRecord: {
        tab1: "充电",
        tab2: "充值",
        tab3: "退款",
        accountPkId: "账户号",
    },
    // 互联互通-- 对账单
    interflowBill: {
        abnormal: "推送结果",
        queryDetails: "明细",
        errorOrder: "异常订单",
        normal: "正常",
        error: "异常",
        beginTime: "账单开始时间",
        endTime: "账单结束时间",
        orderNumber: "订单数(笔)",
        totalChargeElect: "总电量(kWh)",
        totalAmount: "总金额(元)",
        abnormalNumber: "异常订单数(笔)",
        abnormalAmount: "异常订单金额(元)",
        checkingResult: "核对结果",
        reset: "重置",
        diffContent: "争议原因",
        tab1: "对账单",
        tab2: "对账单明细",
    },
    // 修改接口会员
    interfaceMemberUp: {
        operatorSecret: "平台密钥",
        systemName: "接口用户名称",
        protocolPkId: "协议主键",
        phoneNo: "联系方式",
        contactName: "联系人",
        netFileUrl: "附件",
        upload: "上传文件",
        reason: "申请理由",
        reasonPl: "请输入申请理由",
        netFileUrlPl: "请选择附件",
        protocolPkIdPl: "请输入协议主键",
        operatorIdPl: "请输入组织结构代码",
        operatorIdError: "请输入9位的组织结构代码",
        detailsTitle: "接口会员详情",
        updataTitle: "修改接口会员",
        addTitle: "新增接口会员",
        rechargeAmount: "充值金额(元)",
        rechargeSuccess: "充值成功",
    },
    // 修改接口会员
    interfaceMemberRecord: {
        tab1: "充电",
        tab2: "充值",
        accountPkId: "账户号",
    },
    // 第三方服务申请开通
    addThirdPartyServices: {
        tab1: "基本信息",
        tab2: "第三方平台秘钥",
        platformType: "平台类型",
        protocolPkId: "协议",
        contactName: "联系人",
        phoneNo: "联系方式",
        attachmentPkId: "附件",
        uploadBtn: "上传附件",
        remarks: "备注",
        attachmentPkIdPl: "请上传附件",
        platformTypePl: "请选择平台类型",
        protocolPkIdPl: "请选择协议",
        remarksPl: "请输入备注",
        platformId: "第三方平台id",
        aesDataSecret: "加密密钥",
        aesDataSecretIV: "加密初始化向量",
        appSecret: "平台凭证",
        sigSecret: "签名密钥",
        requestUrl: "请求平台地址",
        requestUrlPl: "请输入平台地址",
        protocolType: "协议类型",
        protocolTypePl: "请输入协议类型： https://、http:// 或 其它",
        platformNamePl: "请输入第三方服务商名称",
        couponType: "优惠券类型",
        couponTypeNo: "无",
        couponValueUnit: "分钟",
        couponValueUnit2: "元",
        couponValueNull: "请输入数值",
        couponValueError: "请输入大于等于0的数字",
        couponValueTimeMax: "时间不能大于5000",
        couponValueNumber: "请输入正确的数字,不能有小数",
        couponValueMomeyMax: "金额不能大于5000",
        couponValueMoneyTow: "金额最多保留两位小数",
        couponValueDisMax: "折扣不能大于100，0表示免费",
        couponValueDisOne: "折扣最多保留一位小数",
        invoiceOpenType: "发票开票类型",
        invoiceOpenTypePl: "请选择发票开票类型",
        hasOpenFreeHours: "是否开启免费时段",
        freeBeginHours: "免费时段开始时间",
        freeEndHours: "免费时段结束时间",
        policyConfig: "策略配置",
        parkingReductionRule: "停车道闸减免规则",
        dcPileChargingReduction: "直流桩充电量推送减免",
        acPileChargingReduction: "交流桩充电量推送减免",
        dcPileChargingTimeReduction: "直流桩充电时长推送减免",
        acPileChargingTimeReduction: "交流桩充电时长推送减免",
        chargeUnit: "kW·h",
        inputEnterTip: "请输入正整数",
        minDcCharge: "直流桩充电量≥",
        minDcChargeMinutes: "直流桩充电时长≥",
        minAcCharge: "交流桩充电量≥",
        minAcChargeMinutes: "交流桩充电时长≥",
        pushReduction: "推送减免",
    },
    // 新增提现单
    addwithdrawal: {
        cashInfo: "提现信息",
        cashTime: "提现周期",
        settlementBtn: "结算",
        cashTimeBtn: "可提现日期",
        currentChargeAmount: "本期充电金额",
        transactionServiceAmount: "本期服务费",
        transactionDelayAmount: "本期占桩费",
        oprShare: "运营商分成",
        serviceCharges: "手续费",
        transferAmount: "实际提现金额",
        account: "收款账户",
        contacts: "联系人",
        telephone: "联系电话",
        bankAccountName: "账户名称",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账号",
        recordStatus: "新增提现",
        recordStatus1: "准备付款",
        recordStatus2: "完成付款",
        recordStatus3: "已中止",
        timePl: "请选择时间",
        merchantPkIdPl: "请选择商户",
        settlementError: "结算异常",
        settlementNo: "未结算",
        settlementYes: "已提现",
        settlement: "可提现",
        paying: "付款中",
        handleTitle: "处理进度",
        moneyTips: "金额最多保留两位小数",
    },
    // 提现单模板
    withdrawalTemplate: {
        title: "合作运营充电站费用结算单",
        settlementTime: "提现周期",
        settlementTips: "备注：根据双方合作协议约定，运营商分成比例如下:",
        settlementTips1: "提现手续费为最终提现金额（最终提现金额=收入合计金额-运营商分成）的{serviceChargeFee}。",
        // settlementTips1: "元，根据合作协议，甲方应支付乙方分成费",
        // settlementTips2: "，合计需结算",
        number: "序号",
        tableProject: "项目",
        tableMoney: "金额(元)",
        transactionChargeAmount: "充电电费",
        transactionDelayAmount: "占桩费",
        transactionServiceAmount: "充电服务费",
        oprShare: "运营商分成金额",
        serviceCharges: "手续费",
        transferAmount: "合计结算金额",
        collectionInfo: "收款信息",
        MchSeal: "商户或者个人名称(章)",
        oprSeal: "运营商名称(章)",
        download: "下载证书",
        templateTime: "制单日期",
        totalIncome: "收入合计金额",
        remarks: "综上，本期充电收入合计金额{currentChargeAmount}元，应向贵司支付本期收入结算费用{transferAmount}",
        delegate: "代表",
        date: "日期",
        company: "名称",
        bank: "银行",
    },
    // 刷卡数据报表
    cardDataReport: {
        cardPkId: "电卡会员号",
        totalGunNumber: "枪数",
        totalAmount: "累计总金额",
        totalChargingMinutes: "累计充电时长(分钟)",
        totalChargingTimes: "累计充电次数",
        totalElecAmount: "累计充电电费",
        totalPower: "累计充电量",
        totalSeviceAmount: "累计服务费",
        billGenerationDate: "账单生成日期",
        billCreateDate: "报表创建日期",
    },
    // 短信条数充值
    msgRecharge: {
        notes: "注:",
        notes1: "充值完成将更新短信服务剩余可用条数",
        notes2: "为保证短信发送正常及计数准确，请确保此处充值条数的同时，阿里云已完成短信购买",
        remainder: "当前条数",
        purchasedCount: "充值条数",
        remark: "备注",
        recharge: "充值",
        rechargeUnit: "条",
        rechargeSuccess: "充值成功",
    },
    //子菜单标题
    childMenuTitle: {
        // 短信服务
        msgBuy: "短信购买",
        msgRecharge: "短信条数充值",
        msgBuyRecordDetails: "短信购买详情",
        msgApplyInvoice: "申请发票",
        msgPurchase: "短信购买",
        //接口会员
        interfaceRecharge: "接口会员充值",
        interfaceAdd: "新增接口会员",
        interfaceUp: "修改接口会员",
        interfaceDetails: "接口会员详情",
        interfaceRecord: "接口会员资金记录",
        interfaceSite: "接口会员站点",
        interfaceBalance: "接口会员余额提醒",
        // 结算订单补推订单
        supplementOrder: "补推订单",
        // 第三方服务
        thirdPartyServicesAdd: "第三方服务申请开通",
        thirdPartyServicesUp: "第三方服务编辑",
        thirdPartyServicesDetails: "第三方服务详情",
        // 会员充值记录
        memberRechargeDetails: "充值记录详情",
        //退款记录
        refundRecordsDetails: "退款记录详情",
        refundRecordsAudit: "退款审核",
        refundRecordsManage: "退款管理",
        // 商户提现
        withdrawalTpl: "提现单模板",
        addWithdrawal: "新增提现单",
        detailsWithdrawal: "提现单详情",
        // 导入信息存在错误
        importError: "导入信息存在错误",
        accInfo: "账号信息",
        login: "登录",
        // 互联互通
        interflowStaOpen: "站点开放管理",
        interflowStaOpenDetail: "查看详情",
        interflowSend: "发起申请",
        interflowUp: "修改互联互通",
        interflowDetails: "互联互通查看详情",
        interflowBill: "对账单",
        interflowBalance: "互通余额提醒",
        interflowRecharge: "互联互通充值",
        interflowRecord: "互联互通资金记录",
        interflowRefund: "互联互通退款",
        // 会员列表
        memberDetails: "用户详情",
        memberRecharge: "会员充值",
        memberRefund: "会员退款",
        memberImport: "会员导入",
        memberBindCard: "关联电卡",
        memberRecord: "会员-资金记录",
        memberIntegral: "会员积分调整",
        memberGrade: "会员等级调整",
        membershipCycle: "会员周期",
        // 企业会员
        corporateMemberRecharge: "企业会员充值",
        corporateMemberDetails: "企业会员详情",
        corporateMemberRecord: "企业会员资金记录",
        corporateMemberEdit: "编辑企业会员",
        corporateMemberAdd: "新增企业会员",
        corporateMemberBind: "绑定站点",
        corporateMemberMembers: "企业成员",
        corporateMemberHistory: "企业成员-历史记录",
        membersBindCard: "企业成员-绑卡",
        membersAdd: "新增成员",
        membersUp: "修改成员",
        membersCard: "成员车牌",
        corporateUserGroup: "企业会员用户组",
        corporateUserGroupAdd: "企业会员用户组-新增",
        corporateUserGroupUp: "企业会员用户组-修改",
        corporateUserGroupDetails: "企业会员用户组-详情",
        corporateRefund: "企业会员退款",
        corporateBalance: "企业会员余额提醒",
        enterpriseApplicationAudit: "企业会员申请审核",
        corporateMemberBindList: "关联站点",
        corporateMemberEntPayOrder: "统付订单",
        //注销会员
        cancellationMemberRecord: "注销会员/资金记录",
        // 站点监控
        siteMonitorDetails: "站点监控详情",
        siteMonitorGunDetails: "站点监控/桩详情",
        siteMonitorOper: "站点监控/运营商",
        siteMonitorPileDetails: "站点监控/设备详情",
        // 发票管理
        invoiceDetails: "发票详情",
        invoiceAudit: "发票审核",
        // 优惠券
        couponAdd: "新增优惠券",
        couponDetails: "优惠券详情",
        couponAddUp: "修改优惠券",
        couponAudit: "审核优惠券",
        couponGrant: "发放优惠券",
        // 营销活动
        memberCouponAdd: "新增优惠活动",
        memberCouponUp: "修改优惠活动",
        memberCouponAudit: "审核优惠活动",
        memberCouponDetails: "优惠活动详情",
        memberCouponGrant: "活动发放优惠券",
        // 系统公告
        noticeAdd: "新增系统公告",
        noticeDetails: "系统公告详情",
        // 客户消息
        customerServiceReply: "客户消息回复",
        // 用户指南
        userGuideCatalog: "目录管理",
        userGuideCatalogAdd: "新增目录",
        userGuideCatalogUp: "修改目录",
        userGuideArticleAdd: "新增文章",
        userGuideArticleUp: "修改文章",
        // 非实名卡管理
        cardDetails: "非实名卡详情",
        cardAdd: "非实名卡开卡",
        cardRecharge: "非实名卡充值",
        cardUp: "非实名卡编辑",
        cardDel: "非实名卡注销",
        cardHistory: "非实名卡-操作记录",
        cardFundHistory: "非实名卡-资金记录",
        cardRefund: "非实名卡退款",
        // 会员等级管理
        memberGradeAdd: "新增会员等级",
        memberGradeUp: "修改会员等级",
        memberGradeDetails: "会员等级详情",
        memberGradeRecordDetails: "等级购买记录详情",
        // 积分活动管理
        integralActivityAdd: "新增积分活动",
        integralActivityUp: "修改积分活动",
        integralActivityDetails: "积分活动详情",
        integralRecordDetails: "积分兑换记录详情",
        integralAddRecordDetails: "积分增长记录详情",
        // 告警通知
        addAlert: "新增策略",
        upAlert: "修改策略",
        detailsAlert: "策略详情",
        // 设备生产商
        producerAdd: "新增设备生产商信息",
        producerUp: "编辑设备生产商信息",
        // 商户管理
        merchantUp: "编辑商户",
        merchantAdd: "新增商户",
        merchantDetails: "商户详情",
        mchOperationLog: "商户操作日志",
        // 运营商信息
        operInfoUpSys: "修改系统信息",
        operInfoUp: "运营商基本信息",
        operInfoChargeConfig: "充电服务配置",
        operInfoSoc: "移动端定制",
        operInfoUpSafePassword: "修改操作密码",
        operInfoUpSettlement: "电子发票",
        operInfoUpBalance: "余额提醒",
        invoiceSettings: "发票设置",
        invoiceSettingsPaper: "纸质发票设置",
        // 设备型号
        equipmentModelAdd: "新增设备型号",
        equipmentModelUpdate: "修改设备型号",
        equipmentModelDetail: "设备型号详情",
        //档案报告详情
        reportFileDetail: "档案报告详情",
        // 订单列表
        chargeOrderDetail: "订单详情",
        errorOrderDetail: "异常详情",
        abnormalOrder: "异常处理",
        abnormalErrorOrder: "异常处理 ",
        offCardOrderDetails: "离线卡订单详情",
        reserveChargingOrderDetails: "预约订单详情",
        // 系统管理
        addRoleInfo: "新增角色",
        permissionMune: "权限配置",
        updataRoleInfo: "修改角色",
        detailsRoleInfo: "角色详情",
        detailsEdit: "用户详情",
        permissionLog: "操作日志",
        userEdit: "用户编辑",
        userAdd: "新增用户",
        renewLogAdd: "新增更新日志",
        assignSta: "分配站点",
        // 首页桩
        homePileSta: "站下桩列表",
        homePileStaPile: "站下桩详情",
        // 站点列表
        siteDetails: "站点详情",
        siteImportTable: "站点导入",
        chargeStrategy: "充电策略",
        operSet: "运营设置",
        phoneShow: "增值服务",
        allUpdatarate: "批量更换",
        addRateTemplate: "批量更换充电费率",
        allUpdataRateChange: "批量更换占桩费率",
        allUpdataReservation: "批量更换预约费率",
        eleListDetails: "站点电价详情",
        updataRateTemplate: "修改更换策略",
        detailsRateTemplate: "更换策略详情",
        pileChargingStrategy: "有序充电策略",
        pileChargingStrategyGroups: "有序充电策略分组",
        // 站点列表
        editPiles: "编辑站点",
        addPiles: "新增站点",
        allLineOffPile: "批量上线/下线",
        allBindPile: "批量关联/解绑",
        elePiles: "电价列表",
        discountTerm: "优惠方案",
        pileAudit: "站点审核",
        editGun: "编辑枪",
        elePilesChargeRecord: "费率更换明细",
        // // 桩列表
        detailsPile: "桩详情",
        editPile: "编辑桩",
        addPile: "新增桩",
        editElePile: "编辑电价",
        siteDebug: "现场调试",
        pileAllUpdata: "批量编辑",
        // 费率管理
        feePileDetail: "交直流充电费率",
        feeUsePileDetail: "充电桩充电费率",
        addFee: "新增费率",
        editFee: "编辑费率",
        delayFeeDetail: "占桩费率",
        countDetail: "费率使用数量",
        feePageRecord: "费率记录",
        feeStationBatchChange: "批量更换费率",
        entFeeUpdata: "费率修改",
        feeBindStation: "关联站点",
        feeBindStationList: "关联站点列表",
        delayCountDetail: "占桩费率-使用数量",
        delayFeeAdd: "新增占桩费",
        delayFeeUpdata: "修改占桩费",
        feeDetails: "费率应用详情",
        delayFeeDetails: "占桩费率应用详情",
        //预约费率
        addReservationRate: "新增预约占位费率",
        updataReservationRate: "修改预约占位费率",
        detailsReservationRate: "预约占位费率详情",
        reservationRateCount: "预约费率使用站点",
        // 电池管理
        batteryTestDetails: "报告详情",
        // 有序充电
        qrderlyChargingCount: "功率均分策略应用数量",
        qrderlyChargingAdd: "新增功率均分策略",
        qrderlyChargingUpdata: "修改功率均分策略",
        qrderlyChargingFirstComeCount: "先到先充策略应用数量",
        qrderlyChargingFirstComeAdd: "新增先到先充策略",
        qrderlyChargingFirstComeUpdata: "修改先到先充策略",
        qrderlyChargingFirstComeDetails: "策略详情",
        qrderlyChargingFirstComeDetails2: "策略详情 ",
        qrderlyChargingFirstComeBindSta: "关联站点",
        qrderlyChargingFirstComeBindSta2: "关联站点 ",
        //余额提醒
        balanceReminderEntBindCount: "企业用户关联数",
        balanceReminderThirdPartyCount: "第三方用户关联数",
        addBalanceReminder: "新增余额提醒",
        balanceReminderUpdataRecord: "修改记录",
        updataBalanceReminder: "修改余额提醒",
        detailsBalanceReminder: "余额提醒详情",
        // SIM卡管理
        editSim: "编辑SIM卡",
        detailsSim: "SIM卡详情",
        addSim: "新增SIM卡",
        //平台通知
        platformNotice: "平台通知",
        platformNoticeDetails: "平台通知详情",
        // 桩群功率统计
        pilePower: "站点桩群管理",
        // 结算概览
        settlementOverviewDetails: "商户结算概况",
        //积分商城
        addCommodity: "新增商品",
        updataCommodity: "修改商品",
        detailsCommodity: "商品详情",
        commodityOrderDetails: "商品订单详情",
        mallConfigAdd: "新增地址",
        mallConfigUpdata: "修改地址",
        businessConsulting: "业务咨询",
        // 经营分析-站点排行
        siteRankingTotalRevenue: "总营收排名",
        siteRankingDfRevenue: "电费营收排名及占比",
        siteRankingServerRevenue: "服务费营收排名",
        siteRankingDelayRevenue: "占桩费营收排名",
        siteRankingChargeOrder: "充电订单量排名",
        siteRankingChargeTime: "充电时长排名",
        siteRankingChargeUtilizationRate: "充电使用率排名",
        siteRankingChargeUtilization: "充电利用率排名",
        siteRankingChargeDlTable: "充电量排名详情",
        siteRankingChargeDlTableSharp: "尖时段充电量排名",
        siteRankingChargeDlTablePeak: "锋时段充电量排名",
        siteRankingChargeDlTableFlat: "平时段充电量排名",
        siteRankingChargeDlTableValley: "谷时段充电量排名",
        siteRankingRevenue: "营收排名",
        siteRankingCharging: "充电量排名",
        siteAnalysisDetails: "单站点分析详情",
        userRankingMore: "个人用户总营收排名",
        singleUserDetails: "单用户分析详情",
        //站点建设排名
        siteRankingPile: "充电桩建设排名",
        siteRankingGun: "充电枪建设排名",
        siteRankingPower: "额定功率建设排名",
        // 充值及账户配置
        rechargeConfig: "充值金额限额配置",
        rechargeConfigDetails: "充值金额限额详情",
        accountConfig: "账户限额配置",
        accountConfigDetails: "账户限额详情",
        cashRechargeConfig: "现金充值审核配置",
        cashRechargeConfigDetails: "现金充值审核配置详情",
        //地锁
        addFloorLock: "新增地锁",
        editFloorLock: "修改地锁",
        configFloorLock: "配置地锁",
        // 核算
        rechargeCheckingCorrect: "修正充值核算",
        refundCheckingCorrect: "修正退款核算",
        merchantSharingErrorInfo: "分成结算异常信息",
        //费率策略
        feePageUseNum: "费率使用数量",
        feePagePendingNum: "待下发数量",
        feePagePendingFee: "待生效费率",
        //预约占桩费率
        reservationRateDistribution: "下发预约费率",
        reservationRateRecord: "预约费率修改记录",
        //占桩费率
        delayRateDistribution: "下发占桩费率",
        delayRateRecord: "占桩费修改记录",
        qrderlyChargingOperationRecord: "功率均分策略操作记录",
    },
    //  全局纵览
    overview: {
        timeMonth: "开始月份",
        allClose: "折叠全部",
        allOpen: "展开全部",
        time: "当前日期",
        scaleDay: "规模(日)",
        orderMoney: "订单金额",
        totalOrder: "总订单量",
        orderUnit: "单",
        normalOrder: "正常订单量",
        abnormalOrder: "异常订单量",
        chargingDegree: "充电度数",
        supplyDay: "供给(日)",
        onlineSta: "在线充电站数",
        onlineGun: "在线充电枪数",
        userDay: "用户(日)",
        userNum: "日活跃用户数",
        efficiencyDay: "效率(日)",
        gunEle: "单枪单量",
        gunServer: "单枪服务费流水",
        utilization: "利用率",
        maintenanceDay: "运维(日)",
        abnormalRate: "异常率",
        experienceDay: "体验(日)",
        utilizationRate: "使用率",
        gunUnit: "把",
        formTimeType1: "按日",
        formTimeType2: "按周总",
        formTimeType3: "按月总",
        timeError: "时间错误",
        day: "日环比",
        week: "周环比",
        month: "月环比",
        orderMoneyValue: "已支付的订单金额",
        eleFeeValue: "已支付的电费",
        serverFeeValue: "已支付的服务费",
        delayFeeValue: "已支付的占桩费",
        totalOrderValue: "已支付+异常订单的数量",
        normalOrderValue: "已支付订单的数量",
        abnormalOrderValue: "异常订单的数量",
        chargingDegreeValue: "正常订单的充电度数",
        onlineStaValue: "在线的充电站数量",
        onlineGunValue: "在线的充电枪数量",
        userNumValue: "成功充过电的用户",
        gunEleValue: "充电枪的正常订单量/在线充电枪数",
        gunServerValue: "在线充电枪服务费日流水/在线充电枪数",
        utilizationValue: "充电桩电量之和/（充电桩功率之和*24h）",
        abnormalRateValue: "异常订单数/总订单数",
        utilizationRateValue: "在线充电枪充电总时长/在线充电枪总时长",
    },
    // 站点列表 -- 运营设置
    operSet: {
        tabCard: "指定电卡会员号",
        inputCard: "(请输入非实名在线卡号)",
        inputPhone: "(请输入用户手机号)",
        tabUser: "指定用户",
        tab1: "刷卡充电策略",
        tab2: "扫码充电策略",
        tab3: "企业会员充电策略",
        tab4: "互联互通充电策略",
        tab5: "接口会员充电策略",
        tab6: "SOC充电策略",
        tab7: "车辆信息策略",
        closedSoc: "SOC定停充电",
        closedSocTips: "SOC定停功能开关，若设置关闭，移动端隐藏SOC设置功能，开启后恢复SOC功能。",
        defaultSoc: "SOC默认值(%)",
        defaultSocTips: "配置移动端SOC的默认设定值，用户在未设定SOC值情况下使用此设定值充电，默认设定值98%。为防止意外过充谨慎设置默认值",
        defaultSocTips2: "默认值已达到100%，实际充电超过98%后只允许充电5分钟，请谨慎设置",
        floorSoc: "SOC下限值(%)",
        socSetTitle: "SOC总体策略配置",
        floorSocTips: "用于配置移动端SOC设定的下限值，介于10%-80%之间，默认下限值80%",
        defaultSocPl: "请输入默认值",
        defaultSocMax: "默认值不能多于100",
        defaultSocMin: "默认值必须是大于0的整数",
        floorSocPl: "请输入下限值",
        floorSocMax: "下限值不能多于100",
        floorSocMin: "下限值必须是大于0的整数",
        pileList: "电桩列表",
        status: "策略开关",
        statusTips: "注：刷卡策略只针对非实名在线卡生效，扫码会员关联的充电卡属于实名在线卡，不属于此项策略范围",
        time: "时段",
        name: "名称",
        namePl: "请输入名称",
        remark: "备注",
        remarkPl: "请输入备注",
        openTime: "开放时间",
        accountPl: "请输入用户注册手机号，多个手机号使用逗号隔开，未指定会员则全部会员生效",
        accountCardPl: "请输入电卡会员号，多个电卡会员号使用逗号隔开，未指定会员则全部会员生效",
        account: "指定账户",
        sys: "指定系统",
        pile: "指定电桩",
        select: "选择",
        pilePl: "请输入桩编号，多个桩编号使用逗号隔开,未指定设备则全部设备生效",
        addTime: "新增时段",
        statusPl: "请选择启用策略",
        entName: "企业名称",
        accountPkId: "账户号",
        sysName: "系统名称",
        sysId: "系统Id",
        interfaceName: "接口用户名称",
        import: "导入",
        importTmp: "指定用户导入模板",
        explain: "说明",
        explain1: "1、策略启用为开放时间的方式，即设置了时间之后只允许指定用户或全部用户在这个时间段、这个桩下才能充电",
        explain2: "2、若设置了多个时段，那么只要该会员满足任意时段，都可充电",
        example: "策略范例",
        exampleText: "示例",
        requireLicPlateNo: "充电是否必须车牌",
    },
    // 登录
    login: {
        contentTitle: "为美好生活充电",
        contentTitleSmall: "接入开放平台，互联生态一目了然",
        account: "账号登录",
        userNamePl: "请输入用户名",
        passwordPl: "请输入密码",
        passwordMax: "请输入6位以上的密码",
        userName: "用户名",
        password: "密码",
        login: "登录",
    },
    //验证码
    inputCode: {
        getCode: "获取验证码",
        phonePl: "请输入正确格式的手机号码",
        sendSuccess: "发送成功",
        send: "再次发送",
    },
    // 车牌库
    licensePlateLibrary: {
        pageTitle: "车牌库",
        userType: "用户类型",
        entName: "企业名称",
        userName: "会员名称",
        phone: "会员手机",
        carNo: "车牌号",
        vin: "VIN码",
        createTime: "创建时间",
    },
    // 平台通知
    platformNotice: {
        title: "标题",
        publishTime: "发布时间",
        read: "阅读",
    },
    // 站点功率统计
    pilePower: {
        staName: "桩群名称",
        operationTypeName: "营业类型",
        totalPileQuantity: "合计",
        totalPower: "总功率",
        totalGunQuantity: "枪数",
        staPilePower: "站点桩群",
    },
    // 结算概览
    settlementOverview: {
        dlTotal: "商户用电量汇总（度）",
        amount: "应结算金额（元）",
        settledAmount: "已结算金额（元）",
        operDivide: "运营商分成（元）",
        withdrawnAmount: "已提现金额（元）",
        undrawnamount: "未提现金额（元）",
        mchPl: "商户名称/简称",
        mchName: "商户名称",
        orderNumber: "结算订单数（笔）",
        orderDl: "结算订单电量（度）",
        settlementTime: "结算时间",
        exportName: "结算概览",
        merchantTotal: "商户总数(个)",
        numOfPercentMerchant: "百分比分成商户数(个)",
        fixedShare: "固定分成商户数(个)",
        oprTotal: "运营商分成（元）",
        settlementYear: "结算年份",
        shareType: "分成类型",
        actionQuery: "各月查看概况",
        percentage: "百分比",
        mchIfo: "商户信息",
        ruleDetails: "分成详情",
        detailsTitle: "结算概况",
        unsettled: "未结算完成",
        settled: "已结算完成",
        reportDate: "结算月份",
        settleTotalOrder: "当月结算订单数(笔)",
        settleTotalElectricity: "当月电量(度)",
        chargePayableAmount: "应付充电金额(元)",
        discountAmount: "优惠金额(元)",
        paidChargeAmount: "实付充电金额(元)",
        merchantIncomeAmount: "商户收入金额(元)",
        status: "结算完成状态",
    },
    // 商户报表
    merchantReport: {
        yearReport: "年报表",
        monthReport: "月报表",
        mchName: "商户名称",
        devNum: "设备台数",
        reportYear: "报表年份",
        totalDl: "总计电量（度）",
        totalAmount: "收入金额（元）",
        electricFee: "电费（元）",
        serviceFee: "服务费（元）",
        delayFee: "占桩费（元）",
        operDivide: "运营商分成（元）",
        reportMonth: "报表月份",
        monthDetails: "月明细",
    },
    // 账号信息
    accountInfo: {
        userName: "登录账号",
        roleName: "所属角色",
        fullName: "姓名",
        effectiveTime: "有效时间",
        loginRecord: "近七天登录记录",
        logintime: "登录时间",
        resultDesc: "操作详情",
        loginIp: "登录IP",
    },
    // 时间
    timeObj: {
        "0": "星期日",
        "1": "星期一",
        "2": "星期二",
        "3": "星期三",
        "4": "星期四",
        "5": "星期五",
        "6": "星期六",
        earlyMorning: "早上",
        morning: "上午",
        noon: "中午",
        afternoon: "下午",
        night: "晚上",
    },
    // 商城商品
    commodity: {
        superior: "上架",
        down: "下架",
        addNum: "补货",
        reduceNum: "减货",
        changeDetails: "兑换明细",
        superiorConfirm: "确定要上架商品吗?",
        downConfirm: "确定要下架商品吗?",
        numPl: "请输入数量",
        num: "数量",
        allAddNum: "批量补货",
        allReduceNum: "批量减货",
        globalSearch: "商品名称",
        productType: "商品属性",
        stockStatus: "库存状态",
        productStatus: "商品状态",
        productName: "商品名称",
        pictureUrl: "缩略图",
        price: "积分单价",
        discountRatio: "折扣比例",
        stock: "库存（件）",
        purchaseLimit: "限购数量",
        effectiveStartTime: "有效时间范围",
        redeemed: "已兑换数量",
        // 添加
        productNamePl: "请输入商品名称",
        productTypePl: "请选择商品属性",
        pricePl: "请输入积分单价",
        discountRatioPl: "请输入折扣",
        discountRatioYes: "有折扣",
        discountRatioNo: "无折扣",
        stockPl: "请输入库存",
        listed: "是否上架",
        desc: "商品描述",
        picturePl: "请上传缩略图",
        descPl: "请输入商品描述",
        exCompany: "快递公司",
        exCompanyPl: "请选择快递公司",
        exOrderNo: "快递单号",
        exOrderNoPl: "请输入快递单号",
        shipBtn: "确定发货",
        shipTitle: "快递发货",
        shipConfirm: "确定要发货吗",
        precise0: "模糊查询",
        precise1: "精确查询",
        imgTips: "注：图片大小小于5M，建议尺寸为：680 * 600",
        adjustTitle: "调整库存",
        adjustType: "调整类型",
        adjustNum: "调整数量",
    },
    //商城订单
    mallOrder: {
        globalSearch: "订单编号",
        telephone: "用户手机号",
        deliveryMethod: "兑换方式",
        orderStatus: "订单状态",
        exchangeTime: "兑换时间",
        deliveryTime: "发货时间",
        completeTime: "完成时间",
        delivery: "发货",
        orderNo: "订单编号",
        createUserName: "用户昵称",
        paymentMethod: "支付方式",
        discountPoints: "活动单价",
        quantity: "兑换数量",
        paymentPoints: "实付积分",
        totalOrder: "总订单数(笔)",
        discount: "有无折扣",
        address: "收货地址",
        contacts: "收货人",
        contactsPhone: "联系电话",
        expressOrderNo: "快递单号",
        exportName: "商城订单",
        receipt: "收货",
        receiptConfirm: "确定用户已经收到商品",
        pickUpCode: "取货码",
        pickUpCodePl: "请输入取货码",
        orderInfo: "订单信息",
        deliveryInfo: "收货信息",
        pickUpInfo: "自提信息",
        statisticsTime: "统计时间",
    },
    // 商城配置
    mallConfig: {
        tab1: "提货地址",
        tab2: "库存状态",
        tab3: "商城开关",
        disable: "停用",
        enable: "启用",
        regionName: "所属省市区/县",
        address: "自提地址",
        contacts: "联系人",
        contactsPhone: "联系电话",
        status: "地址状态",
        disableConfirm: "确定要停用该地址吗？",
        enableConfirm: "确定要启用该地址吗？",
        addressDetails: "详细地址",
        regionId: "所属地区",
        regionIdPl: "请选择地区",
        addressPl: "请输入地址",
        mallStatus: "商城当前状态",
        mallSwitch: "积分商城开关",
        open: "开",
        close: "关",
        mallStatusPl: "请选择状态",
        limitStatus: "当前库存显示状态",
        limit: "库存充足",
        limitPl: "请输入库存",
        limitStatus1: "库存充足",
        limitStatusValue1: "库存 ＞ 50",
        limitStatus2: "库存低",
        limitStatusValue2: "0 ＜ 库存 ≤ 50",
        limitStatus3: "库存不足",
        limitStatusValue3: "库存  = 0 ",
        openDeliveryAddress: "商城收货地址",
        openMallOrder: "商城订单",
        openDeliveryAddressPl: "请选择是否开启商城收货地址",
        openMallOrderPl: "请选择是否开启商城订单",
    },
    businessConsulting: {
        search: "手机号/昵称",
        consultStatus: "状态",
        consultType: "业务类型",
        updata: "标记已读",
        fullName: "用户昵称",
        contactPhone: "联系电话",
        content: "内容",
        createTime: "创建时间",
        modifyUserName: "操作人",
        upConfirm: "确定要标记已读吗？",
        exportName: "业务咨询",
    },
    //会员注销
    memberCancellation: {
        globalSearch: "会员名称/手机号",
        logoutTime: "注销时间",
    },
    // 费率明细
    releaseDetailsRate: {
        syncMode: "下发类型",
        syncStatus: "下发结果",
        userName: "操作人",
        syncTime: "下发时间",
    },
    releaseDetailsQrCode: {
        syncStatus: "下发结果",
        checkStatus: "校验结果",
        allCheck: "批量较验",
        check: "校验",
        userPkId: "下发人",
        syncTime: "下发时间",
        checkSuccess: "校验已下发，等待桩回复后即可校验成功",
    },
    // 营收分析
    analysisIncome: {
        totalIncome: "总营收分析",
        serviceIncome: "服务费营收分析",
        elecIncome: "电费营收分析",
        delayIncome: "占桩费营收分析",
        totalAmount: "应收总金额",
        totalAmount2: "应收总金额(元)",
        totalSeviceAmount: "应收服务费",
        totalElecAmount: "应收电费",
        totalDelayAmount: "应收占桩费",
        totalSumDiscount: "总优惠",
        totalSumDiscount2: "总优惠(元)",
        totalServiceDiscount: "服务费优惠",
        totalChargeDiscount: "电费优惠",
        totalDiscount: "总额",
        totalTransAmount: "实收总金额",
        totalTransAmount2: "实收总金额(元)",
        totalTransSeviceAmount: "实收服务费",
        totalTransElecAmount: "实收电费",
        totalTransDelayAmount: "实收占桩费",
        delayDiscount: "占桩费优惠",
        receivableRatio: "应收环比",
        incomeRatio: "实收环比",
        discountRatio: "优惠环比",
        receivableBasis: "应收同比",
        incomeBasis: "实收同比",
        discountBasis: "优惠同比",
        totalIncomeTitle: "总营收",
        serviceIncomeTitle: "服务费营收",
        elecIncomeTitle: "电费营收(元)",
        delayIncomeTitle: "占桩费营收(元)",
        incomeRatioTitle: "营收环比",
        incomeBasisTitle: "营收同比",
        receivableProportionTitle: "应收占比",
        incomeProportionTitle: "实收占比",
        discountProportionTitle: "优惠占比",
        seviceTimeTitle: "各时段服务费营收(元)",
        seviceReceivableProportionTitle: "服务费应收占比",
        seviceIncomeProportionTitle: "服务费实收占比",
        seviceDiscountProportionTitle: "服务费优惠占比",
        elecTimeTitle: "各时段电费营收(元)",
        elecReceivableProportionTitle: "电费应收占比",
        elecDiscountProportionTitle: "电费优惠占比",
        elecIncomeProportionTitle: "电费实收占比",
        jian: "尖时段",
        feng: "峰时段",
        ping: "平时段",
        gu: "谷时段",
        incomeTitle: "实收",
        discountTitle: "优惠",
        receivableTitle: "应收",
        incomeMoeny: "实收(元)",
        discountMoney: "优惠(元)",
        receivableMoney: "应收(元)",
        money: "金额(元)",
    },
    // 账户配置
    accountConfig: {
        titleRecharge: "充值金额限额配置",
        titleAccount: "账户限额配置",
        titleCashRecharge: "现金充值审核配置",
        hasOpenCashAuditName: "现金充值审核配置",
        configName: "配置名称",
        config: "设置",
        hasOpenCashAudit: "现金充值审核开关",
        hasOpenCashAuditAll: "是否所有充值金额都需要审核",
        hasOpenCashAuditAllPl: "请选择",
        cashAuditLeast: "最低充值审核金额",
        accountMaxTips: "账户余额最高为",
        rechargeMaxTips: "单笔充值金额最高不能超过",
        rechargeMax: "当前最多可充值",
        hasOpenRechargeAmountLimit: "充值金额限额",
        singleRechargeAmount: "单笔充值金额最高不超过",
        singleRechargeAmountName: "设置金额",
        applicationChannel: "应用渠道",
        applicationChannelPl: "请选择应用渠道",
        applicationChannelName0: "现金充值",
        applicationChannelName1: "线上充值",
        hasOpenAccountLimit: "账户限额",
        personalAccountLimit: "个人用户账户最高限额",
        entUserAccountLimit: "企业用户账户最高限额",
        accountMaxError: "当前账户余额及待审核金额总和已超过最高限额，暂无法充值",
        chargeAmountConfig: "充值金额限额配置",
        accountMaxConfig: "账户限额配置",
        cashAuditConfig: "现金充值审核配置",
    },
    // 站点排名
    siteRankingPage: {
        tabIndex: "排名",
        titleRevenue: "营收排名",
        titleCharge: "充电量排名",
        titleOrder: "充电订单量排名",
        titleDuration: "充电时长排名",
        titleRatio: "充电使用率/利用率排名",
        titleUtil: "充电利用率排名",
        titleService: "服务费营收排名",
        titleElec: "电费营收分析",
        titleDelay: "占桩费营收分析",
        titleChargeSharp: "尖时段充电量排名",
        titleChargePeak: "峰时段充电量排名",
        titleChargeFlat: "平时段充电量排名",
        titleChargeValley: "谷时段充电量排名",
        totalRevenue: "实收总金额(元)",
        totalCharge: "总充电量(kWh)",
        totalOrder: "总订单量(笔)",
        totalDuration: "充电时长",
        totalRatio: "总使用率",
        totalUtil: "总利用率",
        totalService: "实收服务费(元)",
        totalElec: "实收电费(元)",
        totalDelay: "实收占桩费(元)",
        totalChargeSharp: "尖时段总充电量(kWh)",
        totalChargePeak: "峰时段总充电量(kWh)",
        totalChargeFlat: "平时段总充电量(kWh)",
        totalChargeValley: "谷时段总充电量(kWh)",
        moreBtn: "查看更多排名",
        staName: "站点名称",
        oprName: "所属运营商",
        mchName: "所属商户",
        percentage: "占比",
        staNum: "充电站总数(个)",
    },
    //单站点分析 和单用户分析
    siteAnalysis: {
        siteInfo: "站点基本信息",
        siteAnalysis: "站点分析",
        pileNum: "充电桩数(个)",
        gunCount: "充电枪数(支)",
        totalTransAmount: "实收总金额(元)",
        totalPower: "总充电量(kWh)",
        avgCharging: "平均充电时长(分钟)",
        avgGunChargeMinutes: "单枪平均充电时长(分钟)",
        totalChargingTimes: "充电订单量(笔)",
        usageRate: "使用率",
        utilRate: "利用率",
        staName: "站点名称",
        totalAmount: "应收总金额(元)",
        totalDiscount: "总优惠(元)",
        totalChargingHours: "充电总时长",
        // totalChargingMinutes: "充电总时长",
        totalServiceAmount: "应收服务费(元)",
        totalAmountDiscount: "总额优惠(元)",
        totalTransServiceAmount: "实收服务费(元)",
        totalSharpPower: "尖时段充电量(kWh)",
        oprName: "所属运营商",
        merchantName: "所属商户",
        totalElecAmount: "应收电费(元)",
        totalServiceDiscount: "服务费优惠(元)",
        totalTransElecAmount: "实收电费(元)",
        totalPeakPower: "峰时段充电量(kWh)",
        totalDelayAmount: "应收占桩费(元)",
        totalChargeDiscount: "电费优惠(元)",
        totalTransDelayAmount: "实收占桩费(元)",
        totalFlatPower: "平时段充电量(kWh)",
        totalValleyPower: "谷时段充电量(kWh)",
        time: "统计时间",
        userName: "用户名称",
        accountPkId: "账户号",
        phoneNo: "手机号",
        totalDelayDiscount: "占桩费优惠(元)",
        totalChargingMinutes: "充电时长（分钟）",
        totalOrderTimes: "充电订单量（个）",
        totalOrderSecond: "充电次数",
        entName: "企业名称",
        merchantTypeDesc: "电卡归属",
        accountPkIdCard: "电卡会员号",
        cardPhysicalNumber: "电卡序号",
        contactName: "联系人",
        contactPhoneNo: "联系电话",
        ranking: "排名",
        userInfo: "用户基本信息",
        userUseAnalysis: "用户使用分析",
        siteInfoData: "站点信息",
        siteOprData: "站点运营",
        staPower: "总功率",
    },
    // 使用分析
    useAnalysis: {
        totalPower: "总充电量",
        totalPower2: "总充电量(kWh)",
        sharpPower: "尖时段充电量(kWh)",
        peakPower: "峰时段充电量(kWh)",
        flatPower: "平时段充电量(kWh)",
        valleyPower: "谷时段充电量(kWh)",
        totalChargingTimes: "充电订单量(个)",
        totalChargingSeconds: "充电总时长(时)",
        totalUserNum: "用户数量(个)",
        avgChargingSeconds: "单枪平均充电时长",
        chargingUseRatio: "使用率(%)",
        chargingUsageRate: "利用率(%)",
        eleAnalysis: "充电量分析",
        orderAnalysis: "充电订单量分析",
        timeAnalysis: "单枪平均充电时长",
        activeUserAnalysis: "活跃用户分析",
        userAnalysis: "用户增长分析",
        useRatioAnalysis: "充电使用率/利用率分析",
        usageRateAnalysis: "充电利用率分析",
        avgChargingRadio: "单枪平均充电时长环比",
        avgChargingBasis: "单枪平均充电时长同比",
        totalChargingTimesRadio: "充电订单量环比",
        totalChargingTimesBasis: "充电订单量同比",
        orderTypes: "各类型充电订单量(个)",
        orderTypesProportion: "各类型充电订单量占比(%)",
        personnelOrderVolume: "个人订单量",
        enterpriseOrderVolume: "企业订单量",
        noRealNameCardVolume: "非实名卡订单量",
        personnelOrderVolumeRadio: "个人环比",
        enterpriseOrderVolumeRadio: "企业环比",
        noRealNameCardVolumeRadio: "非实名卡环比",
        personnelOrderVolumeBasis: "个人同比",
        enterpriseOrderVolumeBasis: "企业同比",
        noRealNameCardVolumeBasis: "非实名卡同比",
        totalOrder: "总订单量(笔)",
        personnel: "个人用户",
        enterprise: "企业用户",
        noRealNameCard: "非实名卡用户",
        totalPowerRadio: "总充电量环比",
        totalPowerBasis: "总充电量同比",
        sharpPowerName: "尖时段",
        peakPowerName: "峰时段",
        flatPowerName: "平时段",
        valleyPowerName: "谷时段",
        sharpPowerRadio: "尖时段环比",
        peakPowerRadio: "峰时段环比",
        flatPowerRadio: "平时段环比",
        valleyPowerRadio: "谷时段环比",
        sharpPowerBasis: "尖时段同比",
        peakPowerBasis: "峰时段同比",
        flatPowerBasis: "平时段同比",
        valleyPowerBasis: "谷时段同比",
        timeCharging: "各时段充电量",
        timeChargingProportion: "各时段充电量占比",
        userNum: "使用人数",
        userNumRadio: "使用人数环比",
        userNumBasis: "使用人数同比",
        activeUserNume: "活跃人数",
        activeUserNumRadio: "活跃人数环比",
        activeUserNumBasis: "活跃人数同比",
        activeUserRadio: "人数环比",
        activeUserBasis: "人数同比",
        activeUserReqNum: "用户增长",
        activeUserReqNumRadio: "用户增长环比",
        activeUserReqNumBasis: "用户增长同比",
        money: "金额(元)",
        chargeCapacity: "充电量(kWh)",
        number: "数量(个)",
        totalCharge: "总充电电量(kWh)",
    },
    // 设备档案
    reportFile: {
        deviceArchivePkId: "档案ID",
        deviceTypeName: "设备类型",
        manufacturerName: "生产厂商",
        deviceModelName: "设备型号",
        deviceModelRatedPower: "额定功率",
        deviceModelChargeStandardName: "设备标准",
        archiveCode: "报告编号",
        feelerMechanismName: "测试机构",
        archiveCreateDate: "报告生成日期",
        attachmentRecordPkId: "型式试验报告",
        entryDate: "录入日期",
        deviceRatedPower: "功率范围(kW)",
        query: "点击查看",
    },
    // 建设分析
    constructionAnalysis: {
        totalMchNum: "商户数(个)",
        totalStaNum: "充电站数(个)",
        totalPileNum: "充电桩数(个)",
        totalGunNum: "充电枪数(个)",
        totalPower: "总功率(kW)",
        totalDcPileNum: "直流桩数",
        totalDcGunNum: "直流枪数",
        totalDcPower: "直流桩功率",
        totalAcPileNum: "交流桩数",
        totalAcGunNum: "交流枪数",
        totalAcPower: "交流桩功率",
        stationAnalysis: "充电站建设分析",
        pileAnalysis: "充电桩建设分析",
        gunAnalysis: "充电枪建设分析",
        powerAnalysis: "功率建设分析",
        station: "原有充电站",
        addStation: "新增充电站",
        staMomRatio: "充电站新增环比",
        staYoyRatio: "充电站新增同比",
        addMomRatio: "新增环比",
        addYoyRatio: "新增同比",
        totalMultipleDCPileNum: "分体直流桩",
        totalMultipleDCGunNum: "分体直流枪",
        totalMultipleDCPower: "分体桩功率",
        pile: {
            dcTitle: "直流桩建设分析",
            dcMomRatio: "直流桩新增环比",
            dcYoyRatio: "直流桩新增同比",
            dcLineAddName: "新增直流桩",
            dcLineName: "原有直流桩",
            acTitle: "交流桩建设分析",
            acMomRatio: "交流桩新增环比",
            acYoyRatio: "交流桩新增同比",
            acLineAddName: "新增交流桩",
            acLineName: "原有交流桩",
        },
        gun: {
            dcTitle: "直流枪建设分析",
            dcMomRatio: "直流枪新增环比",
            dcYoyRatio: "直流枪新增同比",
            dcLineAddName: "新增直流枪",
            dcLineName: "原有直流枪",
            acTitle: "交流枪建设分析",
            acMomRatio: "交流枪新增环比",
            acYoyRatio: "交流枪新增同比",
            acLineAddName: "新增交流枪",
            acLineName: "原有交流枪",
        },
        power: {
            dcTitle: "直流功率建设分析",
            dcMomRatio: "直流功率新增环比",
            dcYoyRatio: "直流功率新增同比",
            dcLineAddName: "新增直流功率",
            dcLineName: "原有直流功率",
            acTitle: "交流功率建设分析",
            acMomRatio: "交流功率新增环比",
            acYoyRatio: "交流功率新增同比",
            acLineAddName: "新增交流功率",
            acLineName: "原有交流功率",
        },
    },
    //建设排名
    constructionRanking: {
        tabIndex: "排名",
        pileTab: "充电桩建设排名",
        gunTab: "充电枪建设排名",
        powerTab: "额定功率排名",
        pileNum: "充电桩总数(个)",
        gunNum: "充电枪总数(个)",
        powerNum: "额定功率(kW)",
        totalStaNum: "充电站总数(个)",
        totalPileNum: "充电桩总数(个)",
        totalAcPileNum: "交流桩总数(个)",
        totalDcPileNum: "直流桩总数(个)",
        totalGunNum: "充电枪总数(支)",
        totalAcGunNum: "交流枪总数(个)",
        totalDcGunNum: "直流枪总数(个)",
        totalPower: "总额定功率(kW)",
    },
    // 非实名卡分析
    offcardAnalysis: {
        tab0: "总营收",
        tab1: "刷卡充电",
        tab2: "即插即充",
        tab3: "密码充电",
        chargeNum: "充电次数",
        totalCardNum: "离线卡数量（张）",
        totalChargeElect: "总充电量(kWh)",
        totalChargeTime: "总充电时长",
        totalChargeNum: "总充电次数",
        avgChargeElect: "平均充电量(kWh)",
        avgChargeTime: "平均充电时长",
        avgChargeNum: "平均充电次数",
        offlineCharging: "离线充电量(kWh)",
        userTypeDl: "各用户类型充电量占比(%)",
        timeType: "各时段充电量(kWh)",
        cardCharge: "刷卡充电",
        plugCharge: "即插即充",
        passwordCharge: "密码充电",
        cardChargeRation: "刷卡充电环比",
        plugChargeRation: "即插即充环比",
        passwordChargeRation: "密码充电环比",
        cardChargeBasis: "刷卡充电同比",
        plugChargeBasis: "即插即充同比",
        passwordChargeBasis: "密码充电同比",
        userTypeTime: "各用户类型充电时长占比(%)",
        chargeNumRation: "充电次数环比",
        chargeNumBasis: "充电次数同比",
        userTypeChargeNum: "各用户类型充电次数占比(%)",
        totalTransAmount: "总金额",
        totalTransSeviceAmount: "服务费",
        totalTransElecAmount: "电费",
        timeUserChargeProportion: "各时段充电量占比",
    },
    // 用户分析
    userUseAnalysis: {
        totalPower: "总充电量",
        totalOrderNum: "总充电订单量(笔)",
        totalChargingSeconds: "总充电时长",
        totalChargingNum: "总充电次数",
        activeNum: "活跃人数",
        avgPower: "平均充电量(kWh)",
        avgOrderNum: "平均充电订单量(笔)",
        avgChargingSeconds: "平均充电时长",
        avgChargingNum: "平均充电次数",
        useNum: "使用人数",
        userNum: "总用户数(个)",
        personnel: "个人用户",
        enterprise: "企业用户",
        noRealNameCard: "非实名卡用户",
        personnelRadio: "个人用户环比",
        enterpriseRadio: "企业用户环比",
        noRealNameCardRadio: "非实名卡用户环比",
        personnelBasis: "个人用户同比",
        enterpriseBasis: "企业用户同比",
        noRealNameCardBasis: "非实名卡用户同比",
        totalUserCharge: "用户总充电量(kWh)",
        totalTypeUserCharge: "各用户类型充电量占比(%)",
        timeUserCharge: "各时段充电量(kWh)",
        timeUserChargeProportion: "各时段充电量占比",
        totalAverageTime: "总平均充电时长",
        typeChargeDuration: "各用户类型充电时长占比(%)",
        chargeNumber: "充电次数",
        chargeNumberRadio: "充电次数环比",
        chargeNumberBasis: "充电次数同比",
        typeChargeDurationNumber: "各用户类型充电次数占比(%)",
        activeUsers: "活跃用户数",
        activeUsersRadio: "活跃用户数环比",
        activeUsersBasis: "活跃用户数同比",
        typeChargeactiveUsers: "各用户类型活跃数占比(%)",
        useNumber: "使用人数",
        useNumberRadio: "使用人数数环比",
        useNumberBasis: "使用人数数同比",
        typeChargeUseNumber: "各用户类型使用人数占比(%)",
        avgChargingRadio: "平均充电时长环比",
        avgChargingBasis: "平均充电时长同比",
        userNumber: "个数(人)",
    },
    // 用户分析 - 用户排名
    userAnalysisRanking: {
        userType: "用户类型",
        incomeType: "排名类型",
        more: "查看更多排名",
        userAccount: "个人账户",
        entAccount: "企业账户",
        cardAccount: "非实名卡用户账户",
        totalAmount: "总营收",
        serverAmount: "服务费营收",
        eleAmount: "电费营收",
        delayAmount: "占桩费营收",
        chargeQuantity: "充电量",
        chargeTimes: "充电次数",
        chargeDuration: "充电时长",
        userNum: "总用户数",
        typeUserNum1: "个人用户数",
        typeUserNum2: "企业用户数",
        typeUserNum3: "非实名卡用户数",
        pageTitleUserType1: "个人用户排名",
        pageTitleUserType2: "企业用户排名",
        pageTitleUserType3: "非实名卡用户排名",
        index: "排名",
        userName: "用户名称",
        phoneNo: "手机号",
        enterpriseName: "企业名称",
        cardPhysicalNumber: "电卡会员号",
        cardSerialNumber: "电卡序号",
        merchantType: "卡片归属",
        contactName: "联系人",
        contactPhoneNo: "联系电话",
        amount1: {
            totalAmount: "应收总金额（元）",
            discountAmount: "总优惠（元）",
            actualAmount: "实收总金额（元）",
        },
        amount2: {
            totalAmount: "应收服务费（元）",
            discountAmount: "服务费优惠（元）",
            actualAmount: "实收服务费（元）",
        },
        amount3: {
            totalAmount: "应收电费（元）",
            discountAmount: "电费优惠（元）",
            actualAmount: "实收电费（元）",
        },
        amount4: {
            totalAmount: "应收占桩费（元）",
            discountAmount: "占桩费优惠（元）",
            actualAmount: "实收占桩费（元）",
        },
        dataValue5: "充电量（kWh）",
        dataValue6: "充电次数（次）",
        dataValue7: "充电时长（时）",
    },
    // 有序充电
    qrderlyCharging: {
        powerStrategy: "功率均分策略",
        firstServedStrategy: "先到先充策略",
        bindSta: "关联站点",
        qrderlyInfo: "策略信息",
        tipsTitle: "策略说明：",
        tipsList: [
            "1、只有当充电站输出总功率大于配置功率时，才会触发功率均分策略",
            "2、该站点当前的输出功率高于所设置的最大输出功率，系统将自动计算出超出部分的百分比，每条正在启动的充电枪都将被降低当前功率的超出百分比数。",
            "3、触发功率均分策略之后，遇到充电完成、新启动充电及5分钟定时任务，检测输出功率高于或低于配置值。",
            "4、策略启动后，才判断输出功率是否低于配置值。若该站点当前的输出功率低于所设置的最大输出功率，系统将自动计算出低于部分的百分比，每条正在启动的充电枪都将被上调当前功率的低于百分比数。",
            "5、若遇到当前功率加上升高功率大于该桩的额定功率，则该桩将不参与此次功率上调。",
            "6、超出百分比=超出功率/所配置的最高额定功率。例如：站点额定功率为100Kw，配置百分比为90%，则站点所配置的最高输出功率功率为100*90%=90Kw。若当前站点功率为120Kw，则超出百分比=（120-90）/90=33.34%，进位保留两位小数。",
            "7、低于百分比=低于功率/所配置的最高额定功率。例如：站点额定功率为100Kw，配置百分比为90%，则站点所配置的最高输出功率为100*90%=90Kw。若当前站点功率为80Kw，则低于百分比=（90-80）/90=11.12%，进位保留两位小数。",
        ],
        accurateTipsList: [
            "1、只有当充电站输出总功率大于配置功率时，才会触发功率均分策略。",
            "2、该站点当前的输出功率，高于所设置的最大输出功率，系统将自动计算出超出部分的百分比，并首先降低所有正在充电的交流枪输出功率，降低值为当前功率的超出百分比数。",
            "3、再降低soc ≥ 80%和soc ＜ 80% 的直流桩的输出功率。",
            "4、若（soc≥80%）＞（soc＜80%），soc≥80%的直流桩降低剩余需降功率的2/3，soc＜80%的直流桩降低剩余需降功率的1/3。",
            "5、若（soc≥80%）=（soc＜80%），soc≥80%的直流桩降低剩余需降功率的1/2，soc＜80%的直流桩降低剩余需降功率的1/2。",
            "6、若（soc≥80%）＜（soc＜80%），soc≥80%的直流桩降低剩余需降功率的1/3，soc＜80%的直流桩降低剩余需降功率的2/3。",
            "7、触发功率均分策略之后，遇到充电完成、新启动充电及5分钟定时任务，检测输出功率高于或低于配置值。",
            "8、策略启动后，才判断输出功率是否低于配置值。若该站点当前的输出功率低于所设置的最大输出功率，系统将自动计算出低于部分的百分比，每条正在启动的充电枪都将被上调当前功率的低于百分比数。",
            "9、若遇到当前功率加上升高功率大于该桩的额定功率，则该桩将不参与此次功率上调。",
            "10、超出百分比=超出功率/所配置的最高额定功率。例如：站点额定功率为100Kw，配置百分比为90%，则站点所配置的最高输出功率功率为100*90%=90Kw。若当前站点功率为120Kw，则超出百分比=（120-90）/90=33.34%，进位保留两位小数。",
            "11、低于百分比=低于功率/所配置的最高额定功率。例如：站点额定功率为100Kw，配置百分比为90%，则站点所配置的最高输出功率为100*90%=90Kw。若当前站点功率为80Kw，则低于百分比=（90-80）/90=11.12%，进位保留两位小数。",
        ],
        firstComeTipsList: [
            "1.有当充电站输出总功率大于配置功率时，才会触发先到先充策略。",
            "2.在执行先到先充策略时，将站内的直流桩、交流桩进行划分，根据设备类型，按充电开始时间分别进行时间排序。",
            "3.默认将正在充电的桩数（≥3）按三等分进行时间排序，若无法进行三等分则根据剩余桩数，从后往前依次加1。",
            "4.系统计算出每个时序需要分得的充电桩数后，按照充电开始时间正序进行排序，分别计入各个时序中。第一时序为开始最早，充电时间最长的桩。第二时序次之，第三时序为开始最晚，充电时间最短的桩。",
            "5.若出现充电开始时间相同的桩（以秒为最小计时单位），且无法分配至用一个时序中，则按照站内编号的正序顺序向后顺延。",
            "6.时间排序完成后，分别按照第一时序的桩降至当前输出功率的75%，第二时序的桩降至当前输出功率的50%，第三时序的桩降至当前输出功率的25%，分别执行先到先充策略。",
            "7.触发先到先充策略之后，遇到充电完成、新启动充电及5分钟定时任务，检测输出功率高于或低于配置值。",
            "8.策略启动后，才判断输出功率是否低于配置值。若低于配置值，则需要计算出当前功率低于所配置的最大输出功率的百分比数，并将所有正在充电的充电桩按照该比例升高输出功率，若存在升高的功率超过桩本身的额定功率的桩则不执行此次的升功率策略。",
            "9.例如：站点额定功率为100Kw，配置百分比为90%，则站点所配置的最高输出功率为100*90%=90Kw。若当前站点功率为80Kw，则低于百分比=（90-80）/90=11.12%，进位保留两位小数。",
            "10.在所有正在充电的充电桩升高当前输出功率的低于百分比数（例子中计算出为11.12%）的功率，若存在升高的功率超过桩本身的额定功率的桩则不执行此次的升功率策略。",
        ],
        strategyName: "策略名称",
        strategyType: "策略类型",
        strategyValue: "站点最大输出功率不高于额定功率",
        modifyTime: "操作时间",
        modifyUserName: "操作人",
        countUse: "使用站点数量",
        delConfirm: "确认是否删除该充电策略删除后无法恢复",
        strategyNamePl: "请输入策略名称",
        strategyTypePl: "请选择策略",
        strategyValuePl: "请输入百分比",
        strategyValuePl2: "百分比",
        strategyValueTips: "备注：所设置百分比为站点额定功率的百分比。",
        useSta: "使用范围",
        staAddStrategy: "新增/更换有序充电策略",
        staUnbindStrategy: "解绑",
        staUnbindStrategyConfirm: "确认解绑此策略",
        strategyTypeChangeTips: "提醒：提交后立即生效，站点将按照新的有序充电策略执行。",
        strategyTypeChangeTitle: "更换策略",
        staMaxOutputPower: "最大输出功率数",
        staGroupStatus: "分组状态",
        configBtn: "配置策略分组",
        open: "开启",
        close: "关闭",
    },
    // 有序充电策略分组
    chargingStrategyGroups: {
        add: "新增分组",
        sitePower: "站点额定功率",
        maxPower: "序充电限额为",
        siteMaxPowerd: "站点允许最大输出功率为",
        totalPower: "分组总额定功率为",
        configPower: "剩余可配置功率为",
        configPile: "剩余可配置桩数为",
        groupName: "分组名称",
        groupTotalPower: "分组额定功率（KW）",
        limitRatioTable: "组内最大输出功率不高于分组额定功率百分比数（%）",
        limitRatio: "限额比率",
        groupMaxOutputPower: "分组最大输出功率（KW）",
        groupPileNum: "关联桩数",
        groupStatus: "分组状态",
        modifyTime: "操作时间",
        modifyUserName: "操作人",
        pilePkIdList: "关联桩",
        pilePkIdListTips: "已配置功率",
        pilePkIdListError: "已超出可配置功率，请检查",
        pilePkIdListPl: "请选择桩",
        addTitle: "新增分组策略",
        updataTitle: "修改分组策略",
        detailsTitle: "分组策略详情",
        selectPilePl: "请输入桩名称/编号/类型(交直流)",
        selectNo: "未选择的桩",
        selectYes: "已选择的桩",
    },
    reservationRate: {
        freeMinutes: "免费时长",
        minute: "分钟",
        minuteUnit: "费率(每分钟/元)",
        semih: "半小时",
        semihUnit: "半小时/元",
        slotFlag: "时段类型",
        timingType: "收费类型",
        acRate: "交流桩预约占位费率",
        dcRate: "直流桩预约占位费率",
        replaceTime: "关联时间",
        operatorName: "操作人",
        allCancle: "批量取消关联",
        cancleTip: "确定取消关联吗?",
        cancleAllTip: "确定批量取消关联所选站点吗?",
    },
    // 预约充电配置
    appointmentChargeConfig: {
        tabReservation: "预约充电",
        tabOrderly: "有序充电配置",
        enable: "预约充电",
        maxDuration: "可预约最长时间",
        minDuration: "最小可预约时长",
        maxDurationPl: "请选择可预约最长时间",
        minDurationPl: "请选择最小可预约时长",
        timeoutDuration: "可容忍超时时长",
        enableTips1: "关闭后，所有站点不支持预约充电",
        enableTips2: "开启后，仅配置了预约占位费率的站点支持预约充电",
        maxDurationTips: "用户单次可预约充电的最长时间",
        minDurationTips: "用户单次可预约充电的最短时间",
        timeoutDurationTips1: "用户预约结束时间与开始充电时间运营商可容忍的超时时间长，",
        timeoutDurationTips2: "设置后仅对后续订单生效，已生成订单不生效； 默认为0，",
        timeoutDurationTips3: "即当前时间为用户预约结束时间时，立即以预约超时处理；",
        openSta: "已开通站点",
        reservationName: "预约占位费率名称",
    },
    // 预约订单
    reserveChargingOrder: {
        durationRange: "预约时长",
        stopReason: "结束原因",
        startTime: "预约开始时间",
        handle: "申诉处理",
        reservationOrderNo: "预约单号",
        chargingTime: "预约充电时间",
        frozenAmount: "冻结金额(元)",
        stopTime: "预约结束时间",
        actualDuration: "实际预约时长",
        transactionAmount: "实付金额(元)",
        reasonType: "申诉原因",
        picture: "现场照片",
        auditResult: "处理结果",
        auditMind: "处理意见",
        reasonTitle: "预约单申诉处理",
        auditMindPl: "请输入处理意见",
        auditResultPl: "请选择处理结果",
        totalOrder: "预约单总数（笔）",
        confirm: "同意用户申诉后，充电预约冻结金额或已付金额将全额返还至用户账户，是否继续？",
        reserveOrderStatus: "预约单状态",
        reserveOrderTimeType: "各时长预约单数(笔)",
    },
    // 预约订单详情
    reserveChargingOrderOrder: {
        info: "预约订单信息",
        timingType1: "分钟",
        timingType2: "半小时",
        timingType: "收费类型",
        freeMinutes: "免费时长(分钟)",
        timeoutDuration: "运营商可容忍超时时长(分钟)",
        total: "费用(元)：",
        rate: "费率",
        slotFlag: "时段类型",
        time: "时间段",
        duration: "时长(分钟)",
        feeInfo: "计费信息",
        orderInfo: "订单信息",
        orderStatus: "订单状态",
        chargingOrderNo: "充电订单号",
        life: "生命周期",
        operatingUserName: "操作人",
        occurTime: "操作时间",
        stopReason: "原因",
        imgList: "辅助材料",
        refOrderNo: "退款订单号",
    },
    // 运营商日结单
    operatorDailyStatement: {
        tab1: "日结单",
        tab2: "日结单明细",
        tab3: "日结单分成明细",
        settleOrderNo: "日结订单号",
        settlementOrderStatus: "日结单状态",
        shareOrderStatus: "分成状态",
        settlementDate: "结算日期",
        createTime: "创建日期",
        totalOrderCount: "订单笔数",
        totalChargeElect: "充电量",
        totalTransactionAmount: "实付总金额",
        totalTransactionServiceAmount: "实付服务费",
        totalTransactionChargeAmount: "实付电费",
        totalServiceProviderIncome: "总分成金额",
        totalOprIncome: "运营商收入",
        merchantPkId: "分成方名称",
        settlementRule: "分成方式",
        totalMerchantIncome: "商户收入金额",
    },
    // 运营商分成单
    operatorSplitOrder: {
        tab1: "分成单",
        tab2: "分成单明细",
        tab3: "分成订单明细",
        currentServiceProviderIncome: "本期实际分成金额",
        currentRecordedAmount: "本期记账金额",
        accumulatedRecordedAmount: "累计记账金额",
        shareOrderStatus: "分成状态",
        serviceProviderIncome: "分成方总分成",
        chargeOrderNo: "充电订单号",
        outOrderNo: "分成单号",
        outOrderNoDetailId: "分成详情单号",
        rechargeOrderNo: "充值单号",
        transactionId: "微信支付单号",
        failReason: "分成失败原因",
        finishTime: "分成完成时间",
        detailServiceProviderIncome: "分成方分成金额",
    },
    // 记帐金额管理
    bookkeepingAmount: {
        tab1: "记帐管理",
        tab2: "记帐明细",
        btnName: "冲正",
        positiveStatus: "冲正状态",
        selectPositivePl: "请选择要冲正的数据",
        selectPositiveConfirm: "确认冲正",
        clearPositive: "取消冲正",
        positiveYes: "已冲正",
        positiveNo: "未冲正",
        settlementDate: "记账日期",
        positiveTime: "冲正日期",
        recordedAmount: "记账金额",
        operator: "操作人",
        attachmentPkId: "附件",
        positiveMoney: "冲正金额",
        paymentNetFileUrl: "上传附件",
        paymentNetFileUrlPl: "请上传附件",
        operatorPl: "请输入操作人",
    },
    // 运营商注册
    oprRegister: {
        oprRegisterTitle: "运营商注册",
        clearGoBack: "取消并返回",
        roleName: "高级运营商",
    },
    // 忘记密码
    forgetPassword: {
        title: "忘记密码",
        tips: "只有主账号才可找回密码，子账号找回密码请使用主账号用户管理功能重置密码",
        step1: "验证",
        step2: "重置成功",
        resetBtn: "重置",
        goLogin: "去登录",
    },
    // 到期提醒配置
    expirationReminder: {
        enable: "到期提醒",
        days: "提醒时间",
        daysPrepend: "到期前",
        daysAppend: "天提醒",
        addRow: "添加提醒",
        customerType1: "企业用户",
        customerType2: "代营商户",
        customerType3: "互联互通客户",
        customerType4: "第三方客户",
        customerType5: "接口客户",
        errorTips: "有重复提醒，请检查！",
        enablePl: "请选择要开启的配置",
    },
    //  余额提醒
    balanceReminderConfig: {
        tabEnt: "企业及第三方用户",
        tabUser: "个人用户",
        tabCarUser: "非实名卡用户",
        entName: "企业用户",
        thirdPartyName: "第三方用户",
        templateName: "策略名称",
        triggerValue: "提醒金额",
        alarmTimes1: "提醒时间一",
        alarmTimes2: "提醒时间二",
        alarmTimes3: "提醒时间三",
        notice: "通知方式",
        entUserSum: "企业用户关联数",
        thirdUserSum: "第三方用户关联数",
        weChat: "公众号",
        message: "短信",
        modifyRecord: "修改记录",
        configInfo: "配置信息",
        amountMin: "用户充电中，余额低于",
        amountInfo: "元后，每日定时发送通知。",
        notificationMethod: "通知方式",
        weChatNotification: "公众号通知",
        smsNotification: "短信通知",
        alarmTimesTips: "至少选择一个提醒时间",
        allSelect: "批量选择",
        allCancel: "批量取消",
        cancel: "取消关联",
        phoneTips: "请输入手机号，多个用“，”隔开",
        messageUser: "短信通知人员",
        weChatUser: "公众号通知人员",
        cancelConfirm: "确定批量取消关联吗？",
        noDataTips: "请选择数据",
        weChatTips: "请输入公众号通知人员手机号码",
        phoneError: "手机号码错误，请检查",
        messageTips: "请输入短信通知人员手机号码",
        updataTime: "修改时间",
        updataUser: "修改人",
        deleteTip: "当前策略有关联用户，暂无法删除",
        canDeleteTip: "确认删除该余额提醒策略吗？",
    },
    // 电池检测
    batteryTest: {
        orderNo: "充电订单号",
        acquired: "用户状态",
        userName: "用户名称",
        userPhone: "用户手机号",
        detailsBtn: "报告详情",
        acquiredStatus: "用户状态",
        carBatteryInfo: "车辆及充电信息",
        carInfo: "车辆信息",
        chargeInfo: "充电信息",
        carNo: "车牌号",
        libMaf: "电池厂商",
        brand: "车辆品牌",
        libType: "电池类型",
        model: "车辆型号",
        libBday: "电池生产日期",
        stdQ: "整车额定容量",
        stdV: "整车额定总电压",
        chaE: "本次充电量",
        startTime: "充电开始时间",
        chaTime: "本次充电时长",
        endTime: "充电结束时间",
        dsoc: "SOC增长",
        carbon: "本次节省碳排放量",
        batteryAnalysis: "电池健康分析",
        socSta: "SOC状态",
        trateMax: "最大温升速率",
        cellVSta: "单体电压状态",
        tempAve: "平均充电温度",
        tsta: "温度状态",
        socStart: "本次开始SOC",
        rsta: "绝缘状态",
        socEnd: "本次结束SOC",
        conSta: "动力链接状态",
        powerAve: "平均功率",
        healthScore: "综合健康评分",
        score: "分",
    },
    //运营概览
    operationalOverview: {
        incomeTotal: "总收入统计(元)",
        incomeTotalTips: "统计支付时间",
        totalChargeTransAmount: "充电实收金额(元)",
        totalReserveAmount: "预约金额(元)",
        totalMemberAmount: "会员购买金额(元)",
        orderTotal: "充电订单统计",
        orderTotalTips: "统计开始充电时间",
        totalOrder: "总订单量(笔)",
        totalChargingOrder: "充电中单量",
        totalFinishedChargingOrder: "充电完成单量",
        totalAbnormalOrder: "异常单量",
        totalPaidOrder: "已支付单量",
        totalUnPaidOrder: "未支付单量",
        totalReadyOrder: "准备充电单量",
        rateTotal: "费率统计",
        totalFee: "总费率数(个)",
        totalNormalFee: "站点费率数",
        totalEntFee: "企业费率数",
        totalInterFlowFee: "互联互通费率数",
        activityTitle: "营销活动",
        totalActive: "活动期数量(个)",
        totalNoActive: "未开始活动(个)",
        totalClosed: "已结束活动(个)",
        totalDisAble: "已停用活动(个)",
        totalRechargeGift: "充值赠送数",
        totalRegisterGift: "注册赠送数",
        totalChargeGift: "充电赠送数",
        totalPriceDiscount: "活动调价数",
        totalInvitationGift: "邀请赠送数",
        mallTitle: "商城管理",
        mallCommodity: "商品统计",
        mallOrder: "商城订单统计",
        mallCommodityTotal: "商品总数(个)",
        mallOrderTotal: "总订单数(个)",
        totalFullStockCommodity: "库存充足商品",
        totalLowStockCommodity: "库存低商品",
        totalOutOfStockCommodity: "库存不足商品",
        totalConsignmentOrder: "待发货订单数",
        totalToBeReceivedOrder: "待收货订单数",
        totalCompletedOrder: "已完成订单数",
        integralTitle: "积分活动",
        totalAll: "充电活动总数(个)",
        integralTotalActive: "活动中数量",
        integralTotalNoActive: "未开始数量",
        integralTotalClosed: "已结束数量",
        msgTitle: "消息中心",
        totalMessage: "总会员消息数",
        totalNoReplyMessage: "未回复消息数",
        totalReplyMessage: "已回复消息数",
    },
    // 地锁
    floorLock: {
        floorLockNumber: "地锁编号",
        lockStatus: "升降状态",
        floorLockOnLine: "在线状态",
        serialNumber: "所属桩编号",
        carDetected: "是否有车辆驶入",
        parkNo: "车位号",
        deviceType: "地锁类型",
        floorLockProtocol: "协议",
        remark: "备注",
    },
    // 商户概览
    mchOverview: {
        revenueTitle: "使用数据",
        settlementInfo: "结算信息",
        unsettledOrderNum: "未结算日结单数(笔)",
        notPaidDrawCashOrderNum: "未付款提现单数(笔)",
        undrawAmount: "未提现金额(元)",
        inPayAmount: "正在提现金额(元)",
        drawedAmount: "已提现金额(元)",
        serviceCharges: "累计提现手续费(元)",
        tosettledOrderNum: "待结算日结单数(笔)",
        totalChargingCapacity: "充电电量总计(kWh)",
        onlineChargingCapacity: "在线充电量(kWh)",
        offlineChargingCapacity: "离线充电量(kWh)",
        dividedInformation: "分成信息",
        mchActualIncome: "商户实际收入金额",
        operatorActualIncome: "运营商实际收入金额",
        handingFeeAmount: "手续费金额",
        amountChangeData: "非实名卡金额变化数据",
        refundOrderNumber: "待审核退款单数",
        rechargeAmount: "充值金额(元)",
        refundAmount: "退款金额(元)",
        invoiceInformation: "发票信息",
        operatorNotInvoiced: "运营商未开票数",
        operatorInvoiced: "运营商已开票数",
        pendingReview: "待审核",
        aggreed: "已同意",
        rejected: "已拒绝",
        invoiceFailed: "开票失败",
        invoicing: "开票中",
        shareOfTotalCharging: "占总充电量",
        notInvoicing: "未开票",
        mchNotInvoiced: "商户未开票数",
        mchInvoiced: "商户已开票数",
    },
    //站点管理-资产概览
    staAssetOverview: {
        staTitle: "充电站建设总数",
        pileProportion: "占总桩数",
        gunProportion: "占总枪数",
        staProportion: "占总数",
        usingNum: "正在使用",
        repairNum: "维修中",
        constructionNum: "建设中",
        closeNum: "关闭下线",
        msgTitle: "短信统计",
        residualNum: "短信剩余条数",
        useNum: "短信累计使用条数",
        pileTitle: "充电桩建设总数",
        acNum: "交流桩数",
        dcNum: "直流桩数",
        onlineNum: "上线",
        pileCloseNum: "下线",
        powerTitle: "建设总功率",
        powerProportion: "占总功率",
        powerDc: "直流桩功率",
        powerAc: "交流桩功率",
        simStatistics: "SIM统计",
        totalSim: "SIM卡总数",
        simType1: "待激活",
        simType2: "已激活",
        simType3: "停机",
        simType4: "可测试",
        simType5: "库存",
        simType6: "预销户",
        simType7: "未知",
        gunTitle: "充电枪总数",
        pileOnlineTitle: "充电桩上线情况",
        dcGun: "直流枪数",
        acGun: "交流枪数",
        splitDcPile: "分体式直流桩数",
        splitDcGun: "分体式直流枪数",
        splitDcPower: "分体式直流桩功率",
        goLiveNum: "上线电桩数",
        downLiveNum: "下线电桩数",
    },
    //
    startupFailOrder: {
        staOperationTypeDesc: "营业类型",
        staOperationMethodDesc: "营业方式",
        startModeDesc: "启动方式",
        username: "用户名",
        phoneNo: "手机号",
        chargeBeginTime: "启动时间",
        stopReasonDesc: "失败原因",
        queryStr: "订单号/手机号",
        selectTime: "选择启动时间",
        startupFailOrder: "启动失败订单",
    },
    // 短信管理
    msgManage: {
        msgSendRecord: "短信发送记录",
        msgBuyRecord: "短信购买记录",
    },
    //运维概览
    operationOverview: {
        equipmentStatistics: "设备统计",
        totalStation: "充电桩总数(台)",
        totalGunNum: "充电枪总数",
        totalGun: "枪总数(支)",
        eventStatistics: "事件统计",
        alarmStatistics: "告警统计",
        todayEventNum: "今日事件数",
        recoveryStatus: "恢复状态",
        emergent: "紧急",
        important: "重要",
        secondary: "次要",
        commonAlarm: "一般告警",
        emergentAlarm: "紧急告警",
        seriousAlarm: "严重告警",
        todayAlarmNum: "今日告警数",
        allAlarmNum: "告警总数",
        alarmStrategy: "告警策略",
        strategyNum: "策略总数",
        staAlarmRank: "站點告警次數TOP10",
        unRecovered: "未恢复",
        recovered: "已恢复",
        eventAmount: "事件总数",
        alarmLevel: "告警级别",
    },
};
